// src/AppCandidates.tsx
import { useEffect as useEffect6 } from "react";
import { Navigate as Navigate10, Route as Route23, Routes as Routes18, useNavigate as useNavigate18 } from "react-router-dom";
import { ErrorContainer as ErrorContainer4, Loading, Suspense as Suspense9 } from "shared-ui";
import {
  AuthGuard,
  AuthProvider as AuthProvider3,
  Tenant as Tenant3,
  useOIDC as useOIDC8,
  DebuggerConfig as DebuggerConfig2,
  setAppContext
} from "app-core";

// src/components/account/CandidateShellHeader.tsx
import { Fragment } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Menu, Transition } from "@headlessui/react";
import { EdMenuLink } from "shared-ui";
import { Fragment as Fragment2, jsx, jsxs } from "react/jsx-runtime";
var CandidateShellHeader = ({ userNavigation }) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-1 justify-between px-4 sm:px-6", children: [
    /* @__PURE__ */ jsx("div", { className: "flex flex-1", children: /* @__PURE__ */ jsxs("form", { className: "flex w-full md:ml-0", action: "#", method: "GET", children: [
      /* @__PURE__ */ jsx("label", { htmlFor: "search-field", className: "sr-only", children: "Search all files" }),
      /* @__PURE__ */ jsxs("div", { className: "relative w-full text-gray-600 focus-within:text-gray-600", children: [
        /* @__PURE__ */ jsx("div", { className: "pointer-events-none absolute inset-y-0 left-0 flex items-center", children: /* @__PURE__ */ jsx(
          MagnifyingGlassIcon,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        ) }),
        /* @__PURE__ */ jsx(
          "input",
          {
            name: "search-field",
            id: "search-field",
            className: "h-full w-full border-transparent py-2 pl-8 pr-3 text-base text-gray-900 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0",
            placeholder: "Search",
            type: "search"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: "ml-2 flex items-center space-x-4 sm:ml-6 sm:space-x-6", children: [
      /* @__PURE__ */ jsx(Menu, { as: "div", className: "relative flex-shrink-0", children: ({ open }) => /* @__PURE__ */ jsxs(Fragment2, { children: [
        /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(Menu.Button, { className: "focus:ring-info-500 flex rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-offset-2", children: [
          /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Open user menu" }),
          /* @__PURE__ */ jsx(
            "img",
            {
              className: "h-8 w-8 rounded-full",
              src: "https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80",
              alt: ""
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx(
          Transition,
          {
            show: open,
            as: Fragment,
            enter: "transition ease-out duration-100",
            enterFrom: "transform opacity-0 scale-95",
            enterTo: "transform opacity-100 scale-100",
            leave: "transition ease-in duration-75",
            leaveFrom: "transform opacity-100 scale-100",
            leaveTo: "transform opacity-0 scale-95",
            children: /* @__PURE__ */ jsx(
              Menu.Items,
              {
                static: true,
                className: "absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                children: userNavigation.map((item) => /* @__PURE__ */ jsx(Menu.Item, { children: ({ active }) => /* @__PURE__ */ jsx(
                  EdMenuLink,
                  {
                    to: item.to,
                    name: item.name
                  },
                  item.name
                ) }, item.name))
              }
            )
          }
        )
      ] }) }),
      /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          className: "bg-info-600 hover:bg-info-700 focus:ring-info-500 flex items-center justify-center rounded-full p-1 text-white focus:outline-none focus:ring-2 focus:ring-offset-2",
          children: [
            /* @__PURE__ */ jsx(PlusIcon, { className: "h-6 w-6", "aria-hidden": "true" }),
            /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Add file" })
          ]
        }
      )
    ] })
  ] });
};

// src/components/error/ErrorPage.tsx
import { useRouteError } from "react-router-dom";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var ErrorPage = (props) => {
  const error = useRouteError();
  return /* @__PURE__ */ jsxs2("div", { className: "m-8", children: [
    /* @__PURE__ */ jsx2("div", { className: "py-4", children: /* @__PURE__ */ jsx2("p", { children: "An error has occurred" }) }),
    /* @__PURE__ */ jsx2("div", { className: "border bg-yellow-50", children: /* @__PURE__ */ jsx2("pre", { children: JSON.stringify(error) }) })
  ] });
};

// src/components/navigation/SectionNavigation.tsx
import { NavLink } from "react-router-dom";
import { classNames } from "shared-ui";
import { Fragment as Fragment3, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var SectionNavigation = ({ actions }) => {
  const cols = actions.length > 1 ? "sm:grid-cols-2" : "";
  return /* @__PURE__ */ jsx3("section", { "aria-labelledby": "quick-links-title", children: /* @__PURE__ */ jsxs3(
    "div",
    {
      className: `divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow sm:grid sm:gap-px sm:divide-y-0`,
      children: [
        /* @__PURE__ */ jsx3("h2", { className: "sr-only", id: "quick-links-title", children: "Quick links" }),
        actions.map((action, actionIdx) => /* @__PURE__ */ jsxs3(
          "div",
          {
            className: classNames(
              actionIdx === 0 ? "rounded-tl-lg rounded-tr-lg sm:rounded-tr-none" : "",
              actionIdx === 1 ? "sm:rounded-tr-lg" : "",
              actionIdx === actions.length - 2 ? "sm:rounded-bl-lg" : "",
              actionIdx === actions.length - 1 ? "rounded-bl-lg rounded-br-lg sm:rounded-bl-none" : "",
              "group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-cyan-500"
            ),
            children: [
              /* @__PURE__ */ jsx3("div", { children: /* @__PURE__ */ jsx3(
                "span",
                {
                  className: classNames(
                    action.iconBackground,
                    action.iconForeground,
                    "inline-flex rounded-lg p-3 ring-4 ring-white"
                  ),
                  children: /* @__PURE__ */ jsx3(action.icon, { className: "h-6 w-6", "aria-hidden": "true" })
                }
              ) }),
              /* @__PURE__ */ jsxs3("div", { className: "mt-8", children: [
                /* @__PURE__ */ jsx3("h3", { className: "text-lg font-medium", children: /* @__PURE__ */ jsx3(NavLink, { to: action.href, className: "focus:outline-none", children: ({ isActive }) => /* @__PURE__ */ jsxs3(Fragment3, { children: [
                  /* @__PURE__ */ jsx3("span", { className: "absolute inset-0", "aria-hidden": "true" }),
                  action.name
                ] }) }) }),
                /* @__PURE__ */ jsx3("p", { className: "mt-2 text-sm text-gray-500", children: action.description })
              ] }),
              /* @__PURE__ */ jsx3(
                "span",
                {
                  className: "pointer-events-none absolute right-6 top-6 text-gray-300 group-hover:text-gray-600",
                  "aria-hidden": "true",
                  children: /* @__PURE__ */ jsx3(
                    "svg",
                    {
                      className: "h-6 w-6",
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "currentColor",
                      viewBox: "0 0 24 24",
                      children: /* @__PURE__ */ jsx3("path", { d: "M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" })
                    }
                  )
                }
              )
            ]
          },
          action.name
        ))
      ]
    }
  ) });
};

// src/components/shared/Linkable.tsx
import { EdLink } from "shared-ui";
import { jsx as jsx4 } from "react/jsx-runtime";
var Linkable = ({ link, name, children }) => {
  return /* @__PURE__ */ jsx4(EdLink, { href: link, name, children });
};

// src/components/sign-in/SignInLoader.tsx
import { MynLogo } from "app-core";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCustomEventListener,
  useClearNextLocation,
  useNextLocation
} from "shared-lib";
import { Button, Size } from "shared-ui";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var SignInLoader = () => {
  const navigate = useNavigate();
  const clearLocation = useClearNextLocation();
  const [nextLocation] = useNextLocation();
  const [nextPage, setNextPage] = useState(null);
  useEffect(() => {
    if (!nextPage) {
      return;
    }
    if (nextPage.startsWith("http")) {
      window.location.href = nextPage;
    } else {
      navigate(nextPage, { replace: true });
    }
  }, [navigate, nextPage]);
  useCustomEventListener(
    "user-signed-in",
    () => {
      if (nextLocation) {
        setNextPage(nextLocation);
        clearLocation();
      } else {
        setNextPage("../app");
      }
    },
    [nextLocation]
  );
  return /* @__PURE__ */ jsx5("div", { className: "container mx-auto flex h-full h-screen justify-center", children: /* @__PURE__ */ jsx5("div", { className: "flex h-full max-w-lg flex-grow items-center bg-white", children: /* @__PURE__ */ jsxs4("div", { className: "flex h-fit flex-grow flex-col justify-center rounded border bg-white p-10 p-4 text-center", children: [
    /* @__PURE__ */ jsx5("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx5("div", { className: "flex w-full items-center space-x-4", children: /* @__PURE__ */ jsx5("div", { className: "mx-auto flex items-center justify-center py-2", children: /* @__PURE__ */ jsx5(MynLogo, { size: Size.lg }) }) }) }),
    /* @__PURE__ */ jsx5("div", { className: "flex w-full flex-col gap-2", children: /* @__PURE__ */ jsxs4("div", { children: [
      /* @__PURE__ */ jsx5("h2", { className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: /* @__PURE__ */ jsx5("span", { className: "block", children: "Job Seekers" }) }),
      /* @__PURE__ */ jsx5("div", { className: "pt-4", children: /* @__PURE__ */ jsx5("div", { className: "text-md text-primary-500 font-medium", children: "Start changing your work life today" }) }),
      /* @__PURE__ */ jsx5("div", { className: "mt-8 flex justify-center", children: /* @__PURE__ */ jsx5("div", { className: "flex gap-2", children: /* @__PURE__ */ jsx5(
        Button,
        {
          color: "primary",
          onClick: () => navigate("../app"),
          size: Size.xl,
          children: /* @__PURE__ */ jsx5("div", { className: "mx-1 flex items-center gap-1", children: /* @__PURE__ */ jsx5("div", { className: "whitespace-nowrap text-sm", children: "Go to Portal" }) })
        }
      ) }) })
    ] }) })
  ] }) }) });
};

// src/components/sign-up/__generated__/CandidateSignUpFormQuery.graphql.ts
var node = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "id"
            }
          ],
          "kind": "ObjectValue",
          "name": "id"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSignUpFormQuery",
      "selections": [
        {
          "alias": "talentPools",
          "args": v1,
          "concreteType": "RecruitTalentPoolsConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPools",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPool",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSignUpFormQuery",
      "selections": [
        {
          "alias": "talentPools",
          "args": v1,
          "concreteType": "RecruitTalentPoolsConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPools",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPool",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f8c10b66760efe3d8d821133874d3bb4",
      "id": null,
      "metadata": {},
      "name": "CandidateSignUpFormQuery",
      "operationKind": "query",
      "text": "query CandidateSignUpFormQuery(\n  $id: UUID!\n) {\n  talentPools: recruitTalentPools(where: {id: {eq: $id}}) {\n    edges {\n      node {\n        slug\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "9e885b4ec737d5372b8ef4c6a7f05356";
var CandidateSignUpFormQuery_graphql_default = node;

// src/components/sign-up/__generated__/CandidateSignUpFormMutation.graphql.ts
var node2 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "CandidateAccountCreatePayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfCandidateAccount",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsCandidateAccount",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          v3,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSignUpFormMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountCreatePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCreate",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSignUpFormMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountsCandidateAccountCreatePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountCreate",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d71346bab5ead674597166736f2fc815",
      "id": null,
      "metadata": {},
      "name": "CandidateSignUpFormMutation",
      "operationKind": "mutation",
      "text": "mutation CandidateSignUpFormMutation(\n  $input: AccountsCandidateAccountCreateInput!\n) {\n  accountsCandidateAccountCreate(input: $input) {\n    payload {\n      otacCode\n      account {\n        cursor\n        node {\n          id\n          accountId\n          createdAt\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        name: __typename\n        code\n        message\n        data\n        validations {\n          message\n          name\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node2.hash = "5e49b8c229bb30974c9d392dac4e31d0";
var CandidateSignUpFormMutation_graphql_default = node2;

// src/components/sign-up/__generated__/CandidateSignUpFormInviteCodeQuery.graphql.ts
var node3 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "inviteCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "inviteCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateEmail",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateFirstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateLastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateSignUpFormInviteCodeQuery",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPool",
              "kind": "LinkedField",
              "name": "talentPool",
              "plural": false,
              "selections": [
                v7,
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateSignUpFormInviteCodeQuery",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPool",
              "kind": "LinkedField",
              "name": "talentPool",
              "plural": false,
              "selections": [
                v7,
                v8,
                v2
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6fafe2f7e27e251817467ae11a3680cd",
      "id": null,
      "metadata": {},
      "name": "CandidateSignUpFormInviteCodeQuery",
      "operationKind": "query",
      "text": "query CandidateSignUpFormInviteCodeQuery(\n  $inviteCode: UUID!\n) {\n  data: recruitTalentPoolInviteById(id: $inviteCode) {\n    id\n    candidateEmail\n    candidateFirstName\n    candidateLastName\n    candidateId\n    talentPool {\n      slug\n      talentPoolId\n      id\n    }\n  }\n}\n"
    }
  };
}();
node3.hash = "72842d3771b9f5a384d5c2eda47ee304";
var CandidateSignUpFormInviteCodeQuery_graphql_default = node3;

// src/components/sign-up/CandidateSignUpForm.tsx
import { useCallback, useEffect as useEffect2, useState as useState2 } from "react";
import { useLazyLoadQuery, useMutation } from "react-relay";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Link, Navigate, useLocation, useNavigate as useNavigate2 } from "react-router-dom";
import {
  AlertMessage,
  Button as Button2,
  CheckboxInput,
  CheckboxType,
  ErrorField,
  FormInput,
  Size as Size2
} from "shared-ui";
import { createClientMutationId, useToggle } from "shared-lib";
import { getPlatformLinks } from "shared-lib";
import { useIsLoggedIn } from "app-core";
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var queryDef = CandidateSignUpFormQuery_graphql_default;
var mutationDef = CandidateSignUpFormMutation_graphql_default;
var signUpFormSchema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  email: z.string().min(1, { message: "Email is a required field." }).email("Email must be a valid email address."),
  password: z.string(),
  acceptTerms: z.literal(true, {
    errorMap: () => ({ message: "You must accept the terms and conditions" })
  }),
  acceptGdpr: z.literal(true, {
    errorMap: () => ({ message: "You must accept the GDPR terms" })
  }),
  source: z.string()
});
var CandidateSignUpForm = (props) => {
  const search = useLocation().search;
  const talentPool = new URLSearchParams(search).get("talentPool");
  const inviteCode = new URLSearchParams(search).get("inviteCode");
  if (inviteCode) {
    return /* @__PURE__ */ jsx6(
      CandidateSignUpFormWithTalentInviteCode,
      {
        ...props,
        inviteCode
      }
    );
  }
  if (talentPool) {
    return /* @__PURE__ */ jsx6(CandidateSignUpFormWithTalentPool, { ...props, talentPool });
  }
  return /* @__PURE__ */ jsx6(CandidateSignUpFormComponent, { ...props });
};
var inviteCodeQueryRef = CandidateSignUpFormInviteCodeQuery_graphql_default;
var CandidateSignUpFormWithTalentInviteCode = (props) => {
  const { data } = useLazyLoadQuery(
    inviteCodeQueryRef,
    {
      inviteCode: props.inviteCode
    }
  );
  const navigate = useNavigate2();
  const isLoggedIn = useIsLoggedIn();
  if (isLoggedIn || data.candidateId) {
    return /* @__PURE__ */ jsx6(Navigate, { to: `/candidates/app/talent-pool/${data.talentPool.slug}` });
  }
  return /* @__PURE__ */ jsx6(
    CandidateSignUpFormComponent,
    {
      ...props,
      onSignIn: () => {
        navigate(`/candidates/app/talent-pool/${data.talentPool.slug}`);
      },
      defaultValues: {
        firstName: data.candidateFirstName || "",
        lastName: data.candidateLastName || "",
        email: data.candidateEmail || "",
        acceptGdpr: true,
        acceptTerms: true,
        source: "web sign up"
      }
    }
  );
};
var CandidateSignUpFormWithTalentPool = (props) => {
  const { talentPools } = useLazyLoadQuery(queryDef, {
    id: props.talentPool
  });
  const navigate = useNavigate2();
  if (!talentPools?.edges?.length) {
    return /* @__PURE__ */ jsx6("div", { children: "no talent pool" });
  }
  const slug = talentPools?.edges[0]?.node.slug;
  const isLoggedIn = useIsLoggedIn();
  if (isLoggedIn) {
    return /* @__PURE__ */ jsx6(Navigate, { to: `/candidates/app/talent-pool/${slug}` });
  }
  return /* @__PURE__ */ jsx6(
    CandidateSignUpFormComponent,
    {
      ...props,
      onSignIn: () => {
        navigate(`/candidates/app/talent-pool/${slug}`);
      }
    }
  );
};
var CandidateSignUpFormComponent = ({
  onDone,
  onSignIn,
  talentPool,
  defaultValues = {
    acceptGdpr: true,
    acceptTerms: true,
    source: "web sign up",
    firstName: "",
    lastName: "",
    email: ""
  }
}) => {
  const [commitMutation, isMutationInFlight] = useMutation(mutationDef);
  const { register, handleSubmit, formState, control, watch } = useForm({
    mode: "onChange",
    resolver: zodResolver(signUpFormSchema),
    defaultValues
  });
  useEffect2(() => {
    const subscription = watch(
      (value, { name, type }) => console.log(value, name, type)
    );
    return () => subscription.unsubscribe();
  }, [watch]);
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data) => createAccount(isValid, data));
  const [criticalFailure, toggleCriticalFailure] = useToggle(false);
  const [userErrors, setUserErrors] = useState2([]);
  const createAccount = useCallback(
    (isValid2, form) => {
      if (!form.email) {
        return;
      }
      const clientMutationId = createClientMutationId();
      commitMutation({
        variables: {
          input: {
            data: {
              firstName: form.firstName,
              lastName: form.lastName,
              email: form.email,
              password: form.password,
              acceptTerms: form.acceptTerms,
              acceptGdpr: form.acceptGdpr,
              source: form.source,
              talentPools: talentPool ? [talentPool] : []
            },
            clientMutationId
          }
        },
        onError: (e) => {
          toggleCriticalFailure();
          console.log(e.message);
        },
        onCompleted: ({ accountsCandidateAccountCreate }) => {
          const payload = accountsCandidateAccountCreate.payload;
          const higherLevelErrors = accountsCandidateAccountCreate.userErrors || [];
          if (higherLevelErrors && higherLevelErrors.length > 0) {
            setUserErrors(higherLevelErrors);
          } else if (payload && payload.otacCode != null) {
            onDone({ otacCode: payload.otacCode });
          }
        }
      });
    },
    [commitMutation, onDone, talentPool, toggleCriticalFailure]
  );
  const platformLinks = getPlatformLinks();
  return /* @__PURE__ */ jsx6("div", { className: "mt-4 sm:rounded-md md:w-3/4 lg:w-1/2", children: /* @__PURE__ */ jsxs5("div", { className: "space-y-6 bg-white px-4 ", children: [
    /* @__PURE__ */ jsxs5("div", { className: "sm:mx-auto sm:w-full sm:max-w-md", children: [
      /* @__PURE__ */ jsxs5("h2", { className: "font-AthleticsMedium px-20 text-center text-2xl tracking-tight text-gray-900", children: [
        "Sign up to find work you'll love",
        " "
      ] }),
      /* @__PURE__ */ jsx6("p", { className: "mt-2 text-center text-xs text-gray-500", children: "Create an account or sign-in" })
    ] }),
    userErrors.map((e) => {
      switch (e?.code) {
        case "public":
          return /* @__PURE__ */ jsx6(
            AlertMessage,
            {
              isError: true,
              message: "This is a private Talent Pool, join by invite only. Please contact our Support team for advice."
            }
          );
      }
    }),
    criticalFailure ? /* @__PURE__ */ jsx6("div", { children: "A error has occurred, please try again" }) : null,
    /* @__PURE__ */ jsxs5("form", { onSubmit, children: [
      /* @__PURE__ */ jsxs5("div", { className: "flex flex-col flex-wrap gap-2", children: [
        /* @__PURE__ */ jsxs5("div", { className: "flex-grow", children: [
          /* @__PURE__ */ jsx6(
            FormInput,
            {
              label: "First name *",
              className: "mt-1",
              type: "text",
              placeholder: " First Name ",
              name: "firstName",
              required: true,
              register
            }
          ),
          errors.firstName && /* @__PURE__ */ jsx6(ErrorField, { field: errors.firstName.message })
        ] }),
        /* @__PURE__ */ jsxs5("div", { className: "flex-grow", children: [
          /* @__PURE__ */ jsx6(
            FormInput,
            {
              label: "Last name *",
              className: "mt-1",
              type: "text",
              placeholder: " Last Name ",
              name: "lastName",
              required: true,
              register
            }
          ),
          errors.lastName && /* @__PURE__ */ jsx6(ErrorField, { field: errors.lastName.message })
        ] }),
        /* @__PURE__ */ jsxs5("div", { className: "flex-grow", children: [
          /* @__PURE__ */ jsx6(
            FormInput,
            {
              label: "Email address *",
              className: "mt-1",
              type: "text",
              placeholder: " Email address ",
              name: "email",
              required: true,
              register
            }
          ),
          errors.email && /* @__PURE__ */ jsx6(ErrorField, { field: errors.email.message }),
          userErrors.map((e) => {
            switch (e?.code) {
              case "ACCOUNTS_CANDIDATE_ACCOUNT_EMAIL_IS_IN_USE":
                return /* @__PURE__ */ jsx6(ErrorField, { field: "This email is already in use" });
                break;
            }
          })
        ] }),
        /* @__PURE__ */ jsxs5("div", { className: "flex-grow", children: [
          /* @__PURE__ */ jsx6(
            FormInput,
            {
              label: `Password *`,
              className: "mt-1",
              type: "password",
              placeholder: " Password ",
              name: "password",
              required: true,
              register
            }
          ),
          errors.password && /* @__PURE__ */ jsx6(ErrorField, { field: errors.password.message }),
          userErrors.map((e) => {
            switch (e?.code) {
              case "ACCOUNTS_CANDIDATE_ACCOUNT_VALIDATION":
                return /* @__PURE__ */ jsx6(
                  ErrorField,
                  {
                    field: "Invalid password",
                    validations: e.validations.map((x) => x.message)
                  }
                );
              default:
            }
          })
        ] })
      ] }),
      /* @__PURE__ */ jsxs5("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx6(
          CheckboxInput,
          {
            type: CheckboxType.checkbox,
            label: /* @__PURE__ */ jsxs5("span", { className: "text-xs", children: [
              "I accept the",
              " ",
              /* @__PURE__ */ jsx6(
                Link,
                {
                  to: platformLinks.termsAndConditions,
                  target: `_blank`,
                  className: `underline`,
                  children: "Terms and Conditions"
                }
              )
            ] }),
            name: "acceptTerms",
            defaultChecked: defaultValues.acceptTerms,
            control,
            disabled: false
          }
        ),
        errors.acceptTerms && /* @__PURE__ */ jsx6(ErrorField, { field: errors.acceptTerms.message })
      ] }),
      /* @__PURE__ */ jsxs5("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx6(
          CheckboxInput,
          {
            type: CheckboxType.checkbox,
            label: /* @__PURE__ */ jsxs5("span", { className: "text-xs", children: [
              "I accept the",
              " ",
              /* @__PURE__ */ jsx6(
                Link,
                {
                  to: platformLinks.privacyPolicy,
                  target: `_blank`,
                  className: `underline`,
                  children: "Privacy Policy"
                }
              )
            ] }),
            name: "acceptGdpr",
            defaultChecked: defaultValues.acceptGdpr,
            control,
            disabled: false
          }
        ),
        errors.acceptGdpr && /* @__PURE__ */ jsx6(ErrorField, { field: errors.acceptGdpr.message })
      ] }),
      /* @__PURE__ */ jsx6("div", { className: "mt-5 flex", children: /* @__PURE__ */ jsx6(
        Button2,
        {
          className: "flex-1 rounded-full",
          disabled: !isValid || isMutationInFlight,
          color: "primary",
          size: Size2.xl,
          type: "submit",
          children: "Create account"
        }
      ) }),
      /* @__PURE__ */ jsxs5("div", { className: "mt-4 flex items-center justify-center space-x-2", children: [
        /* @__PURE__ */ jsx6("p", { className: "text-md text-center text-gray-600", children: "Already have an account?" }),
        /* @__PURE__ */ jsx6("div", { onClick: onSignIn, className: "cursor-pointer", children: "Sign in" })
      ] })
    ] })
  ] }) });
};

// src/components/tasks/__generated__/GroupedTasksContainer_data.graphql.ts
var node4 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupedTasksContainer_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GroupedTasksLayout_data"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node4.hash = "eac2a99988d61babd2f2048cd86fcc9a";
var GroupedTasksContainer_data_graphql_default = node4;

// src/components/tasks/GroupedTasksContainer.tsx
import { useEffect as useEffect3 } from "react";
import { useFragment as useFragment2, useQueryLoader } from "react-relay";
import { EdSkeleton as EdSkeleton2 } from "shared-ui";

// src/components/tasks/__generated__/GroupedTasksLayoutQuery.graphql.ts
var node5 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "applicationState"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "candidateId"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskStatus"
  }, v3 = {
    "kind": "Variable",
    "name": "candidateId",
    "variableName": "candidateId"
  }, v4 = [
    v3
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "groupId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateTaskId",
    "storageKey": null
  }, v10 = {
    "args": null,
    "kind": "FragmentSpread",
    "name": "TaskItem_task"
  }, v11 = [
    {
      "kind": "Variable",
      "name": "applicationState",
      "variableName": "applicationState"
    },
    v3,
    {
      "kind": "Variable",
      "name": "taskStatus",
      "variableName": "taskStatus"
    }
  ], v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "summary",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "concreteType": "CandidateTaskGroup",
    "kind": "LinkedField",
    "name": "group",
    "plural": false,
    "selections": [
      v8
    ],
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "concreteType": "CandidateTaskSource",
    "kind": "LinkedField",
    "name": "source",
    "plural": false,
    "selections": [
      v5
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "GroupedTasksLayoutQuery",
      "selections": [
        {
          "alias": "global",
          "args": v4,
          "concreteType": "CandidateTaskGlobalGroup",
          "kind": "LinkedField",
          "name": "tasksCandidateGlobalTasks",
          "plural": true,
          "selections": [
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                v5,
                v9,
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "applications",
          "args": v11,
          "concreteType": "CandidateTaskGlobalGroup",
          "kind": "LinkedField",
          "name": "tasksCandidateApplicationGroupedTasks",
          "plural": true,
          "selections": [
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                v5,
                v9,
                v12,
                v13,
                v7,
                v14,
                v15,
                v16,
                v17,
                v18,
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0,
        v2
      ],
      "kind": "Operation",
      "name": "GroupedTasksLayoutQuery",
      "selections": [
        {
          "alias": "global",
          "args": v4,
          "concreteType": "CandidateTaskGlobalGroup",
          "kind": "LinkedField",
          "name": "tasksCandidateGlobalTasks",
          "plural": true,
          "selections": [
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                v5,
                v9,
                v7,
                v12,
                v16,
                v14,
                v15,
                v13
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "applications",
          "args": v11,
          "concreteType": "CandidateTaskGlobalGroup",
          "kind": "LinkedField",
          "name": "tasksCandidateApplicationGroupedTasks",
          "plural": true,
          "selections": [
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                v5,
                v9,
                v12,
                v13,
                v7,
                v14,
                v15,
                v16,
                v17,
                v18
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "7a96f725ab139b70546eb7b78444e66f",
      "id": null,
      "metadata": {},
      "name": "GroupedTasksLayoutQuery",
      "operationKind": "query",
      "text": "query GroupedTasksLayoutQuery(\n  $candidateId: UUID!\n  $applicationState: ApplicationStates\n  $taskStatus: TaskStatus\n) {\n  global: tasksCandidateGlobalTasks(candidateId: $candidateId) {\n    id\n    groupId\n    type\n    name\n    tasks {\n      id\n      candidateTaskId\n      ...TaskItem_task\n    }\n  }\n  applications: tasksCandidateApplicationGroupedTasks(candidateId: $candidateId, applicationState: $applicationState, taskStatus: $taskStatus) {\n    id\n    groupId\n    type\n    name\n    tasks {\n      id\n      candidateTaskId\n      version\n      status\n      type\n      title\n      summary\n      description\n      group {\n        name\n      }\n      source {\n        id\n      }\n      ...TaskItem_task\n    }\n  }\n}\n\nfragment TaskItem_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n"
    }
  };
}();
node5.hash = "4e2bd22434dfc9c1bbc29fb74dcf0f93";
var GroupedTasksLayoutQuery_graphql_default = node5;

// src/components/tasks/__generated__/GroupedTasksLayout_data.graphql.ts
var node6 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupedTasksLayout_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationTaskLoader_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountTaskLoader_data"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node6.hash = "9d2de77331977cbe154693e61222ba20";
var GroupedTasksLayout_data_graphql_default = node6;

// src/components/tasks/GroupedTasksLayout.tsx
import { useCallback as useCallback2 } from "react";
import { Navigate as Navigate2, Route, Routes, useNavigate as useNavigate3 } from "react-router-dom";
import {
  useFragment,
  usePreloadedQuery
} from "react-relay";
import { Suspense } from "shared-ui";
import { EdSkeleton } from "shared-ui";
import { ApplicationTaskLoader } from "feature-recruit";
import { AccountTaskLoader } from "feature-candidate-accounts";
import { TaskItem } from "app-core";
import { Fragment as Fragment4, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var groupedTasksQueryDef = GroupedTasksLayoutQuery_graphql_default;
var GlobalTasks = ({ queryRef, onSelect }) => {
  const data = usePreloadedQuery(
    groupedTasksQueryDef,
    queryRef
  );
  const globalTasks = data.global || [];
  const accountGroup = globalTasks.find((g) => g.type === "Account");
  if (!accountGroup || !accountGroup.tasks || accountGroup.tasks.length === 0) {
    return /* @__PURE__ */ jsx7(Fragment4, {});
  }
  const tasks = accountGroup.tasks.map((task) => {
    return /* @__PURE__ */ jsx7(
      TaskItem,
      {
        fragmentRef: task,
        selected: () => onSelect(task.candidateTaskId)
      },
      task.candidateTaskId
    );
  });
  return /* @__PURE__ */ jsxs6("div", { className: "p-2", children: [
    /* @__PURE__ */ jsx7("div", { className: "mb-2 py-4 sm:p-4", children: /* @__PURE__ */ jsx7("h2", { className: "text-primary-500 text-xl font-medium", children: "Account Tasks" }) }),
    /* @__PURE__ */ jsx7("ul", { className: "mt-2 flex flex-col gap-2", children: tasks })
  ] });
};
var ApplicationTasks = ({
  queryRef,
  onSelect
}) => {
  const data = usePreloadedQuery(
    groupedTasksQueryDef,
    queryRef
  );
  const applicationTasks = (data.applications || []).map((group) => {
    const tasks = group.tasks.map((task) => {
      return /* @__PURE__ */ jsx7(
        TaskItem,
        {
          fragmentRef: task,
          selected: () => onSelect(task.source.id, task.candidateTaskId)
        },
        task.candidateTaskId
      );
    });
    return /* @__PURE__ */ jsxs6("div", { className: "flex flex-col gap-2 sm:px-4", children: [
      /* @__PURE__ */ jsxs6("div", { className: "mb-2 flex flex-col gap-2", children: [
        /* @__PURE__ */ jsx7("div", { className: "text-lg font-medium text-gray-900", children: group.name }),
        /* @__PURE__ */ jsxs6("div", { className: "text-info-500 text-sm", children: [
          group.tasks.length,
          " tasks pending"
        ] })
      ] }),
      /* @__PURE__ */ jsx7("ul", { children: tasks })
    ] }, group.groupId);
  });
  return /* @__PURE__ */ jsxs6("div", { className: "p-2", children: [
    /* @__PURE__ */ jsx7("div", { className: "mb-4 sm:px-4", children: /* @__PURE__ */ jsx7("h2", { className: "text-primary-500 text-xl font-medium", children: "Application Tasks" }) }),
    applicationTasks.length === 0 ? /* @__PURE__ */ jsx7("div", { className: "flex flex-col gap-4", children: /* @__PURE__ */ jsx7("div", { className: "px-4 text-sm font-medium", children: "No tasks pending !" }) }) : /* @__PURE__ */ jsx7("div", { className: "flex flex-col gap-4", children: applicationTasks })
  ] });
};
var fragmentDef = GroupedTasksLayout_data_graphql_default;
var GroupedTasksLayout = ({
  queryRef,
  fragmentRef
}) => {
  const data = useFragment(fragmentDef, fragmentRef);
  const navigate = useNavigate3();
  const onSelectAccountTask = useCallback2((taskId) => {
    navigate(`task/${taskId}`);
  }, []);
  const onSelectApplicationTask = useCallback2((applicationId, taskId) => {
    navigate(`application/${applicationId}/task/${taskId}`);
  }, []);
  const onCompleted = useCallback2(() => {
    navigate(`list`);
  }, []);
  return /* @__PURE__ */ jsx7(Suspense, { fallback: /* @__PURE__ */ jsx7(EdSkeleton, {}), children: /* @__PURE__ */ jsxs6(Routes, { children: [
    /* @__PURE__ */ jsx7(
      Route,
      {
        path: "list",
        element: /* @__PURE__ */ jsxs6("div", { className: "p-2 sm:p-8", children: [
          /* @__PURE__ */ jsx7(GlobalTasks, { queryRef, onSelect: onSelectAccountTask }),
          /* @__PURE__ */ jsx7(
            ApplicationTasks,
            {
              queryRef,
              onSelect: onSelectApplicationTask
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx7(
      Route,
      {
        path: `task/:taskId`,
        element: /* @__PURE__ */ jsx7(Suspense, { fallback: /* @__PURE__ */ jsx7(EdSkeleton, {}), children: /* @__PURE__ */ jsx7(
          AccountTaskLoader,
          {
            fragmentRef: data,
            onCompleted,
            onBack: onCompleted
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx7(
      Route,
      {
        path: `application/:applicationId/task/:taskId`,
        element: /* @__PURE__ */ jsx7(Suspense, { fallback: /* @__PURE__ */ jsx7(EdSkeleton, {}), children: /* @__PURE__ */ jsx7(
          ApplicationTaskLoader,
          {
            fragmentRef: data,
            onCompleted,
            onBack: onCompleted
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx7(Route, { path: "*", element: /* @__PURE__ */ jsx7(Navigate2, { to: "./list" }) })
  ] }) });
};

// src/components/tasks/GroupedTasksContainer.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var fragmentDef2 = GroupedTasksContainer_data_graphql_default;
var GroupedTasksContainer = ({
  candidateId,
  fragmentRef,
  onSelect
}) => {
  const data = useFragment2(fragmentDef2, fragmentRef);
  const [queryReference, loadQuery, disposeQuery] = useQueryLoader(groupedTasksQueryDef);
  useEffect3(() => {
    loadQuery({ candidateId }, { fetchPolicy: "network-only" });
  }, [loadQuery]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx8(EdSkeleton2, {});
  }
  return /* @__PURE__ */ jsx8(GroupedTasksLayout, { queryRef: queryReference, fragmentRef: data });
};

// src/lib/useUserManager.ts
import { ElevateAccountTypes, Tenant } from "app-core";

// src/config/config.ts
import { useContext, useMemo } from "react";
import {
  loadEnvironmentConfig,
  GlobalSettingsContext,
  PortalApps
} from "shared-lib";

// src/config/oidc.config.ts
import { ElevateScopes } from "app-core";
var oidc_config_default = {
  responseType: "id_token token",
  acrValues: "tenant:contractor",
  clientId: "candidates.web",
  apiPath: `candidates.api`,
  scope: `openid profile email ${ElevateScopes.RecruitApiScope}  ${ElevateScopes.CandidatesApiScope} ${ElevateScopes.EventTrackingApiScope} ${ElevateScopes.IdentityScope} ${ElevateScopes.CompaniesScope}`
};

// src/config/config.ts
var NEXT_LOCATION_KEY = "NEXT_ACTION";
function useConfig() {
  const settings = useContext(GlobalSettingsContext);
  const environmentConfig = useMemo(() => {
    return loadEnvironmentConfig(settings, PortalApps.Candidates);
  }, [settings]);
  return {
    ...oidc_config_default,
    ...environmentConfig
  };
}

// src/lib/useUserManager.ts
function useAuthConfig() {
  const config = useConfig();
  const signoutRedirectUri = `${window.location.protocol}//${window.location.host}/portal/candidates`;
  const signoutLink = `${window.location.protocol}//${window.location.host}/elevate.identity/core`;
  return {
    ...config,
    autoSignIn: false,
    accountType: ElevateAccountTypes.Contractor,
    signoutRedirectUri,
    signoutLink,
    tenant: Tenant.Contractor,
    onSetUserData: async () => {
      window.location.hash = "";
    }
  };
}

// src/landing/HomePage.tsx
import { Button as Button3, EdCard, EdLink as EdLink2, Size as Size3 } from "shared-ui";
import { useIsLoggedIn as useIsLoggedIn2, useOIDC as useOIDC2 } from "app-core";
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var HomePage = () => {
  const isSignedIn = useIsLoggedIn2();
  const { signIn } = useOIDC2();
  async function onSignIn() {
    await signIn("app");
  }
  return /* @__PURE__ */ jsx9("div", { className: "container mx-auto flex flex-grow justify-center sm:my-16", children: /* @__PURE__ */ jsx9("div", { className: "flex h-full max-w-lg flex-grow bg-white", children: /* @__PURE__ */ jsxs7(EdCard, { className: "justify-center p-10 text-center", children: [
    /* @__PURE__ */ jsx9("h2", { className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: /* @__PURE__ */ jsx9("span", { className: "block", children: "Job Seekers" }) }),
    /* @__PURE__ */ jsx9("div", { className: "pt-4", children: /* @__PURE__ */ jsx9("div", { className: "text-md text-primary-500 font-medium", children: "Start changing your work life today" }) }),
    /* @__PURE__ */ jsx9("div", { className: "mt-8 flex justify-center", children: isSignedIn ? /* @__PURE__ */ jsx9(EdLink2, { href: "app", name: "app-link", children: /* @__PURE__ */ jsx9("div", { className: "bg-primary-100 text-primary-700 hover:bg-primary-200 inline-flex items-center justify-center rounded-md border border-transparent px-5 py-3 text-base font-medium", children: "Start Now" }) }) : /* @__PURE__ */ jsxs7("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsx9(Button3, { color: "primary", size: Size3.xl, onClick: onSignIn, children: /* @__PURE__ */ jsx9("div", { className: "mx-1 flex items-center gap-1 px-5", children: /* @__PURE__ */ jsx9("div", { className: "whitespace-nowrap ", children: "Sign In" }) }) }),
      /* @__PURE__ */ jsx9(EdLink2, { href: "pub/signup", name: "signup-link", children: /* @__PURE__ */ jsx9(
        Button3,
        {
          color: "transparent",
          size: Size3.xl,
          className: "border border-black",
          children: /* @__PURE__ */ jsx9("div", { className: "mx-1 flex items-center gap-1 px-5", children: /* @__PURE__ */ jsx9("div", { className: "whitespace-nowrap ", children: "Sign Up" }) })
        }
      ) })
    ] }) })
  ] }) }) });
};

// src/navigate/NavigatePage.tsx
import { useEffect as useEffect4, useState as useState3 } from "react";
import { useNavigate as useNavigate4, useSearchParams } from "react-router-dom";
import { useLogger, useSetNextLocation } from "shared-lib";
import { Button as Button5 } from "shared-ui";
import { ElevateAccountTypes as ElevateAccountTypes2, Tenant as Tenant2, useOIDC as useOIDC3 } from "app-core";

// src/public/EmailVerificationExpired.tsx
import { AppLogo } from "app-core";
import { Link as Link2 } from "react-router-dom";
import { Button as Button4, Card, Size as Size4 } from "shared-ui";
import { jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
function EmailVerificationExpired() {
  return /* @__PURE__ */ jsx10("div", { className: "container mx-auto mt-20 flex items-center justify-center", children: /* @__PURE__ */ jsxs8(Card, { className: "flex max-w-2xl flex-col gap-3 border shadow", children: [
    /* @__PURE__ */ jsxs8("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ jsx10("h1", { className: "text-2xl", children: "Email Verification Expired" }),
      /* @__PURE__ */ jsx10(AppLogo, {})
    ] }),
    /* @__PURE__ */ jsx10("p", { children: "Your email verification link has expired. Please request a new one through the dashboard." }),
    /* @__PURE__ */ jsx10(Link2, { to: "/candidates/app/profile/summary", className: "mt-5", children: /* @__PURE__ */ jsx10(Button4, { color: "primary", size: Size4.lg, className: "w-full", children: "Login" }) })
  ] }) });
}

// src/navigate/NavigatePage.tsx
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var profileLink = `../app/profile`;
var NavigatePage = () => {
  const [log] = useLogger();
  const [error, setError] = useState3(null);
  const [impersonate, setImpersonate] = useState3(null);
  const navigate = useNavigate4();
  const setNextLocation = useSetNextLocation();
  const [context, setContext] = useState3(null);
  const { signInOTP, signInAs, signIn } = useOIDC3();
  const [searchParams] = useSearchParams();
  const action = searchParams.get("action");
  useEffect4(() => {
    const parameters = searchParams.get("data");
    const otac = searchParams.get("otac") || void 0;
    const params = parameters ? JSON.parse(decodeURI(parameters)) : null;
    log(`Candidates Nav: action: ${action} params: ${parameters}`);
    switch (action) {
      case "impersonate": {
        if (params) {
          const { accountId, token } = params;
          if (accountId && token) {
            setImpersonate(params);
          } else {
            setError("Could Not Load Impersonation Data");
          }
        }
        break;
      }
      case "application": {
        if (params) {
          const returnLocation = `../app/applications/${params.id}/info`;
          setContext({ otacCode: otac, returnUrl: returnLocation });
        } else {
          setContext({ otacCode: otac });
        }
        break;
      }
      case "recommendation": {
        if (params) {
          const { recommendationId, decisionToken } = params;
          const link = `/candidates/pub/rec/${recommendationId}/${decisionToken}`;
          setContext({ redirect: link });
        } else {
          setContext({ otacCode: otac });
        }
        break;
      }
      case "talent-pool": {
        const { inviteCode } = params;
        const returnLocation = `../app/talent-pool-invite/${inviteCode}`;
        setContext({ otacCode: otac, returnUrl: returnLocation });
        break;
      }
      case "recommendations": {
        const link = `/candidates/app/jobs/recommendations`;
        setContext({ returnUrl: link });
        break;
      }
      case "apply": {
        if (parameters) {
          const returnLocation = `../app/vacancies/apply/${params.code}`;
          setContext({ otacCode: otac, returnUrl: returnLocation });
        } else {
          setContext({ otacCode: otac });
        }
        break;
      }
      case "chats": {
        const returnLocation = `../app/chats`;
        setContext({ otacCode: otac, returnUrl: returnLocation });
        break;
      }
      case "timesheet": {
        const returnLocation = `../app/contracts`;
        setContext({ otacCode: otac, returnUrl: returnLocation });
        break;
      }
      case "verified": {
        setContext({ otacCode: otac, returnUrl: profileLink });
        break;
      }
      case "vacancy-set-password": {
        log(`Candidates Nav: Invoked vacancy-set-password`);
        if (params) {
          const { applicationId, vacancyId, emailAddress, passwordResetToken } = params;
          const link = `/candidates/pub/apply-new-account/${applicationId}/${vacancyId}/${emailAddress}/${passwordResetToken}`;
          setContext({ otacCode: otac, redirect: link });
        } else {
          setContext({ otacCode: otac, returnUrl: profileLink });
        }
        break;
      }
      default: {
        setContext({ otacCode: otac });
        break;
      }
    }
  }, [searchParams]);
  async function onImpersonation() {
    log(`Candidates Nav Impersonate: ${JSON.stringify(impersonate)}`);
    if (impersonate == null) {
      return;
    }
    const { accountId, token } = impersonate;
    await signInAs(
      accountId,
      Tenant2.Contractor,
      ElevateAccountTypes2.Contractor,
      token
    );
  }
  useEffect4(() => {
    log(`Candidates Nav Context Changed: ${JSON.stringify(context)}`);
    if (context == null) {
      return;
    }
    if (context.redirect) {
      navigate(context.redirect);
      return;
    }
    if (context.returnUrl) {
      setNextLocation(context.returnUrl);
    }
    onSignIn();
  }, [context, setNextLocation, onSignIn]);
  async function onSignIn() {
    if (context && context.otacCode) {
      await signInOTP(context.otacCode);
    } else {
      await signIn();
    }
  }
  if (action == "email-verification-expired") {
    return /* @__PURE__ */ jsx11(EmailVerificationExpired, {});
  }
  if (impersonate) {
    return /* @__PURE__ */ jsx11("div", { className: "p-4", children: /* @__PURE__ */ jsx11(Button5, { color: "primary", clicked: onImpersonation, children: "Impersonate & Sign In" }) });
  }
  if (context && !context.otacCode) {
    return /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(
      "button",
      {
        onClick: () => {
          navigate("/portal/candidates");
        },
        children: "Login"
      }
    ) });
  } else {
    return /* @__PURE__ */ jsxs9("div", { children: [
      error && /* @__PURE__ */ jsx11("div", { className: "m-8 border bg-white", children: error }),
      /* @__PURE__ */ jsx11("button", { onClick: onSignIn, children: "Login" })
    ] });
  }
};

// src/public/recommendations/PublicRecommendationPage.tsx
import { Suspense as Suspense2 } from "react";
import { useNavigate as useNavigate5, useParams } from "react-router-dom";
import { useLogger as useLogger2, useSetNextLocation as useSetNextLocation2 } from "shared-lib";
import { EdSkeleton as EdSkeleton3 } from "shared-ui";
import { useOIDC as useOIDC4 } from "app-core";
import { PublicRecommendationLoader } from "feature-recruit";
import { jsx as jsx12 } from "react/jsx-runtime";
var PublicRecommendationPage = () => {
  const { signInOTP } = useOIDC4();
  const { id } = useParams();
  const { token } = useParams();
  const [log] = useLogger2();
  const setNext = useSetNextLocation2();
  const navigate = useNavigate5();
  return /* @__PURE__ */ jsx12(Suspense2, { fallback: /* @__PURE__ */ jsx12(EdSkeleton3, {}), children: /* @__PURE__ */ jsx12(
    PublicRecommendationLoader,
    {
      recommendationId: id,
      token,
      onResponseCompleted: (otac, applicationId) => {
        log(`PublicRecommendationPage ResponseCompleted otac: ${otac}`);
        if (otac && applicationId) {
          signInOTP(otac);
          setNext(`../app/applications/${applicationId}/info`);
        } else {
          navigate(`../../app/applications/${applicationId}/info`);
        }
      }
    }
  ) });
};

// src/public/signup/pages/SignUpPage.tsx
import { ElevateCentered } from "shared-ui";
import { AuthProvider as AuthProvider2, useOIDC as useOIDC5 } from "app-core";
import { jsx as jsx13 } from "react/jsx-runtime";
var SignUpPage = () => {
  const { signInOTP, signIn } = useOIDC5();
  const authConfig = useAuthConfig();
  return /* @__PURE__ */ jsx13("div", { className: "flex flex-col py-12 sm:px-6 lg:px-8", children: /* @__PURE__ */ jsx13(ElevateCentered, { children: /* @__PURE__ */ jsx13(AuthProvider2, { ...authConfig, children: /* @__PURE__ */ jsx13(
    CandidateSignUpForm,
    {
      onSignIn: () => {
        signIn();
      },
      onDone: ({ otacCode }) => {
        signInOTP(otacCode);
      },
      onFail: (e) => {
        console.error(e);
      }
    }
  ) }) }) });
};

// src/public/vacancies/__generated__/VacancyApplyJobBoardNewAccountPageQuery.graphql.ts
var node7 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vacancyId"
  }, v3 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "vacancyId"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyAdvertId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v8 = {
    "alias": "isValidToken",
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "kind": "ScalarField",
    "name": "accountCandidateCheckEmailToken",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyApplyJobBoardNewAccountPageQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v3,
          "concreteType": "VacancyAdvert",
          "kind": "LinkedField",
          "name": "recruitVacancyAdvertById",
          "plural": false,
          "selections": [
            v4,
            v5,
            v6,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyAdSummary_vacancy"
            },
            v7
          ],
          "storageKey": null
        },
        v8
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v2,
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "VacancyApplyJobBoardNewAccountPageQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v3,
          "concreteType": "VacancyAdvert",
          "kind": "LinkedField",
          "name": "recruitVacancyAdvertById",
          "plural": false,
          "selections": [
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerLogoUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rateMax",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "payType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LocationCriteria",
              "kind": "LinkedField",
              "name": "locations",
              "plural": true,
              "selections": [
                v6,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "durationAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "durationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionHtml",
              "storageKey": null
            },
            v7
          ],
          "storageKey": null
        },
        v8
      ]
    },
    "params": {
      "cacheID": "7622d55b669d9579e9cd4df131f47ced",
      "id": null,
      "metadata": {},
      "name": "VacancyApplyJobBoardNewAccountPageQuery",
      "operationKind": "query",
      "text": "query VacancyApplyJobBoardNewAccountPageQuery(\n  $vacancyId: UUID!\n  $email: String!\n  $code: String!\n) {\n  vacancy: recruitVacancyAdvertById(id: $vacancyId) {\n    id\n    vacancyAdvertId\n    name\n    ...VacancyAdSummary_vacancy\n  }\n  isValidToken: accountCandidateCheckEmailToken(email: $email, code: $code)\n}\n\nfragment VacancyAdSummary_vacancy on VacancyAdvert {\n  id\n  vacancyAdvertId\n  vacancyId\n  createdAt\n  version\n  employerId\n  employerName\n  employerLogoUrl\n  rateMax\n  payType\n  employerReference\n  locations {\n    name\n    state\n    countryCode\n    countryName\n  }\n  durationAmount\n  durationType\n  name\n  publicDescriptionHtml\n}\n"
    }
  };
}();
node7.hash = "0a156da5b161545415ae9e2f1e53516a";
var VacancyApplyJobBoardNewAccountPageQuery_graphql_default = node7;

// src/public/vacancies/VacancyApplyJobBoardNewAccountPage.tsx
import { useCallback as useCallback3, useState as useState4 } from "react";
import { useParams as useParams2 } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery2 } from "react-relay";
import { useSetNextLocation as useSetNextLocation3 } from "shared-lib";
import { AlertMessage as AlertMessage2 } from "shared-ui";
import { useOIDC as useOIDC6 } from "app-core";
import { VacancyAdSummary } from "feature-recruit";
import {
  CandidateAccountResetPasswordTerms,
  CandidateAccountSendResetPassword
} from "feature-candidate-accounts";
import { Fragment as Fragment5, jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var queryDef2 = VacancyApplyJobBoardNewAccountPageQuery_graphql_default;
var VacancyApplyJobBoardNewAccountPage = () => {
  const setLocation = useSetNextLocation3();
  const { signInOTP } = useOIDC6();
  const { applicationId } = useParams2();
  const { vacancyId } = useParams2();
  const { email } = useParams2();
  const { token } = useParams2();
  const [isSent, setIsSent] = useState4(false);
  const onSignIn = useCallback3(async (result) => {
    setLocation(`../app/applications/${applicationId}/info`);
    await signInOTP(result.otacCode);
  }, []);
  const data = useLazyLoadQuery2(
    queryDef2,
    { vacancyId, email, code: token },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!vacancyId || !email || !token) {
    return /* @__PURE__ */ jsx14("div", { className: "m-8", children: /* @__PURE__ */ jsx14(AlertMessage2, { message: "Invalid Link. Please Contact Support" }) });
  }
  const { vacancy, isValidToken } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx14(Fragment5, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs10("div", { className: "flex flex-col gap-5 sm:m-8 sm:mx-auto sm:w-2/3 lg:rounded-2xl lg:border-2", children: [
    /* @__PURE__ */ jsx14("div", { className: "mx-2 mt-4 flex justify-center border-b-2", children: /* @__PURE__ */ jsx14(VacancyAdSummary, { vacancyKey: vacancy }) }),
    isSent && /* @__PURE__ */ jsx14("div", { className: "m-8", children: /* @__PURE__ */ jsx14(AlertMessage2, { message: "New Code Sent" }) }),
    isValidToken ? /* @__PURE__ */ jsx14("div", { className: "flex flex-col gap-4", children: /* @__PURE__ */ jsx14("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx14(
      CandidateAccountResetPasswordTerms,
      {
        email,
        resetCode: token,
        onDone: (result) => {
          onSignIn({ otacCode: result.otacCode });
        }
      }
    ) }) }) : /* @__PURE__ */ jsxs10("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx14("div", { className: "mx-4 mb-4 flex justify-center", children: /* @__PURE__ */ jsx14("div", { className: "text-primary-900", children: "Your password reset token is invalid." }) }),
      /* @__PURE__ */ jsx14("div", { className: "mx-4 mb-4 flex justify-center", children: /* @__PURE__ */ jsx14(
        CandidateAccountSendResetPassword,
        {
          email,
          onDone: () => {
            setIsSent(true);
          }
        }
      ) })
    ] })
  ] });
};

// src/public/vacancies/VacancyPublicApplyPage.tsx
import { useState as useState5 } from "react";
import { useNavigate as useNavigate6, useParams as useParams3 } from "react-router-dom";
import { VacancyApplyPublicContainer } from "feature-recruit";
import { useSetNextLocation as useSetNextLocation4 } from "shared-lib";
import { AppLogo as AppLogo2 } from "app-core";
import { useOIDC as useOIDC7 } from "app-core";
import { jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
function getApplicationLink(id) {
  return `/candidates/app/applications/${id}`;
}
function getApplicationAdLink(code) {
  return `/candidates/pub/ad/${code}`;
}
var VacancyPublicApplyPage = () => {
  const navigate = useNavigate6();
  const setLocation = useSetNextLocation4();
  const { vacancyCode } = useParams3();
  const { signInOTP, signIn } = useOIDC7();
  const [emailSent, setEmailSent] = useState5(false);
  if (emailSent) {
    return /* @__PURE__ */ jsx15("div", { className: "container mx-auto flex items-center justify-center", children: /* @__PURE__ */ jsxs11("div", { className: "mt-10 flex max-w-sm flex-col gap-5", children: [
      /* @__PURE__ */ jsx15("div", { children: /* @__PURE__ */ jsx15(AppLogo2, {}) }),
      /* @__PURE__ */ jsx15("h1", { className: "leading-1 text-lg font-bold", children: "Check your email to continue with your application" }),
      /* @__PURE__ */ jsx15("p", { children: "Your email address has been found has been found in our system. Please check your email for a link to continue your application." })
    ] }) });
  }
  const code = parseInt(vacancyCode);
  return /* @__PURE__ */ jsx15("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx15(
    VacancyApplyPublicContainer,
    {
      vacancyCode: code,
      onCompletedByEmail: () => {
        setEmailSent(true);
      },
      onCompleted: (id) => {
        navigate(getApplicationLink(id));
      },
      onSignInRedirect: () => {
        setLocation(getApplicationAdLink(code));
        signIn();
      },
      onCompletedSignIn: (context) => {
        setLocation(getApplicationLink(context.applicationId));
        signInOTP(context.otacCode);
      },
      onBack: () => {
        navigate(`../../`);
      },
      onFailed: (e) => {
        console.error(e);
      }
    }
  ) });
};

// src/public/AppCandidatesPublicLayout.tsx
import { Routes as Routes2, Route as Route2, useRouteError as useRouteError2 } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryFallback } from "app-core";
import { AuthError, LogLevel, useLogger as useLogger3 } from "shared-lib";
import { jsx as jsx16, jsxs as jsxs12 } from "react/jsx-runtime";
function ErrorPage2() {
  const error = useRouteError2();
  const [log] = useLogger3();
  log(error, LogLevel.ERROR);
  if (AuthError.isAuthError(error)) {
    return /* @__PURE__ */ jsxs12("div", { children: [
      /* @__PURE__ */ jsx16("p", { children: "Authentication Error" }),
      /* @__PURE__ */ jsx16("pre", { children: JSON.stringify(error) })
    ] });
  }
  return /* @__PURE__ */ jsxs12("div", { children: [
    /* @__PURE__ */ jsx16("p", { children: "Application Error" }),
    /* @__PURE__ */ jsx16("pre", { children: JSON.stringify(error) })
  ] });
}
var AppCandidatesPublicLayout = () => {
  return /* @__PURE__ */ jsx16(ErrorBoundary, { FallbackComponent: ErrorBoundaryFallback, children: /* @__PURE__ */ jsxs12(Routes2, { children: [
    /* @__PURE__ */ jsx16(
      Route2,
      {
        errorElement: /* @__PURE__ */ jsx16(ErrorPage2, {}),
        path: "signup",
        element: /* @__PURE__ */ jsx16(SignUpPage, {})
      }
    ),
    /* @__PURE__ */ jsx16(
      Route2,
      {
        path: "ad/:vacancyCode/*",
        errorElement: /* @__PURE__ */ jsx16(ErrorPage2, {}),
        element: /* @__PURE__ */ jsx16(VacancyPublicApplyPage, {})
      }
    ),
    /* @__PURE__ */ jsx16(
      Route2,
      {
        path: `rec/:id/:token/*`,
        errorElement: /* @__PURE__ */ jsx16(ErrorPage2, {}),
        element: /* @__PURE__ */ jsx16(PublicRecommendationPage, {})
      }
    ),
    /* @__PURE__ */ jsx16(
      Route2,
      {
        path: "apply-new-account/:applicationId/:vacancyId/:email/:token",
        errorElement: /* @__PURE__ */ jsx16(ErrorPage2, {}),
        element: /* @__PURE__ */ jsx16(VacancyApplyJobBoardNewAccountPage, {})
      }
    )
  ] }) });
};

// src/secure/account/pages/__generated__/AccountGeneralPageQuery.graphql.ts
var node8 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": "account",
      "args": null,
      "concreteType": "AccountCandidate",
      "kind": "LinkedField",
      "name": "accountCandidateViewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEmailVerified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasAgreedToTerms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileThumbNailImageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "AccountGeneralPageQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "AccountGeneralPageQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "5ec4e8bf4f05f41a0928b82d4216d34e",
      "id": null,
      "metadata": {},
      "name": "AccountGeneralPageQuery",
      "operationKind": "query",
      "text": "query AccountGeneralPageQuery {\n  account: accountCandidateViewer {\n    id\n    accountId\n    email\n    firstName\n    lastName\n    isEmailVerified\n    hasAgreedToTerms\n    profileImageUrl\n    profileThumbNailImageUrl\n  }\n}\n"
    }
  };
}();
node8.hash = "fd93ea3190725b11309db3cbe1a9c751";
var AccountGeneralPageQuery_graphql_default = node8;

// src/secure/account/pages/AccountGeneralPage.tsx
import { useCallback as useCallback4 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery3 } from "react-relay";
import { Button as Button6, LinkButton } from "shared-ui";
import { useToggle as useToggle2 } from "shared-lib";
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var AccountGeneralPageComponent = ({
  accountsUrl,
  account
}) => {
  const [isEditing, toggleIsEditing] = useToggle2();
  const onToggleIsEditing = useCallback4(() => {
    toggleIsEditing();
  }, [isEditing]);
  if (isEditing) {
    return /* @__PURE__ */ jsx17("div", { children: /* @__PURE__ */ jsx17(Button6, { color: "primary", title: "Edit", clicked: onToggleIsEditing, children: "Cancel" }) });
  }
  return /* @__PURE__ */ jsx17("div", { children: /* @__PURE__ */ jsxs13("div", { className: "mt-10 divide-y divide-gray-200", children: [
    /* @__PURE__ */ jsxs13("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsx17("h3", { className: "text-lg font-medium leading-6 text-gray-900", children: "Profile" }),
      /* @__PURE__ */ jsx17("p", { className: "max-w-2xl text-sm text-gray-500", children: "This information will be displayed publicly so be careful what you share." })
    ] }),
    /* @__PURE__ */ jsx17("div", { className: "mt-6", children: /* @__PURE__ */ jsxs13("dl", { className: "divide-y divide-gray-200", children: [
      /* @__PURE__ */ jsxs13("div", { className: "py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5", children: [
        /* @__PURE__ */ jsx17("dt", { className: "text-sm font-medium text-gray-500", children: "Name" }),
        /* @__PURE__ */ jsxs13("dd", { className: "mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0", children: [
          /* @__PURE__ */ jsxs13("span", { className: "flex-grow", children: [
            /* @__PURE__ */ jsx17("span", { children: account?.firstName }),
            " ",
            /* @__PURE__ */ jsx17("span", { children: account?.lastName })
          ] }),
          /* @__PURE__ */ jsx17("span", { className: "ml-4 flex-shrink-0", children: /* @__PURE__ */ jsx17(LinkButton, { label: "Update", clicked: onToggleIsEditing }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs13("div", { className: "py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:pt-5", children: [
        /* @__PURE__ */ jsx17("dt", { className: "text-sm font-medium text-gray-500", children: "Photo" }),
        /* @__PURE__ */ jsxs13("dd", { className: "mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0", children: [
          /* @__PURE__ */ jsx17("span", { className: "flex-grow", children: /* @__PURE__ */ jsx17(
            "img",
            {
              className: "h-8 w-8 rounded-full",
              src: "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
              alt: ""
            }
          ) }),
          /* @__PURE__ */ jsxs13("span", { className: "ml-4 flex flex-shrink-0 items-start space-x-4", children: [
            /* @__PURE__ */ jsx17(LinkButton, { label: "Update", clicked: onToggleIsEditing }),
            /* @__PURE__ */ jsx17("span", { className: "text-gray-300", "aria-hidden": "true", children: "|" }),
            /* @__PURE__ */ jsx17(LinkButton, { label: "Remove", clicked: onToggleIsEditing })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs13("div", { className: "py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:pt-5", children: [
        /* @__PURE__ */ jsx17("dt", { className: "text-sm font-medium text-gray-500", children: "Email" }),
        /* @__PURE__ */ jsxs13("dd", { className: "mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0", children: [
          /* @__PURE__ */ jsxs13("span", { className: "flex flex-grow items-center space-x-4", children: [
            /* @__PURE__ */ jsx17("div", { children: account?.email }),
            account?.isEmailVerified ? /* @__PURE__ */ jsx17("div", { className: "text-success-500 font-medium", children: "Verified" }) : /* @__PURE__ */ jsx17("div", { className: "text-danger-600 font-medium", children: "Verify Now" })
          ] }),
          /* @__PURE__ */ jsx17("span", { className: "ml-4 flex-shrink-0", children: /* @__PURE__ */ jsx17(LinkButton, { label: "Update", clicked: onToggleIsEditing }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs13("div", { className: "py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-b sm:border-gray-200 sm:py-5", children: [
        /* @__PURE__ */ jsx17("dt", { className: "text-lg font-medium text-gray-500", children: "Job title" }),
        /* @__PURE__ */ jsxs13("dd", { className: "mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0", children: [
          /* @__PURE__ */ jsx17("span", { className: "flex-grow", children: "CTO" }),
          /* @__PURE__ */ jsx17("span", { className: "ml-4 flex-shrink-0", children: /* @__PURE__ */ jsx17(LinkButton, { label: "Update", clicked: onToggleIsEditing }) })
        ] })
      ] })
    ] }) })
  ] }) });
};
var AccountGeneralPageWrapper = ({
  accountsUrl
}) => {
  const query = AccountGeneralPageQuery_graphql_default;
  const data = useLazyLoadQuery3(
    query,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx17(
    AccountGeneralPageComponent,
    {
      accountsUrl,
      account: data.account
    }
  );
};

// src/secure/account/pages/PasswordPage.tsx
import { useState as useState6 } from "react";
import { getPlatformDomain, useGlobalSettings } from "shared-lib";
import { ActionContainer, Button as Button7 } from "shared-ui";
import { jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var PasswordPageComponent = ({ onSave }) => {
  const globalSettings = useGlobalSettings();
  const changePasswordUrl = `${globalSettings.identityServerFullPath}/change-password`;
  return /* @__PURE__ */ jsxs14("div", { className: "container mx-auto flex flex-col gap-5 pt-5", children: [
    /* @__PURE__ */ jsx18(
      ActionContainer,
      {
        titleTop: "Update password",
        submitText: "Reset Password",
        onSubmit: () => {
          window.location.href = changePasswordUrl;
        },
        children: /* @__PURE__ */ jsx18("p", { className: "", children: "Click on the button below to reset your password. You will be redirected to reset your password." })
      }
    ),
    /* @__PURE__ */ jsxs14("div", { className: "flex flex-col justify-between gap-5 p-8 xl:flex-row xl:rounded-xl xl:border", children: [
      /* @__PURE__ */ jsxs14("div", { children: [
        /* @__PURE__ */ jsx18("h1", { className: "mb-5 grow text-gray-600", children: "Delete Account" }),
        /* @__PURE__ */ jsxs14("p", { className: "", children: [
          "To delete your account please contact us at",
          " ",
          /* @__PURE__ */ jsxs14(
            "a",
            {
              href: `mailto:support@${getPlatformDomain()}`,
              className: "text-primary-700",
              children: [
                " ",
                "support@",
                getPlatformDomain(),
                " "
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx18(
        "a",
        {
          href: `mailto:support@${getPlatformDomain()}`,
          className: "text-primary-900 flex self-end",
          children: /* @__PURE__ */ jsx18(
            Button7,
            {
              "aria-label": "Contact Us",
              className: "border border-black px-8 py-2 xl:max-w-sm",
              children: "Contact Us"
            }
          )
        }
      )
    ] })
  ] });
};
var PasswordPageWrapper = () => {
  const [passwordDetails, setPasswordDetails] = useState6({});
  return /* @__PURE__ */ jsx18(PasswordPageComponent, { onSave: setPasswordDetails });
};

// src/secure/account/pages/SignoutPage.tsx
import { useCallback as useCallback5 } from "react";
import { Button as Button8 } from "shared-ui";
import { useAuth } from "app-core";
import { jsx as jsx19 } from "react/jsx-runtime";
var SignOutPage = () => {
  const auth = useAuth();
  const onSignOut = useCallback5(async () => {
    await auth?.signOutRedirect();
  }, [auth]);
  return /* @__PURE__ */ jsx19(Button8, { color: "danger", onClick: onSignOut, children: "Sign out" });
};

// src/secure/account/pages/DebuggerPage.tsx
import { useCallback as useCallback6 } from "react";
import { useNavigate as useNavigate7 } from "react-router-dom";
import { DebuggerConfig } from "app-core";
import { jsx as jsx20 } from "react/jsx-runtime";
var DebuggerPage = () => {
  const navigate = useNavigate7();
  const onDone = useCallback6(() => {
    navigate("app");
  }, [navigate]);
  return /* @__PURE__ */ jsx20("div", { className: "container mx-auto flex flex-col gap-5 pt-5", children: /* @__PURE__ */ jsx20(DebuggerConfig, { onDone }) });
};

// src/secure/account/__generated__/AccountLayout_data.graphql.ts
var node9 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "kind": "RootArgument",
        "name": "candidateId"
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountLayout_data",
    "selections": [
      {
        "alias": "account",
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "accountCandidateAccountViewer",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGdprConsented",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAgreedToTerms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuspended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnonymised",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CandidateAccountSetupContainer_account"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContactDetailRoutes_account"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "profile",
        "args": null,
        "concreteType": "RecruitProfile",
        "kind": "LinkedField",
        "name": "recruitProfileViewerGetOrCreate",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RateEditor_RecruitProfile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AvailabilityEditor_RecruitProfile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LocationsFragment_RecruitProfile"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "recommendations",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "candidateId"
          }
        ],
        "concreteType": "RecruitRecommendation",
        "kind": "LinkedField",
        "name": "recruitRecommendationById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "globalTasks",
        "args": [
          {
            "kind": "Variable",
            "name": "candidateId",
            "variableName": "candidateId"
          }
        ],
        "concreteType": "CandidateTaskGlobalGroup",
        "kind": "LinkedField",
        "name": "tasksCandidateGlobalTasks",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "groupId",
            "storageKey": null
          },
          v1,
          v2,
          {
            "alias": null,
            "args": null,
            "concreteType": "TasksCandidateTask",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": true,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateTaskId",
                "storageKey": null
              },
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CandidateTaskGroup",
                "kind": "LinkedField",
                "name": "group",
                "plural": false,
                "selections": [
                  v0,
                  v2
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node9.hash = "7aab2fc1d693314784b268480d101282";
var AccountLayout_data_graphql_default = node9;

// src/secure/account/AccountLayout.tsx
import { Suspense as Suspense4 } from "react";
import { useFragment as useFragment12 } from "react-relay";
import { ErrorBoundary as ErrorBoundary9 } from "react-error-boundary";
import {
  ArrowLeftOnRectangleIcon,
  CalendarDaysIcon,
  CreditCardIcon,
  DocumentIcon,
  GlobeAltIcon,
  LockClosedIcon,
  PhoneIcon,
  ShareIcon
} from "@heroicons/react/24/outline";
import { ErrorBoundaryFallback as ErrorBoundaryFallback9 } from "app-core";
import { EdSkeleton as EdSkeleton5, SectionedLayout } from "shared-ui";
import { ElevateEnvironment, getClientEnvironment } from "shared-lib";

// src/secure/contact-details/pages/__generated__/ContactDetailsEditor_account.graphql.ts
var node10 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactDetailsEditor_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CandidatePhoneVerification",
      "kind": "LinkedField",
      "name": "phone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryPrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneVerificationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDetailsComponent_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node10.hash = "e6618b596d068c110be7ff422a3d38a5";
var ContactDetailsEditor_account_graphql_default = node10;

// src/secure/contact-details/pages/ContactDetailsEditor.tsx
import { useFragment as useFragment4 } from "react-relay";

// src/secure/contact-details/pages/__generated__/ContactDetailsComponent_account.graphql.ts
var node11 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactDetailsComponent_account",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountNameEditor_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountEmailEditor_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidatePhoneContainer_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node11.hash = "1c81b10aa115ed33bc1aca7140721479";
var ContactDetailsComponent_account_graphql_default = node11;

// src/secure/contact-details/pages/ContactDetailsComponent.tsx
import { useFragment as useFragment3 } from "react-relay";
import { EditContainer, Pulse } from "shared-ui";
import {
  CandidateAccountEmailEditor,
  CandidateAccountNameEditor,
  CandidatePhoneContainer
} from "feature-candidate-accounts";
import { useToggle as useToggle3 } from "shared-lib";
import { jsx as jsx21, jsxs as jsxs15 } from "react/jsx-runtime";
var fragmentDef3 = ContactDetailsComponent_account_graphql_default;
var ContactDetailsComponent = ({
  accountId,
  name,
  email,
  telephoneNumber,
  phoneVerificationStatus,
  isEmailVerified,
  fragmentRef
}) => {
  const data = useFragment3(
    fragmentDef3,
    fragmentRef
  );
  const [updateNameVisible, toggleUpdateName] = useToggle3(false);
  const [updateEmailVisible, toggleUpdateEmail] = useToggle3(false);
  const [updatePhoneVisible, toggleUpdatePhone] = useToggle3(false);
  return /* @__PURE__ */ jsx21("div", { className: "mt-5 flex flex-col xl:container", children: /* @__PURE__ */ jsxs15("div", { className: "flex flex-col gap-5", children: [
    !updateNameVisible && /* @__PURE__ */ jsx21(
      EditContainer,
      {
        title: `Name`,
        value: name,
        onClick: toggleUpdateName
      }
    ),
    updateNameVisible && /* @__PURE__ */ jsx21(
      CandidateAccountNameEditor,
      {
        candidateId: accountId,
        fragmentRef: data,
        onSaved: toggleUpdateName,
        onCancel: toggleUpdateName
      }
    ),
    /* @__PURE__ */ jsxs15("div", { className: "relative", children: [
      !isEmailVerified && /* @__PURE__ */ jsx21("div", { className: "absolute -right-1 -top-1 z-10", children: /* @__PURE__ */ jsx21(Pulse, {}) }),
      !updateEmailVisible && /* @__PURE__ */ jsx21(
        EditContainer,
        {
          title: `Email Address ${isEmailVerified ? "(Verified)" : "(Not Verified)"}`,
          onClick: toggleUpdateEmail,
          value: email
        }
      )
    ] }),
    updateEmailVisible && /* @__PURE__ */ jsx21(
      CandidateAccountEmailEditor,
      {
        candidateId: accountId,
        fragmentRef: data,
        onSaved: toggleUpdateEmail,
        onCancel: toggleUpdateEmail
      }
    ),
    /* @__PURE__ */ jsxs15("div", { className: "relative", children: [
      phoneVerificationStatus !== "VERIFIED" && /* @__PURE__ */ jsx21("div", { className: "absolute -right-1 -top-1 z-10", children: /* @__PURE__ */ jsx21(Pulse, {}) }),
      !updatePhoneVisible && /* @__PURE__ */ jsx21(
        EditContainer,
        {
          title: "Phone Number",
          value: telephoneNumber,
          onClick: toggleUpdatePhone
        }
      ),
      updatePhoneVisible && /* @__PURE__ */ jsx21(
        CandidatePhoneContainer,
        {
          fragmentRef: data,
          onCancel: toggleUpdatePhone
        }
      )
    ] })
  ] }) });
};

// src/secure/contact-details/pages/ContactDetailsEditor.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
var fragmentDef4 = ContactDetailsEditor_account_graphql_default;
var ContactDetailsEditor = ({ fragmentRef }) => {
  const data = useFragment4(
    fragmentDef4,
    fragmentRef
  );
  let telephoneNumber = "Not Provided";
  if (data.phone.phoneCountryPrefix !== null && data.phone.phoneNumber !== null) {
    telephoneNumber = `+${data.phone.phoneCountryPrefix} ${data.phone.phoneNumber}`;
  }
  const query = {
    accountId: data.accountId,
    name: data.firstName + " " + data.lastName,
    email: data.email,
    telephoneNumber,
    phoneVerificationStatus: data.phone.phoneVerificationStatus,
    isEmailVerified: data.isEmailVerified
  };
  return /* @__PURE__ */ jsx22(ContactDetailsComponent, { ...query, fragmentRef: data });
};

// src/secure/contact-details/pages/__generated__/ContactDetailsNameContainer_account.graphql.ts
var node12 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactDetailsNameContainer_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountNameEditor_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node12.hash = "f035b8a363c3287bef3fd4581e2dde2d";
var ContactDetailsNameContainer_account_graphql_default = node12;

// src/secure/contact-details/pages/ContactDetailsNameContainer.tsx
import { useCallback as useCallback7 } from "react";
import { useNavigate as useNavigate8 } from "react-router-dom";
import { useFragment as useFragment5 } from "react-relay";
import { CandidateAccountNameEditor as CandidateAccountNameEditor2 } from "feature-candidate-accounts";
import { jsx as jsx23 } from "react/jsx-runtime";
var fragmentDef5 = ContactDetailsNameContainer_account_graphql_default;
var ContactDetailsNameContainer = ({
  candidateId,
  fragmentRef
}) => {
  const navigate = useNavigate8();
  const data = useFragment5(
    fragmentDef5,
    fragmentRef
  );
  const onSaved = useCallback7(() => {
    navigate("../");
  }, []);
  const onCancel = useCallback7(() => {
    navigate("../");
  }, []);
  return /* @__PURE__ */ jsx23("div", { children: /* @__PURE__ */ jsx23(
    CandidateAccountNameEditor2,
    {
      candidateId,
      fragmentRef: data,
      onSaved,
      onCancel
    }
  ) });
};

// src/secure/contact-details/pages/__generated__/ContactDetailsEmailContainer_account.graphql.ts
var node13 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactDetailsEmailContainer_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountEmailEditor_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node13.hash = "a732795f5fb08891af291d19044025f5";
var ContactDetailsEmailContainer_account_graphql_default = node13;

// src/secure/contact-details/pages/ContactDetailsEmailContainer.tsx
import { useCallback as useCallback8 } from "react";
import { useNavigate as useNavigate9 } from "react-router-dom";
import { useFragment as useFragment6 } from "react-relay";
import { CandidateAccountEmailEditor as CandidateAccountEmailEditor2 } from "feature-candidate-accounts";
import { jsx as jsx24 } from "react/jsx-runtime";
var fragmentDef6 = ContactDetailsEmailContainer_account_graphql_default;
var ContactDetailsEmailContainer = ({
  candidateId,
  fragmentRef
}) => {
  const navigate = useNavigate9();
  const data = useFragment6(
    fragmentDef6,
    fragmentRef
  );
  const onSaved = useCallback8(() => {
    navigate("../");
  }, []);
  const onCancel = useCallback8(() => {
    navigate("../");
  }, []);
  return /* @__PURE__ */ jsx24("div", { children: /* @__PURE__ */ jsx24(
    CandidateAccountEmailEditor2,
    {
      candidateId,
      fragmentRef: data,
      onSaved,
      onCancel
    }
  ) });
};

// src/secure/contact-details/__generated__/ContactDetailRoutes_account.graphql.ts
var node14 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactDetailRoutes_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDetailsEditor_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidatePhoneContainer_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDetailsNameContainer_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDetailsEmailContainer_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node14.hash = "8ccfc53df57070adadb85165a1e7b839";
var ContactDetailRoutes_account_graphql_default = node14;

// src/secure/contact-details/ContactDetailRoutes.tsx
import { Route as Route3, Routes as RouterRoutes } from "react-router-dom";
import { useFragment as useFragment7 } from "react-relay";
import { ErrorBoundary as ErrorBoundary2 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback2 } from "app-core";
import { CandidatePhoneContainer as CandidatePhoneContainer2 } from "feature-candidate-accounts";
import { Fragment as Fragment6, jsx as jsx25, jsxs as jsxs16 } from "react/jsx-runtime";
var fragmentDef7 = ContactDetailRoutes_account_graphql_default;
var ContactDetailRoutes = ({
  fragmentRef
}) => {
  const data = useFragment7(
    fragmentDef7,
    fragmentRef
  );
  if (!data) {
    return /* @__PURE__ */ jsx25(Fragment6, { children: "Loading" });
  }
  return /* @__PURE__ */ jsx25(ErrorBoundary2, { FallbackComponent: ErrorBoundaryFallback2, children: /* @__PURE__ */ jsxs16(RouterRoutes, { children: [
    /* @__PURE__ */ jsx25(Route3, { path: "*", element: /* @__PURE__ */ jsx25(ContactDetailsEditor, { fragmentRef: data }) }),
    /* @__PURE__ */ jsx25(
      Route3,
      {
        path: "/name",
        element: /* @__PURE__ */ jsx25(
          ContactDetailsNameContainer,
          {
            candidateId: data.accountId,
            fragmentRef: data
          }
        )
      }
    ),
    /* @__PURE__ */ jsx25(
      Route3,
      {
        path: "/email-address",
        element: /* @__PURE__ */ jsx25(
          ContactDetailsEmailContainer,
          {
            candidateId: data.accountId,
            fragmentRef: data
          }
        )
      }
    ),
    /* @__PURE__ */ jsx25(
      Route3,
      {
        path: "/telephone-number",
        element: /* @__PURE__ */ jsx25(CandidatePhoneContainer2, { fragmentRef: data })
      }
    )
  ] }) });
};

// src/secure/availability/pages/__generated__/AvailabilityEditor_RecruitProfile.graphql.ts
var node15 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AvailabilityEditor_RecruitProfile",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitProfileId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileAvailability",
        "kind": "LinkedField",
        "name": "availability",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobSearchStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "availability",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  v0,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  }
                ],
                "type": "CandidateAvailableFromDate",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  v0,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "immediately",
                    "storageKey": null
                  }
                ],
                "type": "CandidateAvailableImmediately",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  v0,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeframe",
                    "storageKey": null
                  }
                ],
                "type": "CandidateAvailableNotice",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node15.hash = "e1b07210d862fdf3ae2527757f1cdcc9";
var AvailabilityEditor_RecruitProfile_graphql_default = node15;

// src/secure/availability/pages/__generated__/AvailabilityEditorMutation.graphql.ts
var node16 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobSearchStatus",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "immediately",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "notice",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timeframe",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v9 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v8,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v8
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AvailabilityEditorMutation",
      "selections": [
        {
          "alias": "availability",
          "args": v1,
          "concreteType": "RecruitCandidateAvailabilityUpdate2Payload",
          "kind": "LinkedField",
          "name": "recruitCandidateAvailabilityUpdate2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateAvailability",
              "kind": "LinkedField",
              "name": "edgeOfCandidateAvailability",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "availability",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            v3,
                            v4
                          ],
                          "type": "CandidateAvailableFromDate",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            v3,
                            v5
                          ],
                          "type": "CandidateAvailableImmediately",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            v3,
                            v6,
                            v7
                          ],
                          "type": "CandidateAvailableNotice",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AvailabilityEditorMutation",
      "selections": [
        {
          "alias": "availability",
          "args": v1,
          "concreteType": "RecruitCandidateAvailabilityUpdate2Payload",
          "kind": "LinkedField",
          "name": "recruitCandidateAvailabilityUpdate2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateAvailability",
              "kind": "LinkedField",
              "name": "edgeOfCandidateAvailability",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "availability",
                      "plural": false,
                      "selections": [
                        v3,
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            v4
                          ],
                          "type": "CandidateAvailableFromDate",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            v5
                          ],
                          "type": "CandidateAvailableImmediately",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            v6,
                            v7
                          ],
                          "type": "CandidateAvailableNotice",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fe3f8c61edb93832dc3d2d1211d4cae6",
      "id": null,
      "metadata": {},
      "name": "AvailabilityEditorMutation",
      "operationKind": "mutation",
      "text": "mutation AvailabilityEditorMutation(\n  $input: RecruitCandidateAvailabilityUpdate2Input!\n) {\n  availability: recruitCandidateAvailabilityUpdate2(input: $input) {\n    edgeOfCandidateAvailability {\n      node {\n        jobSearchStatus\n        availability {\n          __typename\n          ... on CandidateAvailableFromDate {\n            __typename\n            date\n          }\n          ... on CandidateAvailableImmediately {\n            __typename\n            immediately\n          }\n          ... on CandidateAvailableNotice {\n            __typename\n            notice\n            timeframe\n          }\n        }\n        id\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node16.hash = "fe04f8efa8fe5aa20162b05297a38185";
var AvailabilityEditorMutation_graphql_default = node16;

// src/secure/availability/pages/AvailabilityEditor.tsx
import { useCallback as useCallback9, useMemo as useMemo2, useState as useState7 } from "react";
import { useFragment as useFragment8, useMutation as useMutation2 } from "react-relay";
import * as z2 from "zod";
import { Controller, useForm as useForm2 } from "react-hook-form";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod/dist/zod";
import {
  ActionContainer as ActionContainer2,
  Button as Button9,
  EditContainer as EditContainer2,
  Modal,
  RadioList
} from "shared-ui";
import {
  AlertMessage as AlertMessage3,
  ErrorField as ErrorField2,
  FormInput as FormInput2,
  FormInputRow,
  ListDirection,
  RadioListInput
} from "shared-ui";
import { createClientMutationId as createClientMutationId2, formatDate, useToggle as useToggle4 } from "shared-lib";
import { JobSearchStatusLabel } from "feature-recruit";
import { Fragment as Fragment7, jsx as jsx26, jsxs as jsxs17 } from "react/jsx-runtime";
var jobSearchStatusSchema = z2.union([
  z2.literal("ACTIVELY_LOOKING"),
  z2.literal("NOT_LOOKING"),
  z2.literal("PASSIVELY_LOOKING"),
  z2.literal("UNKNOWN"),
  z2.literal("%future added value")
]);
var noticeTimeframeSchema = z2.union([
  z2.literal("DAYS"),
  z2.literal("MONTHS"),
  z2.literal("WEEKS"),
  z2.literal("%future added value")
]);
var immediatelyInputSchema = z2.object({
  dummy: z2.number()
});
var fromDateInputSchema = z2.object({
  date: z2.string().nonempty("Date is required")
});
var noticePeriodInputSchema = z2.object({
  notice: z2.number().gt(0),
  timeframe: noticeTimeframeSchema
});
var availabilityInputSchema = z2.object({
  fromDate: fromDateInputSchema.optional().nullable(),
  immediately: immediatelyInputSchema.optional().nullable(),
  noticePeriod: noticePeriodInputSchema.optional().nullable()
});
var recruitCandidateAvailabilityUpdate2InputSchema = z2.object({
  availability: availabilityInputSchema,
  jobSearch: jobSearchStatusSchema
});
var jobSearchStatusList = [
  {
    id: "ACTIVELY_LOOKING",
    label: "Actively Looking"
  },
  {
    id: "PASSIVELY_LOOKING",
    label: "Passively Looking"
  },
  {
    id: "NOT_LOOKING",
    label: `Not Looking`
  }
];
var availabilityList = [
  {
    id: "CandidateAvailableImmediately",
    label: "Immediately"
  },
  {
    id: "CandidateAvailableFromDate",
    label: "From Date"
  },
  {
    id: "CandidateAvailableNotice",
    label: "After Notice Period"
  }
];
var noticeTimeframeList = [
  {
    id: "MONTHS",
    label: "Months"
  },
  {
    id: "WEEKS",
    label: "Weeks"
  },
  {
    id: "DAYS",
    label: "Days"
  }
];
var fragmentDef8 = AvailabilityEditor_RecruitProfile_graphql_default;
var mutationDef2 = AvailabilityEditorMutation_graphql_default;
var AvailabilityEditor = ({ fragmentRef }) => {
  const { recruitProfileId, availability } = useFragment8(
    fragmentDef8,
    fragmentRef
  );
  const [editVisible, toggleEditVisible] = useToggle4(false);
  const [commitMutation, isMutationInFlight] = useMutation2(mutationDef2);
  const avail = availability?.availability;
  const [criticalFailure, toggleCriticalFailure] = useToggle4(false);
  const [showWarning, setShowWarning] = useState7(false);
  const onSave = useCallback9(
    (form) => {
      commitMutation({
        variables: {
          input: {
            ...form,
            clientMutationId: createClientMutationId2(),
            profileId: recruitProfileId
          }
        },
        onError: (e) => {
          console.log(e.message);
          toggleCriticalFailure();
        },
        onCompleted: (response) => {
          if (response.availability.edgeOfCandidateAvailability) {
            console.log(response.availability.edgeOfCandidateAvailability);
            setCompleted(true);
            toggleEditVisible();
          }
        }
      });
    },
    [
      commitMutation,
      recruitProfileId,
      toggleCriticalFailure,
      toggleEditVisible
    ]
  );
  const availabilityDefault = useMemo2(() => {
    switch (avail?.__typename) {
      case "CandidateAvailableImmediately":
        return {
          immediately: {
            dummy: Number(avail.immediately)
          }
        };
      case "CandidateAvailableFromDate":
        return {
          fromDate: {
            date: formatDate(avail.date) || ""
          }
        };
      case "CandidateAvailableNotice":
        return {
          noticePeriod: {
            notice: Number(avail.notice) || 4,
            timeframe: avail.timeframe || "WEEKS"
          }
        };
    }
    return {
      immediately: {
        dummy: 1
      }
    };
  }, [
    avail?.__typename,
    avail?.date,
    avail.immediately,
    avail.notice,
    avail?.timeframe
  ]);
  const [availabilityState, setAvailabilityState] = useState7(
    avail.__typename || "CandidateAvailableImmediately"
  );
  const defaultValues = {
    jobSearch: availability?.jobSearchStatus || "ACTIVELY_LOOKING",
    availability: availabilityDefault
  };
  const {
    register,
    handleSubmit,
    getValues,
    reset,
    formState: { errors },
    control
  } = useForm2({
    resolver: zodResolver2(recruitCandidateAvailabilityUpdate2InputSchema),
    defaultValues
  });
  const [completed, setCompleted] = useState7(false);
  const onSubmit = handleSubmit(
    (data) => {
      if (data.jobSearch === "NOT_LOOKING" && !showWarning) {
        setShowWarning(true);
      } else {
        onSave(data);
      }
    },
    (invalid) => {
      console.log(invalid);
    }
  );
  const handleAction = () => {
    setShowWarning(false);
    onSubmit();
  };
  return /* @__PURE__ */ jsxs17("div", { className: "pt-5 xl:container", children: [
    criticalFailure ? /* @__PURE__ */ jsx26("div", { children: "A error has occurred, please try again" }) : null,
    completed ? /* @__PURE__ */ jsx26(AlertMessage3, { message: "Availability Updated" }) : null,
    !editVisible && /* @__PURE__ */ jsx26(
      EditContainer2,
      {
        value: /* @__PURE__ */ jsxs17("div", { className: "flex flex-col gap-3 font-medium text-gray-900 ", children: [
          /* @__PURE__ */ jsxs17("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ jsx26("div", { className: "text-gray-600", children: "Search Status:" }),
            /* @__PURE__ */ jsx26("div", { className: "", children: /* @__PURE__ */ jsx26(JobSearchStatusLabel, { status: getValues("jobSearch") }) })
          ] }),
          /* @__PURE__ */ jsxs17("div", { className: "flex flex-col gap-1 ", children: [
            /* @__PURE__ */ jsx26("div", { className: "text-gray-600", children: "Availability:" }),
            /* @__PURE__ */ jsxs17("div", { className: "", children: [
              availabilityState === "CandidateAvailableImmediately" && "Immediately",
              availabilityState === "CandidateAvailableFromDate" && `From ${formatDate(
                getValues("availability.fromDate.date")
              )}`,
              availabilityState === "CandidateAvailableNotice" && `After Notice Period (${getValues(
                "availability.noticePeriod.notice"
              )} ${getValues("availability.noticePeriod.timeframe")})`
            ] })
          ] })
        ] }),
        onClick: toggleEditVisible
      }
    ),
    editVisible && /* @__PURE__ */ jsxs17(Fragment7, { children: [
      /* @__PURE__ */ jsxs17(
        ActionContainer2,
        {
          onSubmit,
          isSaving: isMutationInFlight,
          showCancel: true,
          onCancel: () => {
            toggleEditVisible();
            setAvailabilityState(
              avail.__typename || "CandidateAvailableImmediately"
            );
            reset();
          },
          children: [
            /* @__PURE__ */ jsx26(FormInputRow, { name: "Job Search", title: "Search Status", children: /* @__PURE__ */ jsx26(
              RadioListInput,
              {
                name: "jobSearch",
                title: "Search Status",
                control,
                list: jobSearchStatusList,
                direction: ListDirection.Vertical
              }
            ) }),
            /* @__PURE__ */ jsxs17(FormInputRow, { name: "availability", title: "Availability", children: [
              /* @__PURE__ */ jsx26(
                Controller,
                {
                  control,
                  name: "availability",
                  render: ({ field: { onChange } }) => /* @__PURE__ */ jsx26(
                    RadioList,
                    {
                      title: "Availability",
                      list: availabilityList,
                      direction: ListDirection.Vertical,
                      value: availabilityState,
                      onChange: (item) => {
                        setAvailabilityState(item.id);
                        switch (item.id) {
                          case "CandidateAvailableImmediately":
                            onChange({
                              immediately: {
                                dummy: 1
                              }
                            });
                            break;
                          case "CandidateAvailableFromDate":
                            onChange({
                              fromDate: {
                                date: formatDate(avail.date) || ""
                              }
                            });
                            break;
                          case "CandidateAvailableNotice":
                            onChange({
                              noticePeriod: {
                                notice: avail.notice || 4,
                                timeframe: avail.timeframe || "WEEKS"
                              }
                            });
                        }
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx26(ErrorField2, { field: errors.availability })
            ] }),
            Object.keys(getValues("availability")).includes(
              "noticePeriod"
            ) && /* @__PURE__ */ jsx26(Fragment7, { children: /* @__PURE__ */ jsxs17(FormInputRow, { name: "noticeTimeframe", title: "Notice Timeframe", children: [
              /* @__PURE__ */ jsxs17("div", { className: "flex items-center space-x-2", children: [
                /* @__PURE__ */ jsx26(
                  FormInput2,
                  {
                    width: "w-16",
                    type: "number",
                    placeholder: " Notice Amount ",
                    name: "availability.noticePeriod.notice",
                    register
                  }
                ),
                /* @__PURE__ */ jsx26(
                  RadioListInput,
                  {
                    name: `availability.noticePeriod.timeframe`,
                    title: "Timeframe",
                    control,
                    list: noticeTimeframeList
                  }
                )
              ] }),
              /* @__PURE__ */ jsx26(
                ErrorField2,
                {
                  field: errors.availability?.noticePeriod?.notice
                }
              )
            ] }) }),
            Object.keys(getValues("availability")).includes("fromDate") && /* @__PURE__ */ jsx26("div", { children: /* @__PURE__ */ jsxs17(FormInputRow, { name: "availableFrom", title: "Available From", children: [
              /* @__PURE__ */ jsx26(
                FormInput2,
                {
                  type: "date",
                  placeholder: " From Date ",
                  name: "availability.fromDate.date",
                  register
                }
              ),
              /* @__PURE__ */ jsx26(ErrorField2, { field: errors.availability?.fromDate?.date })
            ] }) })
          ]
        }
      ),
      showWarning && /* @__PURE__ */ jsx26(
        Modal,
        {
          onClose: () => {
            setShowWarning(false);
          },
          children: /* @__PURE__ */ jsxs17("div", { className: "flex w-full flex-col  justify-center px-5 ", children: [
            /* @__PURE__ */ jsx26("h1", { className: "text-2xl", children: "Confirmation" }),
            /* @__PURE__ */ jsx26("div", { className: "h-1/4 rounded-xl bg-white py-4 lg:w-full lg:max-w-[1400px]", children: `Please note, that by setting your availability to "Not Looking" means that Employers will not be able to view any of your existing applications. In addition, you won't be able to receive any recommendations. If you would like your applications to be visible and to carry on receiving recommendations, click cancel` }),
            /* @__PURE__ */ jsxs17("div", { className: "flex w-full flex-row justify-between ", children: [
              /* @__PURE__ */ jsx26(
                Button9,
                {
                  className: "border border-black px-5 py-2 font-medium text-black",
                  title: "Cancel",
                  onClick: () => setShowWarning(false),
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ jsx26(
                Button9,
                {
                  className: " px-5 py-2 font-medium ",
                  color: "green",
                  title: "Confirm",
                  onClick: handleAction,
                  children: "Confirm"
                }
              )
            ] })
          ] })
        }
      )
    ] })
  ] });
};

// src/secure/availability/AvailabilityLayout.tsx
import { Route as Route4, Routes as RouterRoutes2 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary3 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback3 } from "app-core";
import { jsx as jsx27 } from "react/jsx-runtime";
var AvailabilityLayout = ({ fragmentRef }) => {
  return /* @__PURE__ */ jsx27(ErrorBoundary3, { FallbackComponent: ErrorBoundaryFallback3, children: /* @__PURE__ */ jsx27(RouterRoutes2, { children: /* @__PURE__ */ jsx27(
    Route4,
    {
      path: "*",
      element: /* @__PURE__ */ jsx27(AvailabilityEditor, { fragmentRef })
    }
  ) }) });
};

// src/secure/locations/pages/__generated__/LocationsFragment_RecruitProfile.graphql.ts
var node17 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LocationsFragment_RecruitProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node17.hash = "6aad1604e8ab39ae8cc7d8572cbf2c21";
var LocationsFragment_RecruitProfile_graphql_default = node17;

// src/secure/locations/pages/Locations.tsx
import { useFragment as useFragment9 } from "react-relay";
import { LocationsContainer } from "feature-recruit";
import { jsx as jsx28 } from "react/jsx-runtime";
var Locations = ({
  fragmentRef
}) => {
  const { recruitProfileId } = useFragment9(
    LocationsFragment_RecruitProfile_graphql_default,
    fragmentRef
  );
  return /* @__PURE__ */ jsx28(LocationsContainer, { profileId: recruitProfileId });
};

// src/secure/locations/LocationRoutes.tsx
import { Route as Route5, Routes as RouterRoutes3 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary4 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback4 } from "app-core";
import { jsx as jsx29 } from "react/jsx-runtime";
var LocationRoutes = ({
  fragmentRef
}) => {
  return /* @__PURE__ */ jsx29(ErrorBoundary4, { FallbackComponent: ErrorBoundaryFallback4, children: /* @__PURE__ */ jsx29(RouterRoutes3, { children: /* @__PURE__ */ jsx29(Route5, { path: "*", element: /* @__PURE__ */ jsx29(Locations, { fragmentRef }) }) }) });
};

// src/secure/rate/pages/__generated__/RateEditor_RecruitProfile.graphql.ts
var node18 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RateEditor_RecruitProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileRate",
      "kind": "LinkedField",
      "name": "rate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "payType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maximumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node18.hash = "bca8c3a2f851167b6f924c6436067fa6";
var RateEditor_RecruitProfile_graphql_default = node18;

// src/secure/rate/pages/__generated__/RateEditorMutation.graphql.ts
var node19 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minimumRateOfPay",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "maximumRateOfPay",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v8 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v7,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v7
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RateEditorMutation",
      "selections": [
        {
          "alias": "rate",
          "args": v1,
          "concreteType": "RecruitCandidateRateUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateRateUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidateRatePayload",
              "kind": "LinkedField",
              "name": "candidateRatePayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfCandidateRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2,
                        v3,
                        v4,
                        v5,
                        v6
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RateEditorMutation",
      "selections": [
        {
          "alias": "rate",
          "args": v1,
          "concreteType": "RecruitCandidateRateUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateRateUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidateRatePayload",
              "kind": "LinkedField",
              "name": "candidateRatePayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfCandidateRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2,
                        v3,
                        v4,
                        v5,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "eb48c461c60c2f6ac6225185000f17b4",
      "id": null,
      "metadata": {},
      "name": "RateEditorMutation",
      "operationKind": "mutation",
      "text": "mutation RateEditorMutation(\n  $input: RecruitCandidateRateUpdateInput!\n) {\n  rate: recruitCandidateRateUpdate(input: $input) {\n    candidateRatePayload {\n      rate {\n        node {\n          payType\n          minimumRateOfPay\n          maximumRateOfPay\n          countryCode\n          currencyCode\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node19.hash = "832d4ec775a06c891f736ad8b56c27e7";
var RateEditorMutation_graphql_default = node19;

// src/secure/rate/pages/RateEditor.tsx
import { useCallback as useCallback10, useState as useState8 } from "react";
import { useFragment as useFragment10, useMutation as useMutation3 } from "react-relay";
import { Suspense as Suspense3 } from "shared-ui";
import {
  createClientMutationId as createClientMutationId3,
  useToggle as useToggle5
} from "shared-lib";
import { Spinner, AlertMessage as AlertMessage4 } from "shared-ui";
import { UserErrorList } from "app-core";
import { RateForm } from "feature-candidate-accounts";
import { jsx as jsx30, jsxs as jsxs18 } from "react/jsx-runtime";
var PerDay = "PER_DAY";
var DefaultRate = {
  currencyCode: null,
  countryCode: null,
  maximumRateOfPay: 0,
  minimumRateOfPay: 1,
  payType: PerDay
};
var RateEditor = ({ fragmentRef }) => {
  const [completed, setCompleted] = useState8(false);
  const [criticalFailure, toggleCriticalFailure] = useToggle5(false);
  const [userErrors, setUserErrors] = useState8([]);
  const { rate, recruitProfileId } = useFragment10(
    RateEditor_RecruitProfile_graphql_default,
    fragmentRef
  );
  const [commitMutation, isMutationInFlight] = useMutation3(
    RateEditorMutation_graphql_default
  );
  const onSave = useCallback10(
    (isValid, form, onComplete) => {
      if (!form.max || !form.min || !form.payType || !form.countryCode) {
        return;
      }
      commitMutation({
        variables: {
          input: {
            profileId: recruitProfileId,
            clientMutationId: createClientMutationId3(),
            model: {
              countryCode: form.countryCode,
              isPrivate: false,
              max: form.max,
              min: form.min,
              payType: form.payType
            }
          }
        },
        onError: (e) => {
          console.log(e.message);
          toggleCriticalFailure();
        },
        onCompleted: (response) => {
          if (response.rate.candidateRatePayload?.rate) {
            console.log(response.rate.candidateRatePayload?.rate);
            setCompleted(true);
            onComplete();
          }
        }
      });
    },
    [commitMutation, recruitProfileId, toggleCriticalFailure]
  );
  return /* @__PURE__ */ jsx30("div", { className: "mt-5", children: /* @__PURE__ */ jsxs18(Suspense3, { fallback: /* @__PURE__ */ jsx30(Spinner, {}), children: [
    criticalFailure ? /* @__PURE__ */ jsx30("div", { children: "A error has occurred, please try again" }) : null,
    completed ? /* @__PURE__ */ jsx30(AlertMessage4, { message: "Rate Updated" }) : null,
    /* @__PURE__ */ jsx30(UserErrorList, { errors: userErrors }),
    /* @__PURE__ */ jsx30(
      RateForm,
      {
        onSave,
        isBusy: isMutationInFlight,
        rate: rate || DefaultRate
      }
    )
  ] }) });
};

// src/secure/rate/RateRoutes.tsx
import { Route as Route6, Routes as RouterRoutes4 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary5 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback5 } from "app-core";
import { jsx as jsx31 } from "react/jsx-runtime";
var RateRoutes = ({
  fragmentRef
}) => {
  return /* @__PURE__ */ jsx31(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback5, children: /* @__PURE__ */ jsx31(RouterRoutes4, { children: /* @__PURE__ */ jsx31(Route6, { path: "*", element: /* @__PURE__ */ jsx31(RateEditor, { fragmentRef }) }) }) });
};

// src/secure/right-to-work/pages/RightToAddPage.tsx
import { useNavigate as useNavigate10 } from "react-router-dom";
import { RightToWorkAdd } from "feature-recruit";
import { jsx as jsx32 } from "react/jsx-runtime";
var RightToAddPage = ({ candidateId }) => {
  const navigate = useNavigate10();
  return /* @__PURE__ */ jsx32("div", { children: /* @__PURE__ */ jsx32(
    RightToWorkAdd,
    {
      candidateId,
      onAdd: () => {
        navigate(`..`);
      },
      onCancel: () => {
        navigate(`../`);
      }
    }
  ) });
};

// src/secure/right-to-work/pages/__generated__/RightToEditPageQuery.graphql.ts
var node20 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "rightToWorkId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "rightToWorkId",
      "variableName": "rightToWorkId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rightToWorkId",
    "storageKey": null
  }, v4 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iso3",
      "storageKey": null
    },
    v2
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RightToEditPageQuery",
      "selections": [
        {
          "alias": "rightToWork",
          "args": v1,
          "concreteType": "RightToWork",
          "kind": "LinkedField",
          "name": "recruitRightToWorkGetById",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RightToWorkEditor_rightToWork"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RightToEditPageQuery",
      "selections": [
        {
          "alias": "rightToWork",
          "args": v1,
          "concreteType": "RightToWork",
          "kind": "LinkedField",
          "name": "recruitRightToWorkGetById",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateAccountId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryIso3",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "statusId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "otherCountryIso3",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visaType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visaNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "additionalInfo",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GeoCountry",
              "kind": "LinkedField",
              "name": "country",
              "plural": false,
              "selections": v4,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GeoCountry",
              "kind": "LinkedField",
              "name": "otherCountry",
              "plural": false,
              "selections": v4,
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fb708871d873e381be0833c559a7bd91",
      "id": null,
      "metadata": {},
      "name": "RightToEditPageQuery",
      "operationKind": "query",
      "text": "query RightToEditPageQuery(\n  $rightToWorkId: UUID!\n) {\n  rightToWork: recruitRightToWorkGetById(rightToWorkId: $rightToWorkId) {\n    id\n    rightToWorkId\n    ...RightToWorkEditor_rightToWork\n  }\n}\n\nfragment RightToWorkEditor_rightToWork on RightToWork {\n  id\n  rightToWorkId\n  createdAt\n  updatedAt\n  candidateAccountId\n  countryIso3\n  status\n  statusId\n  otherCountryIso3\n  visaType\n  visaNumber\n  additionalInfo\n  country {\n    name\n    iso3\n    id\n  }\n  otherCountry {\n    name\n    iso3\n    id\n  }\n}\n"
    }
  };
}();
node20.hash = "1c361172a6b05c289c38b40be893058f";
var RightToEditPageQuery_graphql_default = node20;

// src/secure/right-to-work/pages/RightToEditPage.tsx
import { useNavigate as useNavigate11, useParams as useParams4 } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery4 } from "react-relay";
import { RightToWorkEdit } from "feature-recruit";
import { jsx as jsx33 } from "react/jsx-runtime";
var queryDef3 = RightToEditPageQuery_graphql_default;
var RightToEditPage = ({ candidateId }) => {
  const navigate = useNavigate11();
  const { id } = useParams4();
  const query = useLazyLoadQuery4(
    queryDef3,
    { rightToWorkId: id },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx33("div", { children: /* @__PURE__ */ jsx33(
    RightToWorkEdit,
    {
      candidateId,
      fragmentRef: query.rightToWork,
      onCancel: () => {
        navigate(`../`);
      },
      onDeleted: () => {
        navigate(`../`);
      }
    }
  ) });
};

// src/secure/right-to-work/pages/__generated__/RightToWorkListPageQuery.graphql.ts
var node21 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v3 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v4 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v5 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    v4
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "iso3",
    "storageKey": null
  }, v10 = [
    v8,
    v9,
    v7
  ], v11 = {
    "alias": null,
    "args": null,
    "concreteType": "GeoCountry",
    "kind": "LinkedField",
    "name": "country",
    "plural": false,
    "selections": v10,
    "storageKey": null
  }, v12 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "DESC"
      }
    },
    v4
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2,
        v3
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "RightToWorkListPageQuery",
      "selections": [
        {
          "alias": "rightToWorkCountries",
          "args": v5,
          "concreteType": "RecruitRightsToWorkConnection",
          "kind": "LinkedField",
          "name": "recruitRightsToWork",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRightsToWorkEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v6,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "country",
                      "plural": false,
                      "selections": [
                        v8,
                        v9
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RightToWorkList_rightsToWork"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v3,
        v0,
        v1,
        v2
      ],
      "kind": "Operation",
      "name": "RightToWorkListPageQuery",
      "selections": [
        {
          "alias": "rightToWorkCountries",
          "args": v5,
          "concreteType": "RecruitRightsToWorkConnection",
          "kind": "LinkedField",
          "name": "recruitRightsToWork",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRightsToWorkEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v6,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v7,
                    v11
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "rightsToWork",
          "args": v12,
          "concreteType": "RecruitRightsToWorkConnection",
          "kind": "LinkedField",
          "name": "recruitRightsToWork",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRightsToWorkEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v6,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateAccountId",
                      "storageKey": null
                    },
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryIso3",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "statusId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "otherCountryIso3",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "otherCountry",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visaType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visaNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "additionalInfo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "rightsToWork",
          "args": v12,
          "filters": [],
          "handle": "connection",
          "key": "RightToWorkList_rightsToWork",
          "kind": "LinkedHandle",
          "name": "recruitRightsToWork"
        }
      ]
    },
    "params": {
      "cacheID": "bb3225f4662f9d6890669306e49a0ad3",
      "id": null,
      "metadata": {},
      "name": "RightToWorkListPageQuery",
      "operationKind": "query",
      "text": "query RightToWorkListPageQuery(\n  $where: RightToWorkFilter!\n  $after: String\n  $first: Int\n  $order: [RightToWorkSort!]\n) {\n  rightToWorkCountries: recruitRightsToWork(first: $first, after: $after, order: $order, where: $where) {\n    edges {\n      cursor\n      node {\n        id\n        country {\n          name\n          iso3\n          id\n        }\n      }\n    }\n  }\n  ...RightToWorkList_rightsToWork\n}\n\nfragment RightToWorkList_rightsToWork on Query {\n  rightsToWork: recruitRightsToWork(first: 10, order: {createdAt: DESC}, where: $where) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        rightToWorkId\n        createdAt\n        updatedAt\n        candidateAccountId\n        country {\n          name\n          iso3\n          id\n        }\n        countryIso3\n        status\n        statusId\n        otherCountryIso3\n        otherCountry {\n          name\n          iso3\n          id\n        }\n        visaType\n        visaNumber\n        additionalInfo\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node21.hash = "3802cd7dc5c8b222dec64acd43b5cfd0";
var RightToWorkListPageQuery_graphql_default = node21;

// src/secure/right-to-work/pages/RightToWorkListPage.tsx
import { useLazyLoadQuery as useLazyLoadQuery5 } from "react-relay";
import { useNavigate as useNavigate12 } from "react-router-dom";
import { ActionContainer as ActionContainer3, EditContainer as EditContainer3 } from "shared-ui";
import { RightToWorkList } from "feature-recruit";
import { useToggle as useToggle6 } from "shared-lib";
import { jsx as jsx34, jsxs as jsxs19 } from "react/jsx-runtime";
var queryDef4 = RightToWorkListPageQuery_graphql_default;
var RightToWorkListPage = ({ candidateId }) => {
  const navigate = useNavigate12();
  const where = {
    candidateAccountId: { eq: candidateId }
  };
  const query = useLazyLoadQuery5(
    queryDef4,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [isEditable, toggleEditable] = useToggle6(false);
  return /* @__PURE__ */ jsxs19("div", { className: "pt-5 xl:container", children: [
    !isEditable && /* @__PURE__ */ jsx34(
      EditContainer3,
      {
        onClick: toggleEditable,
        title: "Countries you have the right to work in",
        value: /* @__PURE__ */ jsx34("ul", { children: query.rightToWorkCountries?.edges?.map(({ node: node39 }) => /* @__PURE__ */ jsx34("li", { children: node39.country?.name }, node39.id)) })
      }
    ),
    isEditable && /* @__PURE__ */ jsx34(
      ActionContainer3,
      {
        onCancel: toggleEditable,
        showCancel: true,
        submitText: "Add a Country",
        onSubmit: () => navigate("../add"),
        titleTop: `Countries you have the right to work in`,
        children: /* @__PURE__ */ jsx34(
          RightToWorkList,
          {
            fragmentRef: query,
            onSelect: (id) => {
              navigate(`../edit/${id}`);
            }
          }
        )
      }
    )
  ] });
};

// src/secure/right-to-work/RightToWorkRoutes.tsx
import { Route as Route7, Routes as RouterRoutes5 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary6 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback6 } from "app-core";
import { jsx as jsx35, jsxs as jsxs20 } from "react/jsx-runtime";
var RightToWorkRoutes = ({ candidateId }) => {
  return /* @__PURE__ */ jsx35(ErrorBoundary6, { FallbackComponent: ErrorBoundaryFallback6, children: /* @__PURE__ */ jsxs20(RouterRoutes5, { children: [
    /* @__PURE__ */ jsx35(
      Route7,
      {
        path: "add",
        element: /* @__PURE__ */ jsx35(RightToAddPage, { candidateId })
      }
    ),
    /* @__PURE__ */ jsx35(
      Route7,
      {
        path: "edit/:id",
        element: /* @__PURE__ */ jsx35(RightToEditPage, { candidateId })
      }
    ),
    /* @__PURE__ */ jsx35(
      Route7,
      {
        path: "*",
        element: /* @__PURE__ */ jsx35(RightToWorkListPage, { candidateId })
      }
    )
  ] }) });
};

// src/secure/talent-pools/__generated__/TalentPoolsLayoutQuery.graphql.ts
var node22 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    {
      "alias": "data",
      "args": null,
      "concreteType": "RecruitProfile",
      "kind": "LinkedField",
      "name": "recruitProfileViewerGetOrCreate",
      "plural": false,
      "selections": [
        v0,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recruitProfileId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitTalentPool",
          "kind": "LinkedField",
          "name": "talentPools",
          "plural": true,
          "selections": [
            v0,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "talentPoolId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolTheme",
              "kind": "LinkedField",
              "name": "customTheme",
              "plural": false,
              "selections": [
                v0,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "logoUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolsLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "TalentPoolsLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "d275801b62d69939b4570870fafab7a8",
      "id": null,
      "metadata": {},
      "name": "TalentPoolsLayoutQuery",
      "operationKind": "query",
      "text": "query TalentPoolsLayoutQuery {\n  data: recruitProfileViewerGetOrCreate {\n    id\n    recruitProfileId\n    talentPools {\n      id\n      talentPoolId\n      name\n      slug\n      enabled\n      customTheme {\n        id\n        logoUrl\n      }\n    }\n  }\n}\n"
    }
  };
}();
node22.hash = "76e005c367bfd0a93b373e972a1b1da3";
var TalentPoolsLayoutQuery_graphql_default = node22;

// src/secure/talent-pools/__generated__/TalentPoolsLayoutLeaveTalentPoolMutation.graphql.ts
var node23 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clientMutationId"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "profileId"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "talentPoolId"
  }, v3 = [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "clientMutationId",
          "variableName": "clientMutationId"
        },
        {
          "kind": "Variable",
          "name": "profileId",
          "variableName": "profileId"
        },
        {
          "kind": "Variable",
          "name": "talentPoolId",
          "variableName": "talentPoolId"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitProfile",
    "kind": "LinkedField",
    "name": "profile",
    "plural": false,
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPool",
        "kind": "LinkedField",
        "name": "talentPools",
        "plural": true,
        "selections": [
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolsLayoutLeaveTalentPoolMutation",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "RecruitTalentPoolMembershipLeavePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipLeave",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolMembership",
              "kind": "LinkedField",
              "name": "talentPoolMembership",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolMembership",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v2,
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "TalentPoolsLayoutLeaveTalentPoolMutation",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "RecruitTalentPoolMembershipLeavePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipLeave",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolMembership",
              "kind": "LinkedField",
              "name": "talentPoolMembership",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolMembership",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    v4
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a8b086285605f55eb3d2ab1196372e68",
      "id": null,
      "metadata": {},
      "name": "TalentPoolsLayoutLeaveTalentPoolMutation",
      "operationKind": "mutation",
      "text": "mutation TalentPoolsLayoutLeaveTalentPoolMutation(\n  $talentPoolId: UUID!\n  $profileId: UUID!\n  $clientMutationId: String!\n) {\n  recruitTalentPoolMembershipLeave(input: {talentPoolId: $talentPoolId, profileId: $profileId, clientMutationId: $clientMutationId}) {\n    talentPoolMembership {\n      node {\n        profile {\n          id\n          talentPools {\n            id\n            talentPoolId\n          }\n        }\n        id\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node23.hash = "7e63074a8c3c60231c9221222b828c33";
var TalentPoolsLayoutLeaveTalentPoolMutation_graphql_default = node23;

// src/secure/talent-pools/TalentPoolsLayout.tsx
import { useState as useState9, useCallback as useCallback11, useMemo as useMemo3 } from "react";
import { ErrorBoundary as ErrorBoundary7 } from "react-error-boundary";
import { useLazyLoadQuery as useLazyLoadQuery6, useMutation as useMutation4 } from "react-relay";
import { useLocation as useLocation2 } from "react-router-dom";
import { ErrorBoundaryFallback as ErrorBoundaryFallback7 } from "app-core";
import { Button as Button10, EdLink as EdLink3, EdSkeleton as EdSkeleton4 } from "shared-ui";
import { createClientMutationId as createClientMutationId4, getPlatformDomain as getPlatformDomain2 } from "shared-lib";
import { jsx as jsx36, jsxs as jsxs21 } from "react/jsx-runtime";
var queryDef5 = TalentPoolsLayoutQuery_graphql_default;
var leaveTalentPoolMutation = TalentPoolsLayoutLeaveTalentPoolMutation_graphql_default;
var TalentPoolsLayout = () => {
  const location = useLocation2();
  const query = useLazyLoadQuery6(
    queryDef5,
    {},
    { fetchPolicy: "store-and-network" }
  );
  const [commitMutation] = useMutation4(leaveTalentPoolMutation);
  const { data } = query;
  if (!data) {
    return /* @__PURE__ */ jsx36(EdSkeleton4, {});
  }
  const onSubmit = useCallback11(
    (talentPoolId) => {
      commitMutation({
        variables: {
          talentPoolId,
          profileId: data.recruitProfileId,
          clientMutationId: createClientMutationId4()
        }
      });
    },
    [commitMutation, data.recruitProfileId]
  );
  const activeTalentPools = useMemo3(() => {
    return location.pathname.includes("admin") ? data.talentPools : data.talentPools?.filter((pool) => pool.enabled);
  }, [data.talentPools, location.pathname]);
  return /* @__PURE__ */ jsx36(ErrorBoundary7, { FallbackComponent: ErrorBoundaryFallback7, children: /* @__PURE__ */ jsx36("div", { className: "container", children: /* @__PURE__ */ jsxs21("div", { className: "overflow-hidden rounded-2xl border", children: [
    data.talentPools.length == 0 && /* @__PURE__ */ jsx36("div", { className: "border px-5 py-4 text-center", children: "You are not subscribed to any talent pools" }),
    activeTalentPools?.map((pool) => /* @__PURE__ */ jsxs21(
      "div",
      {
        className: "hover:bg-secondary-100 flex w-full justify-between border-b bg-white px-5 py-5 hover:cursor-pointer",
        children: [
          /* @__PURE__ */ jsxs21("div", { className: "flex items-center gap-5", children: [
            pool.customTheme && /* @__PURE__ */ jsx36("img", { src: pool.customTheme?.logoUrl, className: "h-10" }),
            /* @__PURE__ */ jsx36("div", { children: pool.name })
          ] }),
          /* @__PURE__ */ jsx36(
            ActionButtons,
            {
              onSubmit: () => onSubmit(pool.talentPoolId),
              slug: pool.slug
            }
          )
        ]
      },
      pool.id
    ))
  ] }) }) });
};
var ActionButtons = ({
  onSubmit,
  slug
}) => {
  const [areYouSure, setAreYouSure] = useState9(false);
  const domain = getPlatformDomain2();
  return /* @__PURE__ */ jsxs21("div", { children: [
    !areYouSure && /* @__PURE__ */ jsxs21("div", { className: "flex gap-1", children: [
      /* @__PURE__ */ jsx36(
        EdLink3,
        {
          href: `https://vacancies.${domain}/talent-pool/${slug}`,
          name: `talent-pool-${slug}`,
          children: /* @__PURE__ */ jsx36(Button10, { "aria-label": "Go to talent pool", color: "primary", children: "Go to talent pool" })
        }
      ),
      /* @__PURE__ */ jsx36(
        Button10,
        {
          "aria-label": "Leave talent pool",
          color: "warning",
          onClick: () => setAreYouSure(true),
          children: "Leave talent pool"
        }
      )
    ] }),
    areYouSure && /* @__PURE__ */ jsxs21("div", { className: "flex flex-col items-center gap-2", children: [
      /* @__PURE__ */ jsx36("label", { className: "text-right", children: "Are you sure you want to leave this talent pool?" }),
      /* @__PURE__ */ jsx36("div", { className: "flex w-full justify-end", children: /* @__PURE__ */ jsxs21("div", { children: [
        /* @__PURE__ */ jsx36(Button10, { "aria-label": "Confirm", onClick: onSubmit, children: "Yes" }),
        /* @__PURE__ */ jsx36(Button10, { "aria-label": "Cancel", onClick: () => setAreYouSure(false), children: "No" })
      ] }) })
    ] })
  ] });
};

// src/secure/talent-pools/__generated__/TalentPoolSignUpFragment_RecruitProfile.graphql.ts
var node24 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TalentPoolSignUpFragment_RecruitProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node24.hash = "321e9501a31e4139864b0c94de3203d7";
var TalentPoolSignUpFragment_RecruitProfile_graphql_default = node24;

// src/secure/talent-pools/__generated__/TalentPoolSignUpQuery.graphql.ts
var node25 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "slug"
    }
  ], v1 = [
    {
      "alias": "talentPools",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "eq",
                  "variableName": "slug"
                }
              ],
              "kind": "ObjectValue",
              "name": "slug"
            }
          ],
          "kind": "ObjectValue",
          "name": "where"
        }
      ],
      "concreteType": "RecruitTalentPoolsConnection",
      "kind": "LinkedField",
      "name": "recruitTalentPools",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitTalentPoolsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPool",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "talentPoolId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "inviteOnly",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolSignUpQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolSignUpQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "5699e777144ec3973eaeebb0b0677bb7",
      "id": null,
      "metadata": {},
      "name": "TalentPoolSignUpQuery",
      "operationKind": "query",
      "text": "query TalentPoolSignUpQuery(\n  $slug: String!\n) {\n  talentPools: recruitTalentPools(where: {slug: {eq: $slug}}) {\n    edges {\n      node {\n        id\n        talentPoolId\n        slug\n        inviteOnly\n        name\n        description\n      }\n    }\n  }\n}\n"
    }
  };
}();
node25.hash = "bbc98362c87e2c85c30b213f1aaab4bd";
var TalentPoolSignUpQuery_graphql_default = node25;

// src/secure/talent-pools/__generated__/TalentPoolSignUpJoinTalentPoolMutation.graphql.ts
var node26 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitTalentPoolMembershipJoinPayload",
      "kind": "LinkedField",
      "name": "recruitTalentPoolMembershipJoin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfTalentPoolMembership",
          "kind": "LinkedField",
          "name": "talentPoolMembership",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolSignUpJoinTalentPoolMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolSignUpJoinTalentPoolMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "03d30b821f26da125a458519ac951709",
      "id": null,
      "metadata": {},
      "name": "TalentPoolSignUpJoinTalentPoolMutation",
      "operationKind": "mutation",
      "text": "mutation TalentPoolSignUpJoinTalentPoolMutation(\n  $input: RecruitTalentPoolMembershipJoinInput!\n) {\n  recruitTalentPoolMembershipJoin(input: $input) {\n    talentPoolMembership {\n      node {\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node26.hash = "414c879bb4e4bd79be93939e460aa9b4";
var TalentPoolSignUpJoinTalentPoolMutation_graphql_default = node26;

// src/secure/talent-pools/TalentPoolSignUp.tsx
import { useState as useState10 } from "react";
import { ErrorBoundary as ErrorBoundary8 } from "react-error-boundary";
import { useNavigate as useNavigate13, useParams as useParams5 } from "react-router-dom";
import {
  useFragment as useFragment11,
  useLazyLoadQuery as useLazyLoadQuery7,
  useMutation as useMutation5
} from "react-relay";
import { ErrorBoundaryFallback as ErrorBoundaryFallback8 } from "app-core";
import { createClientMutationId as createClientMutationId5 } from "shared-lib";
import { Button as Button11, Card as Card2, Error as Error2, Size as Size5 } from "shared-ui";
import { jsx as jsx37, jsxs as jsxs22 } from "react/jsx-runtime";
var fragmentDef9 = TalentPoolSignUpFragment_RecruitProfile_graphql_default;
function TalentPoolSignUp({
  fragmentRef
}) {
  const { slug } = useParams5();
  if (!slug) {
    return null;
  }
  return /* @__PURE__ */ jsx37(ErrorBoundary8, { FallbackComponent: ErrorBoundaryFallback8, children: /* @__PURE__ */ jsx37(TalentPoolSignUpComponent, { slug, fragmentRef }) });
}
function TalentPoolSignUpComponent({
  slug,
  fragmentRef
}) {
  const [joinTalentPool] = useMutation5(
    TalentPoolSignUp.mutations.joinTalentPool
  );
  const { talentPools } = useLazyLoadQuery7(
    TalentPoolSignUp.query,
    { slug }
  );
  const [errors, setErrors] = useState10(null);
  const { recruitProfileId } = useFragment11(fragmentDef9, fragmentRef);
  const navigate = useNavigate13();
  if (talentPools?.edges == null || talentPools?.edges == void 0 || talentPools?.edges.length === 0) {
    return /* @__PURE__ */ jsx37("div", { children: "Talent Pool not found" });
  }
  const talentPool = talentPools.edges[0];
  const talentPoolId = talentPool.node.talentPoolId;
  const redirectToTalentPools = () => {
    navigate("/candidates/app/account/talent-pools");
  };
  const handleJoinTalentPool = () => {
    if (!talentPoolId || !recruitProfileId) {
      return;
    }
    joinTalentPool({
      variables: {
        input: {
          clientMutationId: createClientMutationId5(),
          profileId: recruitProfileId,
          source: "website",
          talentPoolId
        }
      },
      onCompleted: () => {
        redirectToTalentPools();
      },
      onError: (error) => {
        setErrors(error.message);
      }
    });
  };
  return /* @__PURE__ */ jsx37(ErrorBoundary8, { FallbackComponent: ErrorBoundaryFallback8, children: /* @__PURE__ */ jsx37("div", { className: "mx-auto max-w-2xl py-10", children: /* @__PURE__ */ jsx37(Card2, { children: /* @__PURE__ */ jsxs22("div", { className: "flex flex-col gap-5", children: [
    /* @__PURE__ */ jsxs22("h1", { className: "text-2xl", children: [
      "Join the ",
      talentPool.node.name,
      " talent pool"
    ] }),
    /* @__PURE__ */ jsx37("div", { children: /* @__PURE__ */ jsx37("p", { children: talentPool.node.description }) }),
    /* @__PURE__ */ jsxs22("div", { className: "flex w-full flex-col justify-center", children: [
      /* @__PURE__ */ jsx37(
        Button11,
        {
          color: "primary",
          size: Size5.xl,
          onClick: handleJoinTalentPool,
          children: "Join"
        }
      ),
      /* @__PURE__ */ jsx37(Button11, { size: Size5.xl, onClick: redirectToTalentPools, children: "Cancel" })
    ] }),
    errors && /* @__PURE__ */ jsxs22(Error2, { className: "self-center rounded-2xl bg-red-400 px-2 py-1 text-white", children: [
      "This is a Private Talent Pool. Contact the",
      " ",
      /* @__PURE__ */ jsx37("a", { href: "mailto:support@myn.co.uk", children: "Talent Pool Administrator" }),
      " ",
      "for further details."
    ] })
  ] }) }) }) });
}
TalentPoolSignUp.query = TalentPoolSignUpQuery_graphql_default;
TalentPoolSignUp.mutations = {
  joinTalentPool: TalentPoolSignUpJoinTalentPoolMutation_graphql_default
};

// src/secure/account/pages/__generated__/DocumentsPageUrlQuery.graphql.ts
var node27 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentReferenceId"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "documentReferenceId",
          "variableName": "documentReferenceId"
        }
      ],
      "concreteType": "DocumentReferenceDownloadLink",
      "kind": "LinkedField",
      "name": "customDataDocumentReferenceDownloadLink",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentsPageUrlQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentsPageUrlQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "dd487a7995ad5a5c0e08e454591b75d8",
      "id": null,
      "metadata": {},
      "name": "DocumentsPageUrlQuery",
      "operationKind": "query",
      "text": "query DocumentsPageUrlQuery(\n  $documentReferenceId: UUID!\n) {\n  customDataDocumentReferenceDownloadLink(documentReferenceId: $documentReferenceId) {\n    url\n  }\n}\n"
    }
  };
}();
node27.hash = "e389a769b15c6f5f38d173660865d1c6";
var DocumentsPageUrlQuery_graphql_default = node27;

// src/secure/account/pages/__generated__/DocumentsPageQuery.graphql.ts
var node28 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "profileId"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "eq",
                  "variableName": "profileId"
                }
              ],
              "kind": "ObjectValue",
              "name": "ownerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "where"
        }
      ],
      "concreteType": "CustomDataDocumentReferencesConnection",
      "kind": "LinkedField",
      "name": "customDataDocumentReferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DocumentReference",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "source",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "container",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentTypeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentReferenceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DocumentsPageQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DocumentsPageQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ba7155f404e3194e7bbfeb03e9f57fd5",
      "id": null,
      "metadata": {},
      "name": "DocumentsPageQuery",
      "operationKind": "query",
      "text": "query DocumentsPageQuery(\n  $profileId: UUID!\n) {\n  customDataDocumentReferences(where: {ownerId: {eq: $profileId}}) {\n    nodes {\n      id\n      fileName\n      key\n      source\n      container\n      documentTypeId\n      documentReferenceId\n      url\n    }\n  }\n}\n"
    }
  };
}();
node28.hash = "532620e2ea4b4203c313fb300b79d8c9";
var DocumentsPageQuery_graphql_default = node28;

// src/secure/account/pages/DocumentsPage.tsx
import { useLazyLoadQuery as useLazyLoadQuery8 } from "react-relay";
import { Link as Link3 } from "react-router-dom";
import { ArrowDownCircleIcon } from "@heroicons/react/24/outline";
import { ActionContainer as ActionContainer4 } from "shared-ui";
import { useUserSessionContext } from "app-core";
import { Fragment as Fragment8, jsx as jsx38, jsxs as jsxs23 } from "react/jsx-runtime";
function DownloadDocument({
  documentReferenceId,
  fileName
}) {
  const data = useLazyLoadQuery8(DownloadDocument.query, {
    documentReferenceId
  });
  if (!data) {
    return /* @__PURE__ */ jsx38(Fragment8, {});
  }
  return /* @__PURE__ */ jsxs23(
    Link3,
    {
      to: data?.customDataDocumentReferenceDownloadLink?.url || "",
      className: "flex cursor-pointer justify-between p-5 hover:bg-gray-100",
      children: [
        fileName,
        /* @__PURE__ */ jsx38(ArrowDownCircleIcon, { className: "h-7 w-7 text-gray-500" })
      ]
    }
  );
}
DownloadDocument.query = DocumentsPageUrlQuery_graphql_default;
function DocumentsPageComponent() {
  const session = useUserSessionContext();
  const data = useLazyLoadQuery8(
    DocumentsPageComponent.query,
    {
      profileId: session.userId
    }
  );
  return /* @__PURE__ */ jsx38("div", { className: "container mx-auto flex flex-col gap-5 pt-5", children: /* @__PURE__ */ jsx38(ActionContainer4, { showSubmit: false, children: /* @__PURE__ */ jsx38("div", { className: "flex flex-col divide-y rounded-xl border", children: data.customDataDocumentReferences?.nodes?.map((document) => /* @__PURE__ */ jsx38(
    DownloadDocument,
    {
      documentReferenceId: document.documentReferenceId,
      fileName: document.fileName
    },
    document.id
  )) }) }) });
}
DocumentsPageComponent.query = DocumentsPageQuery_graphql_default;
var DocumentsPageWrapper = () => {
  return /* @__PURE__ */ jsx38(DocumentsPageComponent, {});
};

// src/secure/account/AccountLayout.tsx
import { jsx as jsx39, jsxs as jsxs24 } from "react/jsx-runtime";
var fragmentDef10 = AccountLayout_data_graphql_default;
var AccountLoading = () => {
  return /* @__PURE__ */ jsxs24("div", { className: "m-8", children: [
    /* @__PURE__ */ jsx39("div", { className: "p-4", children: "Loading Account...." }),
    /* @__PURE__ */ jsx39(EdSkeleton5, {})
  ] });
};
var SectionElement = ({ children }) => {
  return /* @__PURE__ */ jsx39("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var AccountLayout = ({ fragmentRef }) => {
  const data = useFragment12(fragmentDef10, fragmentRef);
  const environment = getClientEnvironment();
  const globalAccountTaskKeys = data.globalTasks.reduce(
    (a, c) => {
      return [...a, ...c.tasks.map(({ type }) => type)];
    },
    []
  );
  const sections = [
    {
      key: "contact-details",
      itemTitle: "Contact Details",
      listTitle: "Contact Details",
      icon: PhoneIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      highlight: ["VerifyPhoneCandidateTask", "VerifyEmailCandidateTask"].some(
        (x) => globalAccountTaskKeys.includes(x)
      ),
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(ContactDetailRoutes, { fragmentRef: data.account }) }) })
    },
    {
      key: "availability",
      itemTitle: "Availability",
      listTitle: "Availability",
      icon: CalendarDaysIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(AvailabilityLayout, { fragmentRef: data.profile }) }) })
    },
    {
      key: "locations",
      itemTitle: "Locations",
      listTitle: "Locations",
      icon: GlobeAltIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      highlight: ["WorkLocationsTask"].some(
        (x) => globalAccountTaskKeys.includes(x)
      ),
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(Locations, { fragmentRef: data.profile }) }) })
    },
    {
      key: "right-to-work",
      itemTitle: "Right to work",
      listTitle: "Right to work",
      icon: GlobeAltIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      highlight: ["RightToWorkTask"].some(
        (x) => globalAccountTaskKeys.includes(x)
      ),
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(RightToWorkRoutes, { candidateId: data.account?.accountId || "" }) }) })
    },
    {
      key: "rate",
      itemTitle: "Rate",
      listTitle: "Rate",
      icon: CreditCardIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      highlight: ["ClarifyRateApplicationTask"].some(
        (x) => globalAccountTaskKeys.includes(x)
      ),
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(RateRoutes, { fragmentRef: data.profile }) }) })
    },
    {
      key: "talent-pools",
      itemTitle: "Talent Pools",
      listTitle: "Talent Pools",
      icon: ShareIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(TalentPoolsLayout, {}) }) })
    },
    {
      key: "security",
      itemTitle: "Security",
      listTitle: "Security",
      icon: LockClosedIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(PasswordPageWrapper, {}) }) })
    },
    {
      key: "documents",
      itemTitle: "Documents",
      listTitle: "Documents",
      icon: DocumentIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(DocumentsPageWrapper, {}) }) })
    },
    {
      key: "logout",
      itemTitle: "Log out",
      listTitle: "Log out",
      icon: ArrowLeftOnRectangleIcon,
      iconForeground: "text-red-700",
      iconBackground: "bg-red-50",
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(SignOutPage, {}) }) })
    }
  ];
  if (environment !== ElevateEnvironment.Production) {
    sections.push({
      key: "debugger",
      itemTitle: "Debugger",
      listTitle: "Debugger",
      icon: LockClosedIcon,
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(AccountLoading, {}), children: /* @__PURE__ */ jsx39(SectionElement, { children: /* @__PURE__ */ jsx39(DebuggerPage, {}) }) })
    });
  }
  return /* @__PURE__ */ jsx39(Suspense4, { fallback: /* @__PURE__ */ jsx39(EdSkeleton5, {}), children: /* @__PURE__ */ jsx39(ErrorBoundary9, { FallbackComponent: ErrorBoundaryFallback9, children: /* @__PURE__ */ jsx39(SectionedLayout, { title: "Account", sections }) }) });
};

// src/secure/applications/pages/ApplicationPage.tsx
import { Suspense as Suspense5 } from "react";
import { useParams as useParams6 } from "react-router-dom";
import { EdSkeleton as EdSkeleton6 } from "shared-ui";
import { ApplicationContainer } from "feature-recruit";
import { jsx as jsx40 } from "react/jsx-runtime";
var ApplicationPage = ({
  title,
  candidateId
}) => {
  const { applicationId } = useParams6();
  return /* @__PURE__ */ jsx40(Suspense5, { fallback: /* @__PURE__ */ jsx40(EdSkeleton6, {}), children: /* @__PURE__ */ jsx40(
    ApplicationContainer,
    {
      showExpand: false,
      section: title,
      candidateId,
      applicationId
    }
  ) });
};
var ApplicationPage_default = ApplicationPage;

// src/secure/applications/ApplicationsLayout.tsx
import { Routes as Routes3, Route as Route8 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary10 } from "react-error-boundary";
import { ErrorContainer } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback10 } from "app-core";
import { ApplicationsContainer } from "feature-recruit";
import { jsx as jsx41, jsxs as jsxs25 } from "react/jsx-runtime";
var ApplicationsLayout = ({
  candidateId,
  defaultPath = "info",
  title = "Applications"
}) => {
  return /* @__PURE__ */ jsx41(ErrorBoundary10, { FallbackComponent: ErrorBoundaryFallback10, children: /* @__PURE__ */ jsxs25(Routes3, { children: [
    /* @__PURE__ */ jsx41(
      Route8,
      {
        path: "*",
        element: /* @__PURE__ */ jsx41(
          ApplicationsContainer,
          {
            title,
            defaultPath,
            candidateId
          }
        ),
        errorElement: /* @__PURE__ */ jsx41(ErrorContainer, {})
      }
    ),
    /* @__PURE__ */ jsx41(
      Route8,
      {
        path: `application/:applicationId/*`,
        element: /* @__PURE__ */ jsx41(ApplicationPage_default, { title: "Applications", candidateId }),
        errorElement: /* @__PURE__ */ jsx41(ErrorContainer, {})
      }
    ),
    /* @__PURE__ */ jsx41(
      Route8,
      {
        path: `task/:applicationId/*`,
        element: /* @__PURE__ */ jsx41(ApplicationPage_default, { title: "Tasks", candidateId }),
        errorElement: /* @__PURE__ */ jsx41(ErrorContainer, {})
      }
    )
  ] }) });
};

// src/secure/benefits/CandidatesBenefitsLayout.tsx
import { Navigate as Navigate3, Route as Route9, Routes as Routes4 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary11 } from "react-error-boundary";
import {
  BanknotesIcon,
  HeartIcon,
  SparklesIcon
} from "@heroicons/react/24/outline";
import { ErrorBoundaryFallback as ErrorBoundaryFallback11 } from "app-core";
import {
  Breadcrumbs,
  MobileHeader,
  SectionedLayout as SectionedLayout2
} from "shared-ui";

// src/secure/finance/RewardsLayout.tsx
import { Iframe } from "shared-ui";
import { jsx as jsx42 } from "react/jsx-runtime";
var url = "https://payroll.myn.co.uk/register/home";
var RewardsLayout = () => {
  return /* @__PURE__ */ jsx42("div", { className: "px-1 sm:m-4 sm:p-4", children: /* @__PURE__ */ jsx42(
    Iframe,
    {
      style: { height: 670 },
      className: "w-full overflow-y-scroll border-none",
      src: url
    }
  ) });
};

// src/secure/benefits/FinancialConsultationLayout.tsx
import { Button as Button12, Card as Card3, EdLink as EdLink4 } from "shared-ui";
import { jsx as jsx43, jsxs as jsxs26 } from "react/jsx-runtime";
var FinancialConsultationLayout = () => {
  return /* @__PURE__ */ jsx43("div", { className: "m-4 flex flex-col items-center justify-center gap-3 p-4", children: /* @__PURE__ */ jsx43("div", { className: "max-w-2xl", children: /* @__PURE__ */ jsx43(Card3, { children: /* @__PURE__ */ jsxs26("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx43("h1", { className: "text-xl font-bold", children: "Financial Consolutation" }),
    /* @__PURE__ */ jsxs26("div", { children: [
      /* @__PURE__ */ jsxs26("p", { children: [
        "We all need a little financial advice to help on life's journey.",
        " "
      ] }),
      /* @__PURE__ */ jsx43("p", { children: "Book a free consultation with one of our FCA registered adviser today for advice on investing, pensions, mortgages and savings." })
    ] }),
    /* @__PURE__ */ jsx43("div", { className: "my-4 flex justify-end", children: /* @__PURE__ */ jsx43(EdLink4, { href: "mailto:enquiries@myn.co.uk", name: "contact", children: /* @__PURE__ */ jsx43(Button12, { "aria-label": "Contact Us", color: "green", children: "Contact Us" }) }) })
  ] }) }) }) });
};

// src/secure/benefits/HealthLayout.tsx
import {
  ArrowPathIcon,
  CloudArrowUpIcon,
  FingerPrintIcon,
  LockClosedIcon as LockClosedIcon2
} from "@heroicons/react/24/outline";
import { jsx as jsx44, jsxs as jsxs27 } from "react/jsx-runtime";
var features = [
  {
    name: "Video consultations",
    description: "Life can be tough on our health. So we\u2019ve made talking to a doctor easy with our online GP appointments - Smple and convenient way to speak to a GP online, in as little as 30 minutes.",
    icon: CloudArrowUpIcon
  },
  {
    name: "E-Prescriptions & Referral Letters",
    description: "Simple, discreet and convenient. Same-day prescriptions for lifestyle and sexual health conditions.",
    icon: LockClosedIcon2
  },
  {
    name: "Medications delivered to your door",
    description: "When you order a treatment with us you can usually choose standard or express delivery, or collection from a pharmacy",
    icon: ArrowPathIcon
  },
  {
    name: "GDPR & HIPAA compliance",
    description: "We believe in giving you the best possible care, which includes taking care of your privacy so that you feel you can trust us and have confidence in the way we handle your information.",
    icon: FingerPrintIcon
  }
];
var HealthLayout = () => {
  return /* @__PURE__ */ jsx44("div", { children: /* @__PURE__ */ jsx44("div", { className: "bg-white py-24 sm:py-32", children: /* @__PURE__ */ jsxs27("div", { className: "mx-auto max-w-7xl px-6 lg:px-8", children: [
    /* @__PURE__ */ jsxs27("div", { className: "mx-auto max-w-2xl lg:text-center", children: [
      /* @__PURE__ */ jsx44("h2", { className: "text-primary-700 text-lg font-semibold leading-8 tracking-tight", children: "Coming Soon" }),
      /* @__PURE__ */ jsx44("p", { className: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl", children: "Online GP" }),
      /* @__PURE__ */ jsx44("p", { className: "mt-6 text-lg leading-8 text-gray-600", children: "Book an online consultation with a GP at a time that suits you best, letting you focus on the day job" })
    ] }),
    /* @__PURE__ */ jsx44("div", { className: "mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl", children: /* @__PURE__ */ jsx44("dl", { className: "grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16", children: features.map((feature) => /* @__PURE__ */ jsxs27("div", { className: "relative pl-16", children: [
      /* @__PURE__ */ jsxs27("dt", { className: "text-base font-semibold leading-7 text-gray-900", children: [
        /* @__PURE__ */ jsx44("div", { className: "bg-primary-400 absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg", children: /* @__PURE__ */ jsx44(
          feature.icon,
          {
            className: "h-6 w-6 text-white",
            "aria-hidden": "true"
          }
        ) }),
        feature.name
      ] }),
      /* @__PURE__ */ jsx44("dd", { className: "mt-2 text-base leading-7 text-gray-600", children: feature.description })
    ] }, feature.name)) }) })
  ] }) }) });
};

// src/secure/benefits/CandidatesBenefitsLayout.tsx
import { jsx as jsx45, jsxs as jsxs28 } from "react/jsx-runtime";
var ItemLayout = ({ children, links }) => {
  return /* @__PURE__ */ jsxs28("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx45("div", { className: "hidden border-b md:flex", children: /* @__PURE__ */ jsx45(Breadcrumbs, { homeText: "Benefits", homeHref: "..", links }) }),
    /* @__PURE__ */ jsx45("div", { children })
  ] });
};
var BenefitsLayout = () => {
  return /* @__PURE__ */ jsx45(
    SectionedLayout2,
    {
      title: "Benefits",
      sections: [
        {
          key: "rewards-and-benefits",
          listTitle: "Rewards & Benefits",
          itemTitle: "Rewards & Benefits",
          icon: SparklesIcon,
          iconBackground: "bg-gray-50",
          iconForeground: "text-gray-700",
          element: /* @__PURE__ */ jsx45(RewardsLayout, {})
        },
        {
          key: "financial-consultation",
          listTitle: "Financial Consultation",
          itemTitle: "Financial Consultation",
          icon: BanknotesIcon,
          iconBackground: "bg-gray-50",
          iconForeground: "text-gray-700",
          element: /* @__PURE__ */ jsx45(FinancialConsultationLayout, {})
        },
        {
          key: "health",
          listTitle: "Health & Well-being",
          itemTitle: "Health & Well-being",
          icon: HeartIcon,
          iconBackground: "bg-gray-50",
          iconForeground: "text-gray-700",
          element: /* @__PURE__ */ jsx45(HealthLayout, {})
        }
      ]
    }
  );
};
var CandidatesBenefitsLayout = () => {
  return /* @__PURE__ */ jsx45(ErrorBoundary11, { FallbackComponent: ErrorBoundaryFallback11, children: /* @__PURE__ */ jsx45(Routes4, { children: /* @__PURE__ */ jsxs28(Route9, { path: "/", element: /* @__PURE__ */ jsx45(BenefitsLayout, {}), children: [
    /* @__PURE__ */ jsx45(
      Route9,
      {
        path: "rewards-and-benefits/*",
        element: /* @__PURE__ */ jsxs28(ItemLayout, { links: [{ name: "Rewards", href: "" }], children: [
          /* @__PURE__ */ jsx45(
            MobileHeader,
            {
              title: /* @__PURE__ */ jsx45("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Rewards and Benefits" }),
              showBackButton: true
            }
          ),
          /* @__PURE__ */ jsx45(RewardsLayout, {})
        ] })
      }
    ),
    /* @__PURE__ */ jsx45(
      Route9,
      {
        path: "health/*",
        element: /* @__PURE__ */ jsxs28(ItemLayout, { links: [{ name: "Rewards", href: "" }], children: [
          /* @__PURE__ */ jsx45(
            MobileHeader,
            {
              title: /* @__PURE__ */ jsx45("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Health" }),
              showBackButton: true
            }
          ),
          /* @__PURE__ */ jsx45(HealthLayout, {})
        ] })
      }
    ),
    /* @__PURE__ */ jsx45(
      Route9,
      {
        path: "financial-consultation/*",
        element: /* @__PURE__ */ jsxs28(
          ItemLayout,
          {
            links: [{ name: "Financial Consultation", href: "" }],
            children: [
              /* @__PURE__ */ jsx45(
                MobileHeader,
                {
                  title: /* @__PURE__ */ jsx45("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Financial Consolutation" }),
                  showBackButton: true
                }
              ),
              /* @__PURE__ */ jsx45(FinancialConsultationLayout, {})
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsx45(Route9, { path: "*", element: /* @__PURE__ */ jsx45(Navigate3, { to: "./dashboard" }) })
  ] }) }) });
};

// src/secure/support/CandidatesSupportLayout.tsx
import { Navigate as Navigate4, Route as Route10, Routes as Routes5 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary12 } from "react-error-boundary";
import {
  LifebuoyIcon,
  ClipboardDocumentListIcon
} from "@heroicons/react/24/outline";
import { ErrorBoundaryFallback as ErrorBoundaryFallback12 } from "app-core";
import {
  Breadcrumbs as Breadcrumbs2,
  MobileHeader as MobileHeader2,
  SectionedLayout as SectionedLayout3
} from "shared-ui";

// src/secure/support/GetSupportLayout.tsx
import { Card as Card4, EdLink as EdLink5 } from "shared-ui";
import { jsx as jsx46, jsxs as jsxs29 } from "react/jsx-runtime";
var GetSupportLayout = () => {
  return /* @__PURE__ */ jsx46("div", { className: "flex flex-col items-center justify-center overflow-x-hidden px-1 sm:m-4 sm:p-4", children: /* @__PURE__ */ jsx46(Card4, { children: /* @__PURE__ */ jsx46("div", { className: "prose gap-10 bg-white p-3", children: /* @__PURE__ */ jsxs29("p", { children: [
    "Get in touch with the Support Team at",
    /* @__PURE__ */ jsx46(EdLink5, { href: "mailto:support@myn.co.uk", name: "contact", children: /* @__PURE__ */ jsxs29("span", { className: "text-primary-900 font-bold", children: [
      " ",
      "support@myn.co.uk"
    ] }) }),
    /* @__PURE__ */ jsx46("br", {}),
    "Alternatively, you can visit the",
    " ",
    /* @__PURE__ */ jsx46(
      EdLink5,
      {
        href: "https://app.chatwoot.com/hc/myn-candidates/en",
        name: "contact",
        children: /* @__PURE__ */ jsx46("span", { className: "text-primary-900 font-bold", children: "Candidate HelpCentre" })
      }
    ),
    " ",
    "for assistance."
  ] }) }) }) });
};

// src/secure/support/LegalLayout.tsx
import { EdLink as EdLink6 } from "shared-ui";
import { jsx as jsx47, jsxs as jsxs30 } from "react/jsx-runtime";
var LegalLayout = () => {
  const ListItemContainer = ({
    title,
    link
  }) => {
    return /* @__PURE__ */ jsx47("div", { className: "flex  justify-between rounded-lg bg-white px-6 py-5 xl:border", children: /* @__PURE__ */ jsx47(EdLink6, { href: link, name: title, children: /* @__PURE__ */ jsx47("div", { className: "text-primary-900", children: title }) }) });
  };
  return /* @__PURE__ */ jsx47("div", { className: "container mx-auto", children: /* @__PURE__ */ jsxs30("div", { className: "m-5 flex flex-col gap-5", children: [
    /* @__PURE__ */ jsx47(
      ListItemContainer,
      {
        title: "Privacy Notes / GDPR",
        link: "https://myn.co.uk/privacy-policy"
      }
    ),
    /* @__PURE__ */ jsx47(
      ListItemContainer,
      {
        title: "Terms & Conditions",
        link: "https://myn.co.uk/terms-and-conditions"
      }
    ),
    /* @__PURE__ */ jsx47(
      ListItemContainer,
      {
        title: "FAQ",
        link: "https://app.chatwoot.com/hc/myn-candidates/articles/1711472344-myn-candidate-fa_qs"
      }
    )
  ] }) });
};

// src/secure/support/CandidatesSupportLayout.tsx
import { jsx as jsx48, jsxs as jsxs31 } from "react/jsx-runtime";
var ItemLayout2 = ({ children, links }) => {
  return /* @__PURE__ */ jsxs31("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx48("div", { className: "hidden border-b md:flex", children: /* @__PURE__ */ jsx48(Breadcrumbs2, { homeText: "Get Support", homeHref: "..", links }) }),
    /* @__PURE__ */ jsx48("div", { children })
  ] });
};
var SupportLayout = () => {
  return /* @__PURE__ */ jsx48(
    SectionedLayout3,
    {
      title: "Support",
      sections: [
        {
          key: "get-support",
          listTitle: "Get Support",
          itemTitle: "Get Support",
          icon: LifebuoyIcon,
          iconBackground: "bg-gray-50",
          iconForeground: "text-gray-700",
          element: /* @__PURE__ */ jsx48(GetSupportLayout, {})
        },
        {
          key: "legal",
          listTitle: "Legal",
          itemTitle: "Legal",
          icon: ClipboardDocumentListIcon,
          iconBackground: "bg-gray-50",
          iconForeground: "text-gray-700",
          element: /* @__PURE__ */ jsx48(LegalLayout, {})
        }
      ]
    }
  );
};
var CandidatesSupportLayout = () => {
  return /* @__PURE__ */ jsx48(ErrorBoundary12, { FallbackComponent: ErrorBoundaryFallback12, children: /* @__PURE__ */ jsx48(Routes5, { children: /* @__PURE__ */ jsxs31(Route10, { path: "/", element: /* @__PURE__ */ jsx48(SupportLayout, {}), children: [
    /* @__PURE__ */ jsx48(
      Route10,
      {
        path: "get-support/*",
        element: /* @__PURE__ */ jsxs31(ItemLayout2, { links: [{ name: "Get Support", href: "" }], children: [
          /* @__PURE__ */ jsx48(
            MobileHeader2,
            {
              title: /* @__PURE__ */ jsx48("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Get Support" }),
              showBackButton: true
            }
          ),
          /* @__PURE__ */ jsx48(GetSupportLayout, {})
        ] })
      }
    ),
    /* @__PURE__ */ jsx48(
      Route10,
      {
        path: "legal/*",
        element: /* @__PURE__ */ jsxs31(ItemLayout2, { links: [{ name: "Legal", href: "" }], children: [
          /* @__PURE__ */ jsx48(
            MobileHeader2,
            {
              title: /* @__PURE__ */ jsx48("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Legal" }),
              showBackButton: true
            }
          ),
          /* @__PURE__ */ jsx48(LegalLayout, {})
        ] })
      }
    ),
    /* @__PURE__ */ jsx48(Route10, { path: "*", element: /* @__PURE__ */ jsx48(Navigate4, { to: "./dashboard" }) })
  ] }) }) });
};

// src/secure/compliance/Pages/Compliance.tsx
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { EdLink as EdLink7, Info, MultiColumn, Section } from "shared-ui";
import { Fragment as Fragment9, jsx as jsx49, jsxs as jsxs32 } from "react/jsx-runtime";
var CompliancePageComponent = () => {
  const content = /* @__PURE__ */ jsxs32(Fragment9, { children: [
    /* @__PURE__ */ jsx49(Section, { title: "Ongoing checks", children: /* @__PURE__ */ jsx49(EdLink7, { href: "./verify", name: "verify", children: /* @__PURE__ */ jsx49(
      Info,
      {
        label: "Verify experience with employer",
        value: "0 of 1 Recent experiences verified",
        icon: CheckCircleIcon
      }
    ) }) }),
    /* @__PURE__ */ jsx49(Section, { title: "Check history", children: /* @__PURE__ */ jsx49(
      Info,
      {
        label: "Verify experience with employer",
        value: "0 of 1 Recent experiences verified",
        icon: CheckCircleIcon
      }
    ) }),
    /* @__PURE__ */ jsx49(Section, { title: "No compliance checks started", children: /* @__PURE__ */ jsx49(
      Info,
      {
        label: "Verify experience with employer",
        value: "0 of 1 Recent experiences verified",
        icon: CheckCircleIcon
      }
    ) })
  ] });
  const header = /* @__PURE__ */ jsx49("div", { className: "w-full bg-gray-100", children: /* @__PURE__ */ jsxs32("div", { className: "h-full px-4 py-6 sm:px-6 lg:px-8", children: [
    /* @__PURE__ */ jsx49("h2", { className: "pb-1 text-2xl", children: "Compliance" }),
    /* @__PURE__ */ jsx49("p", { className: "text-sm", children: "Complete compliance steps to get started in new roles as fast as possible." })
  ] }) });
  return /* @__PURE__ */ jsx49(
    MultiColumn,
    {
      mainContent: content,
      sideContent: "",
      mainContentHeader: header
    }
  );
};
var CompliancePageLayout = () => {
  return /* @__PURE__ */ jsx49(CompliancePageComponent, {});
};

// src/secure/compliance/Pages/Verify.tsx
import {
  EdLink as EdLink8,
  Header,
  Info as Info2,
  JobDetails,
  MultiColumn as MultiColumn2,
  Progress,
  Tag
} from "shared-ui";
import { jsx as jsx50, jsxs as jsxs33 } from "react/jsx-runtime";
var verifiedCount = ({ experience, start, end }) => experience.slice(start, end).filter(({ status }) => status != "UNVERIFIED").length;
var jobDescription = ({ title, company, status, startDate, endDate, type, companyId }, key) => {
  return /* @__PURE__ */ jsxs33("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ jsx50(EdLink8, { href: `./${companyId}`, name: "company-verify", children: /* @__PURE__ */ jsx50(
      JobDetails,
      {
        title,
        company,
        startDate,
        endDate,
        type,
        status
      }
    ) }),
    /* @__PURE__ */ jsx50("div", { children: /* @__PURE__ */ jsx50(Tag, { size: "xsmall", children: status }) })
  ] }, key);
};
var VerifyPageComponent = ({ experience }) => {
  const content = /* @__PURE__ */ jsxs33("div", { className: "flex flex-col gap-5", children: [
    /* @__PURE__ */ jsxs33("div", { className: "flex flex-col justify-between sm:flex-row", children: [
      /* @__PURE__ */ jsx50(
        Info2,
        {
          label: "Recent Experience",
          value: "We recommend starting with your most recent experience and working backwards from there."
        }
      ),
      /* @__PURE__ */ jsx50("div", { className: "flex w-full pt-2 sm:w-3/12 sm:pl-4", children: /* @__PURE__ */ jsx50(
        Progress,
        {
          count: verifiedCount({ experience, start: 0, end: 1 }),
          total: experience.slice(0, 1).length
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx50("div", { className: "flex flex-col gap-5", children: experience.slice(0, 1).map(jobDescription) }),
    /* @__PURE__ */ jsxs33("div", { className: "flex flex-col justify-between sm:flex-row", children: [
      /* @__PURE__ */ jsx50(
        Info2,
        {
          label: "Older Experience",
          value: "We recommend starting with your most recent experience and working backwards from there."
        }
      ),
      /* @__PURE__ */ jsx50("div", { className: "flex w-full pt-2 sm:w-3/12 sm:pl-4", children: /* @__PURE__ */ jsx50(
        Progress,
        {
          count: verifiedCount({
            experience,
            start: 1,
            end: experience.length
          }),
          total: experience.slice(1, experience.length).length
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx50("div", { className: "flex flex-col gap-5", children: experience.slice(1, experience.length).map(jobDescription) })
  ] });
  const header = /* @__PURE__ */ jsx50(Header, { title: "Verify", children: "Verifying your work experience with employers is easy and can significantly speed up the recruitment process. Verification is not a reference. Instead it simply involes the employer confirming the dates and job titles given in your profile." });
  return /* @__PURE__ */ jsx50(
    MultiColumn2,
    {
      mainContent: content,
      sideContent: "",
      mainContentHeader: header
    }
  );
};
var VerifyPageLayout = () => {
  const experience = [
    {
      companyId: "12345",
      title: "Web Developer",
      company: "Luna IT Solutions",
      status: "UNVERIFIED",
      startDate: /* @__PURE__ */ new Date("2015-01-01"),
      endDate: /* @__PURE__ */ new Date(),
      type: "PERMANENT"
    },
    {
      companyId: "12345",
      title: "Web Developer",
      company: "Luna IT Solutions",
      status: "VERIFIED",
      startDate: /* @__PURE__ */ new Date("2015-01-01"),
      endDate: /* @__PURE__ */ new Date(),
      type: "PERMANENT"
    },
    {
      companyId: "12345",
      title: "Web Developer",
      company: "Luna IT Solutions",
      status: "UNVERIFIED",
      startDate: /* @__PURE__ */ new Date("2015-01-01"),
      endDate: /* @__PURE__ */ new Date(),
      type: "PERMANENT"
    },
    {
      companyId: "12345",
      title: "Web Developer",
      company: "Luna IT Solutions",
      status: "UNVERIFIED",
      startDate: /* @__PURE__ */ new Date("2015-01-01"),
      endDate: /* @__PURE__ */ new Date(),
      type: "PERMANENT"
    }
  ];
  return /* @__PURE__ */ jsx50(VerifyPageComponent, { experience });
};

// src/secure/compliance/Pages/VerifyEmployer.tsx
import { Input, FormBuilder } from "shared-ui";
import { jsx as jsx51 } from "react/jsx-runtime";
var VerifyEmployerPageComponent = ({
  experience
}) => {
  return /* @__PURE__ */ jsx51(
    FormBuilder,
    {
      headerTitle: "Verify Employer",
      headerDescription: "Verify your contact details",
      sectionTitle: "Enter your contact details here",
      layout: {
        contactFirstName: {
          key: "contactFirstName",
          component: Input,
          props: {
            label: "Contact First Name"
          }
        },
        contactLastName: {
          key: "contactLastName",
          component: Input,
          props: {
            label: "Contact Last Name"
          }
        },
        contactJobTitle: {
          key: "contactJobTitle",
          component: Input,
          props: {
            label: "Contact Job Title"
          }
        },
        contactEmailAddress: {
          key: "contactEmailAddress",
          component: Input,
          props: {
            label: "Contact Email Address"
          }
        }
      },
      onSave: function(model) {
        throw new Error("Function not implemented.");
      }
    }
  );
};
var VerifyEmployerPageLayout = () => {
  const experience = {
    companyId: "1234",
    title: "Web Developer",
    company: "Luna IT Solutions",
    status: "UNVERIFIED",
    startDate: /* @__PURE__ */ new Date("2015-01-01"),
    endDate: /* @__PURE__ */ new Date(),
    type: "PERMANENT"
  };
  return /* @__PURE__ */ jsx51(VerifyEmployerPageComponent, { experience });
};

// src/secure/compliance/Compliance.tsx
import { Route as Route11, Routes as Routes6 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary13 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback13 } from "app-core";
import { jsx as jsx52, jsxs as jsxs34 } from "react/jsx-runtime";
var ComplianceLayout = () => {
  return /* @__PURE__ */ jsx52(ErrorBoundary13, { FallbackComponent: ErrorBoundaryFallback13, children: /* @__PURE__ */ jsxs34(Routes6, { children: [
    /* @__PURE__ */ jsx52(Route11, { path: "*", element: /* @__PURE__ */ jsx52(CompliancePageComponent, {}) }),
    /* @__PURE__ */ jsx52(Route11, { path: "verify", element: /* @__PURE__ */ jsx52(VerifyPageLayout, {}) }),
    /* @__PURE__ */ jsx52(
      Route11,
      {
        path: "verify/:companyId",
        element: /* @__PURE__ */ jsx52(VerifyEmployerPageLayout, {})
      }
    )
  ] }) });
};

// src/secure/contracts/pages/Contracts.tsx
import {
  ChatBubbleLeftRightIcon,
  ChatBubbleOvalLeftIcon
} from "@heroicons/react/24/solid";
import { EdCard as EdCard2, Info as Info3, MultiColumn as MultiColumn3 } from "shared-ui";
import { jsx as jsx53, jsxs as jsxs35 } from "react/jsx-runtime";
var Contracts = () => {
  const contracts = [
    {
      name: "Contract 1"
    }
  ];
  const mainContent = /* @__PURE__ */ jsx53(ChatLayout, { contracts });
  return /* @__PURE__ */ jsx53(MultiColumn3, { mainContent, sideContent: void 0 });
};
var ChatLayout = ({ contracts }) => {
  return /* @__PURE__ */ jsx53("div", { children: contracts.map(({ name }, key) => /* @__PURE__ */ jsx53(EdCard2, { children: /* @__PURE__ */ jsx53(Info3, { icon: ChatBubbleOvalLeftIcon, label: name, value: name }) }, key)) });
};

// src/secure/contracts/Routes.tsx
import { Route as Route12, Routes as RouterRoutes6 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary14 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback14 } from "app-core";
import { jsx as jsx54 } from "react/jsx-runtime";
var Routes7 = () => {
  return /* @__PURE__ */ jsx54(ErrorBoundary14, { FallbackComponent: ErrorBoundaryFallback14, children: /* @__PURE__ */ jsx54(RouterRoutes6, { children: /* @__PURE__ */ jsx54(Route12, { path: "*", element: /* @__PURE__ */ jsx54(Contracts, {}) }) }) });
};

// src/secure/documents/pages/Documents.tsx
import { DocumentPlusIcon, FingerPrintIcon as FingerPrintIcon2 } from "@heroicons/react/24/solid";
import { MultiColumn as MultiColumn4, Header as Header2, Info as Info4, Button as Button13, EdLink as EdLink9 } from "shared-ui";
import { Fragment as Fragment10, jsx as jsx55, jsxs as jsxs36 } from "react/jsx-runtime";
var DocumentsComponent = ({ documents }) => {
  const header = /* @__PURE__ */ jsx55(Header2, { title: "Your Documents", children: "Upload your documents" });
  const content = /* @__PURE__ */ jsx55("div", { className: "flex flex-col gap-5", children: documents.map((document, i) => {
    return /* @__PURE__ */ jsxs36("div", { className: "flex w-full justify-between", children: [
      /* @__PURE__ */ jsx55(
        Info4,
        {
          icon: document.icon,
          label: document.label,
          value: /* @__PURE__ */ jsx55(Fragment10, { children: /* @__PURE__ */ jsx55("div", { children: document.description }) })
        }
      ),
      /* @__PURE__ */ jsx55("div", { children: /* @__PURE__ */ jsx55(EdLink9, { href: document.link, name: document.label, children: /* @__PURE__ */ jsx55(Button13, { "aria-label": "View/Edit", color: "primary", children: "View/Edit" }) }) })
    ] }, i);
  }) });
  return /* @__PURE__ */ jsx55(
    MultiColumn4,
    {
      mainContentHeader: header,
      mainContent: content,
      sideContent: void 0
    }
  );
};
var Documents = () => {
  const documents = [
    {
      link: "./signature",
      icon: FingerPrintIcon2,
      label: "Digital Signature",
      description: "You have created a signature"
    },
    {
      link: "./signature",
      icon: DocumentPlusIcon,
      label: "P45",
      description: "You havent uploaded your P45"
    }
  ];
  return /* @__PURE__ */ jsx55(DocumentsComponent, { documents });
};

// src/secure/documents/pages/Signature.tsx
import { FormBuilder as FormBuilder2, TextArea } from "shared-ui";
import { Fragment as Fragment11, jsx as jsx56 } from "react/jsx-runtime";
var Signature = () => {
  const layout = {
    name: {
      key: "name",
      component: ({ name }) => /* @__PURE__ */ jsx56(Fragment11, { children: name }),
      props: {
        name: ""
      }
    },
    signature: {
      key: "signature",
      component: ({ name }) => /* @__PURE__ */ jsx56(TextArea, { rows: 4, children: name }),
      props: {
        name: "Signature"
      }
    }
  };
  return /* @__PURE__ */ jsx56(
    FormBuilder2,
    {
      layout,
      headerTitle: "Signature",
      headerDescription: "Update your signature",
      sectionTitle: "",
      onSave: (model) => console.log(model)
    }
  );
};

// src/secure/documents/Routes.tsx
import { Route as Route13, Routes as RouterRoutes7 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary15 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback15 } from "app-core";
import { jsx as jsx57, jsxs as jsxs37 } from "react/jsx-runtime";
var Routes8 = () => {
  return /* @__PURE__ */ jsx57(ErrorBoundary15, { FallbackComponent: ErrorBoundaryFallback15, children: /* @__PURE__ */ jsxs37(RouterRoutes7, { children: [
    /* @__PURE__ */ jsx57(Route13, { path: "*", element: /* @__PURE__ */ jsx57(Documents, {}) }),
    /* @__PURE__ */ jsx57(Route13, { path: "/signature", element: /* @__PURE__ */ jsx57(Signature, {}) })
  ] }) });
};

// src/secure/jobs/JobsLayout.tsx
import { ErrorBoundary as ErrorBoundary17 } from "react-error-boundary";
import { Navigate as Navigate5, Route as Route15, Routes as Routes10, useRouteError as useRouteError3 } from "react-router-dom";
import { ErrorBoundaryFallback as ErrorBoundaryFallback17 } from "app-core";

// src/secure/recommendations/RecommendationsLayout.tsx
import { ErrorBoundary as ErrorBoundary16 } from "react-error-boundary";
import { Route as Route14, Routes as Routes9 } from "react-router-dom";
import { ErrorBoundaryFallback as ErrorBoundaryFallback16 } from "app-core";
import { RecommendationsContainer } from "feature-recruit";
import { jsx as jsx58 } from "react/jsx-runtime";
var RecommendationsLayout = ({
  candidateId
}) => {
  return /* @__PURE__ */ jsx58(ErrorBoundary16, { FallbackComponent: ErrorBoundaryFallback16, children: /* @__PURE__ */ jsx58(Routes9, { children: /* @__PURE__ */ jsx58(
    Route14,
    {
      path: "*",
      element: /* @__PURE__ */ jsx58(RecommendationsContainer, { candidateId })
    }
  ) }) });
};

// src/secure/recommendations/pages/RecommendationPage.tsx
import { Suspense as Suspense6 } from "react";
import { useParams as useParams7 } from "react-router-dom";
import { EdSkeleton as EdSkeleton7 } from "shared-ui";
import { RecommendationLoader } from "feature-recruit";
import { jsx as jsx59 } from "react/jsx-runtime";
var RecommendationPage = () => {
  const { recommendationId } = useParams7();
  return /* @__PURE__ */ jsx59(Suspense6, { fallback: /* @__PURE__ */ jsx59(EdSkeleton7, {}), children: /* @__PURE__ */ jsx59(
    RecommendationLoader,
    {
      showExpand: false,
      recommendationId,
      showHeader: true
    }
  ) });
};

// src/secure/jobs/JobsLayout.tsx
import { jsx as jsx60, jsxs as jsxs38 } from "react/jsx-runtime";
var ErrorPage3 = (props) => {
  const error = useRouteError3();
  return /* @__PURE__ */ jsxs38("div", { className: "m-8", children: [
    /* @__PURE__ */ jsx60("div", { className: "py-4", children: /* @__PURE__ */ jsx60("p", { children: "An error has occurred" }) }),
    /* @__PURE__ */ jsx60("div", { className: "border bg-yellow-50", children: /* @__PURE__ */ jsx60("pre", { children: JSON.stringify(error) }) })
  ] });
};
var JobsLayout = ({ candidateId }) => {
  return /* @__PURE__ */ jsx60(ErrorBoundary17, { FallbackComponent: ErrorBoundaryFallback17, children: /* @__PURE__ */ jsxs38(Routes10, { children: [
    /* @__PURE__ */ jsx60(
      Route15,
      {
        path: `recommendations/*`,
        errorElement: /* @__PURE__ */ jsx60(ErrorPage3, {}),
        element: /* @__PURE__ */ jsx60(RecommendationsLayout, { candidateId })
      }
    ),
    /* @__PURE__ */ jsx60(
      Route15,
      {
        path: `recommendation/:recommendationId/*`,
        errorElement: /* @__PURE__ */ jsx60(ErrorPage3, {}),
        element: /* @__PURE__ */ jsx60(RecommendationPage, {})
      }
    ),
    /* @__PURE__ */ jsx60(Route15, { path: "*", element: /* @__PURE__ */ jsx60(Navigate5, { to: "recommendations" }) })
  ] }) });
};

// src/secure/recruit/RecruitLayout.tsx
import { ErrorBoundary as ErrorBoundary18 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback18 } from "app-core";
import { jsx as jsx61 } from "react/jsx-runtime";
var RecruitLayout = () => {
  return /* @__PURE__ */ jsx61(ErrorBoundary18, { FallbackComponent: ErrorBoundaryFallback18, children: /* @__PURE__ */ jsx61("div", { className: "container", children: /* @__PURE__ */ jsx61("h2", { children: "Recruit" }) }) });
};

// src/secure/profile/__generated__/ProfilePageQuery.graphql.ts
var node29 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileId",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v15 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 8
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdOn": "DESC"
      }
    }
  ], v16 = {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPreviousPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerLogoUrl",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "concreteType": "Vacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      v13,
      v18,
      v19,
      v20,
      v4
    ],
    "storageKey": null
  }, v22 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v23 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v24 = {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }, v25 = [
    v24
  ], v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v28 = [
    v24,
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "DESC"
      }
    }
  ], v29 = [
    v24,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "code": "DESC"
        }
      ]
    },
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfilePageQuery",
      "selections": [
        {
          "alias": "profile",
          "args": null,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileViewerGetOrCreate",
          "plural": false,
          "selections": [
            v1,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProfileContainer_profile"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "account",
          "args": null,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountViewer",
          "plural": false,
          "selections": [
            v2,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProfileContainer_account"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileContainer_tasks"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileContainer_recommendations"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileContainer_interviews"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileContainer_applications"
        },
        {
          "args": [
            v3
          ],
          "kind": "FragmentSpread",
          "name": "ProfileContainer_recruitTalentPoolInvites"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfilePageQuery",
      "selections": [
        {
          "alias": "profile",
          "args": null,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileViewerGetOrCreate",
          "plural": false,
          "selections": [
            v1,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileSummary",
              "kind": "LinkedField",
              "name": "summary",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentJobTitleName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "prefersNoResume",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperience",
              "kind": "LinkedField",
              "name": "currentPosition",
              "plural": false,
              "selections": [
                v5,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyIsVerified",
                  "storageKey": null
                },
                v6,
                v7,
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "version",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "titleId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endDate",
                  "storageKey": null
                },
                v8,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "positionType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                v9
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileRate",
              "kind": "LinkedField",
              "name": "rate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "maximumRateOfPay",
                  "storageKey": null
                },
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minimumRateOfPay",
                  "storageKey": null
                },
                v10,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCode",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperienceCollection",
              "kind": "LinkedField",
              "name": "experiences",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    v4,
                    v9
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitResume",
              "kind": "LinkedField",
              "name": "resume",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "addedToProfile",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RightToWork",
              "kind": "LinkedField",
              "name": "rightToWork",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "account",
              "plural": false,
              "selections": [
                v2,
                v11,
                v12,
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileWorkLocations",
              "kind": "LinkedField",
              "name": "workLocations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentLocationCountryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentLocationCountryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentLocationName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentLocationLatitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentLocationLongitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentLocationRadius",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WorkLocationEntry",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": true,
                  "selections": [
                    v4,
                    v13,
                    v10,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entireCountry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "latitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "longitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "radius",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperience",
              "kind": "LinkedField",
              "name": "experience",
              "plural": true,
              "selections": [
                v4,
                v7,
                v5,
                v8
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileAvailability",
              "kind": "LinkedField",
              "name": "availability",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "jobSearchStatus",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "account",
          "args": null,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountViewer",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEmailVerified",
              "storageKey": null
            },
            v4,
            v11,
            v12,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSignUpComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasAgreedToTerms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGdprConsented",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "globalTasks",
          "args": [
            {
              "kind": "Variable",
              "name": "candidateId",
              "variableName": "candidateId"
            }
          ],
          "concreteType": "CandidateTaskGlobalGroup",
          "kind": "LinkedField",
          "name": "tasksCandidateGlobalTasks",
          "plural": true,
          "selections": [
            v4,
            v14,
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                v4,
                v6,
                v14
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "recommendations",
          "args": v15,
          "concreteType": "RecruitRecommendationsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendations",
          "plural": false,
          "selections": [
            v16,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v17,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitRecommendationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentStatus",
                      "storageKey": null
                    },
                    v21,
                    v22
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": 'recruitRecommendations(first:8,order:{"createdOn":"DESC"})'
        },
        {
          "alias": "recommendations",
          "args": v15,
          "filters": [],
          "handle": "connection",
          "key": "ProfileContainer_recommendations",
          "kind": "LinkedHandle",
          "name": "recruitRecommendations"
        },
        {
          "alias": "interviews",
          "args": v25,
          "concreteType": "RecruitInterviewsConnection",
          "kind": "LinkedField",
          "name": "recruitInterviews",
          "plural": false,
          "selections": [
            v16,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitInterviewsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v17,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitInterview",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "interviewId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    v26,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stage",
                      "storageKey": null
                    },
                    v27,
                    v14,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v13,
                        v18,
                        v20,
                        v19,
                        v4
                      ],
                      "storageKey": null
                    },
                    v22
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": "recruitInterviews(first:4)"
        },
        {
          "alias": "interviews",
          "args": v25,
          "filters": [],
          "handle": "connection",
          "key": "ProfileContainer_interviews",
          "kind": "LinkedHandle",
          "name": "recruitInterviews"
        },
        {
          "alias": null,
          "args": v28,
          "concreteType": "ApplicationsConnection",
          "kind": "LinkedField",
          "name": "applications",
          "plural": false,
          "selections": [
            v16,
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v17,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    v26,
                    v18,
                    v20,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedDocumentTypes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedForms",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedOptionalSkills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedRate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedRequiredSkills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    v21,
                    v22
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": 'applications(first:4,order:{"createdAt":"DESC"})'
        },
        {
          "alias": null,
          "args": v28,
          "filters": [],
          "handle": "connection",
          "key": "ProfileContainer_applications",
          "kind": "LinkedHandle",
          "name": "applications"
        },
        {
          "alias": null,
          "args": v29,
          "concreteType": "RecruitTalentPoolInvitesConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInvites",
          "plural": false,
          "selections": [
            v16,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolInvitesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v17,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolInvite",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    v27,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "source",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolInviteId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitTalentPool",
                      "kind": "LinkedField",
                      "name": "talentPool",
                      "plural": false,
                      "selections": [
                        v13,
                        v4
                      ],
                      "storageKey": null
                    },
                    v22
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v29,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ProfileContainer_recruitTalentPoolInvites",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolInvites"
        }
      ]
    },
    "params": {
      "cacheID": "a4302da0bb6beb347352fc714f322f20",
      "id": null,
      "metadata": {},
      "name": "ProfilePageQuery",
      "operationKind": "query",
      "text": "query ProfilePageQuery(\n  $candidateId: UUID!\n  $where: RecruitTalentPoolInviteFilter!\n) {\n  profile: recruitProfileViewerGetOrCreate {\n    recruitProfileId\n    ...ProfileContainer_profile\n    id\n  }\n  account: accountCandidateAccountViewer {\n    accountId\n    ...ProfileContainer_account\n    id\n  }\n  ...ProfileContainer_tasks\n  ...ProfileContainer_recommendations\n  ...ProfileContainer_interviews\n  ...ProfileContainer_applications\n  ...ProfileContainer_recruitTalentPoolInvites_3FC4Qo\n}\n\nfragment CandidateAccountEmailVerifyForm_account on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n}\n\nfragment CompaniesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n}\n\nfragment ExperienceCurrent_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    id\n    version\n    candidateExperienceId\n    titleId\n    title\n    companyId\n    companyName\n    companyIsVerified\n    startDate\n    endDate\n    industry\n    positionType\n    description\n    ...ExperienceItem_profile\n  }\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n\nfragment IndustriesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    industry\n  }\n}\n\nfragment ProfileContainer_account on AccountsCandidateAccount {\n  accountId\n  isEmailVerified\n  ...ProfileNameUpdateDialog_profile\n  ...CandidateAccountEmailVerifyForm_account\n}\n\nfragment ProfileContainer_applications on Query {\n  applications(first: 4, order: {createdAt: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        applicationId\n        code\n        employerName\n        vacancyName\n        hasCompletedDocumentTypes\n        hasCompletedForms\n        hasCompletedOptionalSkills\n        hasCompletedRate\n        hasCompletedRequiredSkills\n        applicationStateName\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment ProfileContainer_interviews on Query {\n  interviews: recruitInterviews(first: 4) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        interviewId\n        vacancyId\n        applicationId\n        employerId\n        stage\n        status\n        type\n        vacancy {\n          name\n          code\n          employerName\n          employerLogoUrl\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment ProfileContainer_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    currentJobTitleName\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    companyName\n    companyIsVerified\n    title\n    candidateExperienceId\n    id\n  }\n  rate {\n    maximumRateOfPay\n    id\n  }\n  experiences {\n    items {\n      id\n      skills\n    }\n  }\n  resume {\n    id\n    addedToProfile\n  }\n  rightToWork {\n    id\n  }\n  account {\n    accountId\n    firstName\n    lastName\n    id\n  }\n  workLocations {\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      id\n      name\n      countryCode\n      countryName\n      entireCountry\n      latitude\n      longitude\n      radius\n    }\n    id\n  }\n  ...Rates_RecruitProfile\n  ...ProfileInfoSidebar_profile\n  ...CompaniesTags_profile\n  ...IndustriesTags_profile\n  ...ExperienceCurrent_profile\n  ...RateEditor_RecruitProfile\n}\n\nfragment ProfileContainer_recommendations on Query {\n  recommendations: recruitRecommendations(first: 8, order: {createdOn: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        recruitRecommendationId\n        currentStatus\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment ProfileContainer_recruitTalentPoolInvites_3FC4Qo on Query {\n  recruitTalentPoolInvites(first: 4, order: [{code: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        status\n        source\n        talentPoolInviteId\n        talentPool {\n          name\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment ProfileContainer_tasks on Query {\n  globalTasks: tasksCandidateGlobalTasks(candidateId: $candidateId) {\n    id\n    type\n    tasks {\n      id\n      title\n      type\n    }\n  }\n}\n\nfragment ProfileInfoSidebar_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n  workLocations {\n    workLocations {\n      name\n      countryCode\n    }\n    id\n  }\n}\n\nfragment ProfileNameUpdateDialog_profile on AccountsCandidateAccount {\n  id\n  firstName\n  lastName\n  isSignUpComplete\n  isEmailVerified\n}\n\nfragment RateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment Rates_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n"
    }
  };
}();
node29.hash = "004649a0445d7647d918ca2627895406";
var ProfilePageQuery_graphql_default = node29;

// src/secure/profile/ProfilePage.tsx
import { useCallback as useCallback12, useEffect as useEffect5 } from "react";
import {
  Navigate as Navigate6,
  Outlet,
  Route as Route16,
  Routes as Routes11,
  useLocation as useLocation3,
  useNavigate as useNavigate14
} from "react-router-dom";
import {
  usePreloadedQuery as usePreloadedQuery2,
  useQueryLoader as useQueryLoader2
} from "react-relay";
import { ErrorBoundary as ErrorBoundary19 } from "react-error-boundary";
import { Suspense as Suspense7 } from "shared-ui";
import { EdSkeleton as EdSkeleton8, MobileHeader as MobileHeader3 } from "shared-ui";
import {
  ResumesLayout,
  ExperienceLayout,
  ProfileContainer
} from "feature-recruit";
import { ErrorBoundaryFallback as ErrorBoundaryFallback19 } from "app-core";
import { ButtonTabPills } from "shared-ui";
import { createButtonLinkState } from "shared-ui";
import { jsx as jsx62, jsxs as jsxs39 } from "react/jsx-runtime";
var queryDef6 = ProfilePageQuery_graphql_default;
var ProfileRoot = () => {
  const location = useLocation3();
  const navigate = useNavigate14();
  const isExperienceTab = location.pathname.includes("experience");
  const isResumesTab = location.pathname.includes("resumes");
  const tabs = [
    createButtonLinkState(
      "Profile",
      !isExperienceTab && !isResumesTab,
      () => navigate("./profile"),
      "Profile"
    ),
    createButtonLinkState(
      "Work Experience",
      isExperienceTab,
      () => navigate("./experience"),
      "Work History"
    ),
    createButtonLinkState(
      "Resumes",
      isResumesTab,
      () => navigate("./resumes"),
      "Resumes"
    )
  ];
  return /* @__PURE__ */ jsxs39("div", { children: [
    /* @__PURE__ */ jsx62(
      MobileHeader3,
      {
        title: /* @__PURE__ */ jsx62("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Profile" }),
        showBackButton: false
      }
    ),
    /* @__PURE__ */ jsx62("div", { className: "border-b px-4 py-2 sm:px-8", children: /* @__PURE__ */ jsx62(ButtonTabPills, { tabs }) }),
    /* @__PURE__ */ jsx62(Outlet, {})
  ] });
};
var ProfilePage = ({ candidateId, candidateEmail }) => {
  const [queryReference, loadQuery, disposeQuery] = useQueryLoader2(queryDef6);
  const where = {
    candidateEmail: { eq: candidateEmail },
    status: { in: ["OPEN"] }
  };
  const load = useCallback12(() => {
    loadQuery({ candidateId, where }, { fetchPolicy: "network-only" });
  }, []);
  useEffect5(() => {
    load();
  }, []);
  return /* @__PURE__ */ jsx62(ErrorBoundary19, { FallbackComponent: ErrorBoundaryFallback19, children: /* @__PURE__ */ jsx62(Suspense7, { fallback: /* @__PURE__ */ jsx62(EdSkeleton8, {}), children: queryReference ? /* @__PURE__ */ jsx62(ProfileLayout, { queryRef: queryReference, onReload: load }) : /* @__PURE__ */ jsx62(EdSkeleton8, {}) }) });
};
var ProfileLayout = ({
  queryRef,
  onReload
}) => {
  const data = usePreloadedQuery2(queryDef6, queryRef);
  if (!data || !data.profile) {
    return /* @__PURE__ */ jsxs39("div", { children: [
      /* @__PURE__ */ jsx62("p", { children: "Loading Profile..." }),
      /* @__PURE__ */ jsx62(EdSkeleton8, {})
    ] });
  }
  return /* @__PURE__ */ jsx62(ErrorBoundary19, { FallbackComponent: ErrorBoundaryFallback19, children: /* @__PURE__ */ jsx62(Suspense7, { fallback: /* @__PURE__ */ jsx62(EdSkeleton8, {}), children: /* @__PURE__ */ jsx62(Routes11, { children: /* @__PURE__ */ jsxs39(Route16, { element: /* @__PURE__ */ jsx62(ProfileRoot, {}), children: [
    /* @__PURE__ */ jsx62(
      Route16,
      {
        path: "summary/*",
        element: /* @__PURE__ */ jsx62(
          ProfileContainer,
          {
            tasksFragmentRef: data,
            profileFragmentRef: data.profile,
            accountFragmentRef: data.account,
            recommendationFragmentRef: data,
            interviewsFragmentRef: data,
            allTasksFragmentRef: data,
            talentPoolQueryRef: data,
            onReload
          }
        )
      }
    ),
    /* @__PURE__ */ jsx62(
      Route16,
      {
        path: "experience/*",
        element: /* @__PURE__ */ jsx62(
          ExperienceLayout,
          {
            profileId: data.profile.recruitProfileId,
            onExperienceChanged: onReload
          }
        )
      }
    ),
    /* @__PURE__ */ jsx62(
      Route16,
      {
        path: "resumes/*",
        element: /* @__PURE__ */ jsx62(ResumesLayout, { profileId: data.profile.recruitProfileId })
      }
    ),
    /* @__PURE__ */ jsx62(Route16, { path: "*", element: /* @__PURE__ */ jsx62(Navigate6, { to: "./summary" }) })
  ] }) }) }) });
};

// src/secure/legal/pages/Legal.tsx
import { DocumentIcon as DocumentIcon2 } from "@heroicons/react/24/solid";
import { Info as Info5, PageBuilderElement, linkHOC } from "shared-ui";
import { jsx as jsx63 } from "react/jsx-runtime";
var Legal = () => {
  const layout = {
    gdpr: {
      key: "gdpr",
      component: linkHOC(Info5, {
        link: "./GDPR",
        name: "gdpr"
      }),
      props: {
        label: "GDPR Consent",
        value: "",
        icon: DocumentIcon2
      }
    },
    whereCanYouWork: {
      key: "tandc",
      component: linkHOC(Info5, {
        link: "./terms-and-conditions",
        name: "terms-and-conditions"
      }),
      props: {
        label: "Terms & Conditions",
        value: "",
        icon: DocumentIcon2
      }
    }
  };
  return /* @__PURE__ */ jsx63(
    PageBuilderElement,
    {
      layout,
      headerTitle: "Legal",
      headerDescription: "Please find info on GDPR and our Terms & Conditions below."
    }
  );
};

// src/secure/legal/pages/GDPR.tsx
import { CloudArrowUpIcon as CloudArrowUpIcon2 } from "@heroicons/react/24/solid";
import { Info as Info6, PageBuilderElement as PageBuilderElement2, linkHOC as linkHOC2 } from "shared-ui";
import { jsx as jsx64, jsxs as jsxs40 } from "react/jsx-runtime";
var GDPR = () => {
  const layout = {
    whatIsGDPR: {
      key: "whatIsGDPR",
      component: linkHOC2(Info6, {
        link: "https://www.myn.co.uk/dpfaq/",
        name: "dpfaq"
      }),
      props: {
        label: "What is GDPR",
        value: "Click here to find out more",
        icon: CloudArrowUpIcon2
      }
    }
  };
  return /* @__PURE__ */ jsx64(
    PageBuilderElement2,
    {
      layout,
      headerTitle: "GDPR Consent",
      headerDescription: /* @__PURE__ */ jsxs40("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ jsx64("p", { children: "In order to provide our services, we will use and share the data you provide us (eg. name, email, phone number, CV) with clients, MSPs and recruiters. By providing us this data, you remain in direct control of who has access through the actions you take (eg. applying for vacancies or joining talent pools)." }),
        /* @__PURE__ */ jsx64("p", { children: "You have the right to delete and remove your data at any time, plus the right to be forgotten." }),
        /* @__PURE__ */ jsx64("p", { children: "We will not sell your data to third parties" }),
        /* @__PURE__ */ jsx64("p", { children: "For more information, please see our data privacy FAQs" })
      ] })
    }
  );
};

// src/secure/legal/pages/TermsAndConditions.tsx
import { CheckCircleIcon as CheckCircleIcon2 } from "@heroicons/react/24/solid";
import { createUUID } from "shared-lib";
import { Info as Info7, PageBuilderElement as PageBuilderElement3, Tag as Tag2 } from "shared-ui";
import { jsx as jsx65 } from "react/jsx-runtime";
var TermsAndConditions = () => {
  const keyPoints = [
    "100% Free",
    "We represent YOU soley for roles on the platform",
    "Contracts, Schedules, Time-sheets are all submitted and held elctronically",
    "We pay Ltd company, Umbrella or PAYE COntractors",
    "Completely Transparent Process",
    "Full terms & conditions"
  ];
  const layout = keyPoints.reduce((a, point) => {
    const uuid = createUUID();
    a[uuid] = {
      key: uuid,
      component: Info7,
      props: {
        label: point,
        value: "",
        icon: (props) => /* @__PURE__ */ jsx65(CheckCircleIcon2, { ...props, className: "fill-primary-400 h-8 w-8" })
      }
    };
    return a;
  }, {});
  return /* @__PURE__ */ jsx65(
    PageBuilderElement3,
    {
      layout,
      headerTitle: "Terms & Conditions",
      headerDescription: /* @__PURE__ */ jsx65(Tag2, { children: "T&C Accepted" })
    }
  );
};

// src/secure/legal/Routes.tsx
import { Route as Route17, Routes as RouterRoutes8 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary20 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback20 } from "app-core";
import { jsx as jsx66, jsxs as jsxs41 } from "react/jsx-runtime";
var Routes12 = () => {
  return /* @__PURE__ */ jsx66(ErrorBoundary20, { FallbackComponent: ErrorBoundaryFallback20, children: /* @__PURE__ */ jsxs41(RouterRoutes8, { children: [
    /* @__PURE__ */ jsx66(Route17, { path: "*", element: /* @__PURE__ */ jsx66(Legal, {}) }),
    /* @__PURE__ */ jsx66(Route17, { path: "/gdpr", element: /* @__PURE__ */ jsx66(GDPR, {}) }),
    /* @__PURE__ */ jsx66(Route17, { path: "/terms-and-conditions", element: /* @__PURE__ */ jsx66(TermsAndConditions, {}) })
  ] }) });
};

// src/secure/finance/CandidatesFinanceLayout.tsx
import { Navigate as Navigate7, Outlet as Outlet2, Route as Route18, Routes as Routes13 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary21 } from "react-error-boundary";
import {
  ClockIcon,
  CalendarIcon,
  BanknotesIcon as BanknotesIcon2
} from "@heroicons/react/24/outline";
import {
  Breadcrumbs as Breadcrumbs3,
  MobileHeader as MobileHeader4,
  SectionedLayout as SectionedLayout4
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback21 } from "app-core";

// src/secure/finance/PayrollLayout.tsx
import { Iframe as Iframe2 } from "shared-ui";
import { jsx as jsx67 } from "react/jsx-runtime";
var url2 = "https://payroll.myn.co.uk/register/home";
var PayrollLayout = () => {
  return /* @__PURE__ */ jsx67("div", { className: "m-4 p-4", children: /* @__PURE__ */ jsx67(
    Iframe2,
    {
      style: { height: 670 },
      className: "w-full overflow-y-scroll border-none",
      src: url2
    }
  ) });
};

// src/secure/finance/TimesheetsLayout.tsx
import { Button as Button14, Card as Card5, EdLink as EdLink10 } from "shared-ui";
import { jsx as jsx68, jsxs as jsxs42 } from "react/jsx-runtime";
var TimesheetsLayout = () => {
  return /* @__PURE__ */ jsx68("div", { className: "flex flex-col items-center justify-center px-1 sm:m-4 sm:p-4", children: /* @__PURE__ */ jsx68(Card5, { children: /* @__PURE__ */ jsxs42("div", { className: "prose gap-10 bg-white p-3", children: [
    /* @__PURE__ */ jsx68("p", { children: "Simple and reliable time sheeting tool that you can complete any time - any place - in seconds with full access to historic submissions and electronic approval system from your job" }),
    /* @__PURE__ */ jsx68("div", { className: "flex justify-end", children: /* @__PURE__ */ jsx68(
      EdLink10,
      {
        href: "https://myn.timesheetportal.com/",
        rel: "noreferrer",
        name: "timesheeting-signin",
        children: /* @__PURE__ */ jsx68(Button14, { "aria-label": "Sign In to time sheet portal", color: "green", children: "Sign In Here" })
      }
    ) })
  ] }) }) });
};

// src/secure/finance/CandidatesFinanceLayout.tsx
import { jsx as jsx69, jsxs as jsxs43 } from "react/jsx-runtime";
var ItemLayout3 = ({ children, links }) => {
  return /* @__PURE__ */ jsxs43("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx69("div", { className: "hidden border-b md:flex", children: /* @__PURE__ */ jsx69(Breadcrumbs3, { homeText: "Finance", homeHref: "..", links }) }),
    /* @__PURE__ */ jsx69("div", { children })
  ] });
};
var CandidatesFinanceLayout = () => {
  return /* @__PURE__ */ jsx69(ErrorBoundary21, { FallbackComponent: ErrorBoundaryFallback21, children: /* @__PURE__ */ jsx69(Routes13, { children: /* @__PURE__ */ jsxs43(
    Route18,
    {
      path: "/",
      element: /* @__PURE__ */ jsx69(
        SectionedLayout4,
        {
          title: "Finance",
          sections: [
            {
              key: "payroll",
              listTitle: "Payroll and AdvancePay",
              itemTitle: "Payroll and AdvancePay",
              icon: BanknotesIcon2,
              iconBackground: "bg-gray-50",
              iconForeground: "text-gray-700",
              element: /* @__PURE__ */ jsx69(PayrollLayout, {})
            },
            {
              key: "timesheets",
              listTitle: "Timesheeting",
              itemTitle: "Timesheeting",
              icon: ClockIcon,
              iconBackground: "bg-gray-50",
              iconForeground: "text-gray-700",
              element: /* @__PURE__ */ jsx69(TimesheetsLayout, {})
            }
          ],
          children: /* @__PURE__ */ jsx69(Outlet2, {})
        }
      ),
      children: [
        /* @__PURE__ */ jsx69(
          Route18,
          {
            path: "payroll/*",
            element: /* @__PURE__ */ jsxs43(ItemLayout3, { links: [{ name: "Payroll", href: "" }], children: [
              /* @__PURE__ */ jsx69(
                MobileHeader4,
                {
                  title: /* @__PURE__ */ jsx69("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Payroll and AdvancePay" }),
                  showBackButton: true
                }
              ),
              /* @__PURE__ */ jsx69(PayrollLayout, {})
            ] })
          }
        ),
        /* @__PURE__ */ jsx69(
          Route18,
          {
            path: "timesheets/*",
            element: /* @__PURE__ */ jsxs43(ItemLayout3, { links: [{ name: "Timesheets", href: "" }], children: [
              /* @__PURE__ */ jsx69(
                MobileHeader4,
                {
                  title: /* @__PURE__ */ jsx69("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Timesheeting" }),
                  showBackButton: true
                }
              ),
              /* @__PURE__ */ jsx69(TimesheetsLayout, {})
            ] })
          }
        ),
        /* @__PURE__ */ jsx69(
          Route18,
          {
            path: "rewards/*",
            element: /* @__PURE__ */ jsxs43(ItemLayout3, { links: [{ name: "Rewards", href: "" }], children: [
              /* @__PURE__ */ jsx69(
                MobileHeader4,
                {
                  title: /* @__PURE__ */ jsx69("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Rewards and Benefits" }),
                  showBackButton: true
                }
              ),
              /* @__PURE__ */ jsx69(RewardsLayout, {})
            ] })
          }
        ),
        /* @__PURE__ */ jsx69(Route18, { path: "*", element: /* @__PURE__ */ jsx69(Navigate7, { to: "./dashboard" }) })
      ]
    }
  ) }) });
};

// src/secure/tasks/__generated__/TasksLayout_data.graphql.ts
var node30 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TasksLayout_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GroupedTasksContainer_data"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node30.hash = "92d8483b0217bd0fd7c392f0dac2f187";
var TasksLayout_data_graphql_default = node30;

// src/secure/tasks/TasksLayout.tsx
import { useFragment as useFragment13 } from "react-relay";
import { ErrorBoundary as ErrorBoundary22 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback22 } from "app-core";
import { jsx as jsx70 } from "react/jsx-runtime";
var fragmentDef11 = TasksLayout_data_graphql_default;
var TasksLayout = ({
  candidateId,
  fragmentRef
}) => {
  const data = useFragment13(fragmentDef11, fragmentRef);
  return /* @__PURE__ */ jsx70(ErrorBoundary22, { FallbackComponent: ErrorBoundaryFallback22, children: /* @__PURE__ */ jsx70("div", { className: "flex flex-col gap-3", children: /* @__PURE__ */ jsx70(GroupedTasksContainer, { candidateId, fragmentRef: data }) }) });
};

// src/secure/vacancies/pages/VacancyApplyPage.tsx
import { useNavigate as useNavigate15, useParams as useParams8 } from "react-router-dom";
import { useUserSessionContext as useUserSessionContext2 } from "app-core";
import { VacancyApplyContainer } from "feature-recruit";
import { jsx as jsx71 } from "react/jsx-runtime";
var VacancyApplyPage = () => {
  const navigate = useNavigate15();
  const session = useUserSessionContext2();
  const { vacancyCode } = useParams8();
  return /* @__PURE__ */ jsx71("div", { children: /* @__PURE__ */ jsx71(
    VacancyApplyContainer,
    {
      vacancyCode: parseInt(vacancyCode),
      candidateId: session.userId,
      onCompleted: (applicationId) => {
        navigate(`../../applications/application/${applicationId}/info`);
      }
    }
  ) });
};

// src/secure/vacancies/VacanciesLayout.tsx
import { Routes as Routes14, Route as Route19 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary23 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback23 } from "app-core";
import { jsx as jsx72 } from "react/jsx-runtime";
var VacanciesLayout = () => {
  return /* @__PURE__ */ jsx72(ErrorBoundary23, { FallbackComponent: ErrorBoundaryFallback23, children: /* @__PURE__ */ jsx72(Routes14, { children: /* @__PURE__ */ jsx72(Route19, { path: "apply/:vacancyCode", element: /* @__PURE__ */ jsx72(VacancyApplyPage, {}) }) }) });
};

// src/secure/__generated__/AppCandidatesSecureLayoutQuery.graphql.ts
var node31 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateId"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isGdprConsented",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isEmailVerified",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasAgreedToTerms",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSuspended",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAnonymised",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileThumbNailImageUrl",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileId",
    "storageKey": null
  }, v13 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "candidateId"
    }
  ], v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v15 = [
    {
      "kind": "Variable",
      "name": "candidateId",
      "variableName": "candidateId"
    }
  ], v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "groupId",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateTaskId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AppCandidatesSecureLayoutQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AccountLayout_data"
        },
        {
          "alias": "account",
          "args": null,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountViewer",
          "plural": false,
          "selections": [
            v1,
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateAccountSetupContainer_account"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContactDetailsEditor_account"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "profile",
          "args": null,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileViewerGetOrCreate",
          "plural": false,
          "selections": [
            v12,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RateEditor_RecruitProfile"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AvailabilityEditor_RecruitProfile"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "LocationsFragment_RecruitProfile"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TasksLayout_data"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolSignUpFragment_RecruitProfile"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolInvite_RecruitProfile"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TalentPoolExternalSignUpFragment_RecruitProfile"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "recommendations",
          "args": v13,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationById",
          "plural": false,
          "selections": [
            v14
          ],
          "storageKey": null
        },
        {
          "alias": "globalTasks",
          "args": v15,
          "concreteType": "CandidateTaskGlobalGroup",
          "kind": "LinkedField",
          "name": "tasksCandidateGlobalTasks",
          "plural": true,
          "selections": [
            v1,
            v16,
            v17,
            v18,
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                v1,
                v19
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AppCandidatesSecureLayoutQuery",
      "selections": [
        {
          "alias": "account",
          "args": null,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountViewer",
          "plural": false,
          "selections": [
            v1,
            v2,
            v3,
            v4,
            v6,
            v7,
            v8,
            v9,
            v10,
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidatePhoneVerification",
              "kind": "LinkedField",
              "name": "phone",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneCountryPrefix",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneVerificationStatus",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            v11
          ],
          "storageKey": null
        },
        {
          "alias": "profile",
          "args": null,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileViewerGetOrCreate",
          "plural": false,
          "selections": [
            v12,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileRate",
              "kind": "LinkedField",
              "name": "rate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minimumRateOfPay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "maximumRateOfPay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCode",
                  "storageKey": null
                },
                v1
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileAvailability",
              "kind": "LinkedField",
              "name": "availability",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "jobSearchStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "date",
                          "storageKey": null
                        }
                      ],
                      "type": "CandidateAvailableFromDate",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "immediately",
                          "storageKey": null
                        }
                      ],
                      "type": "CandidateAvailableImmediately",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "notice",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "timeframe",
                          "storageKey": null
                        }
                      ],
                      "type": "CandidateAvailableNotice",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                v1
              ],
              "storageKey": null
            },
            v1,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperienceCollection",
              "kind": "LinkedField",
              "name": "experiences",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    v1
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperience",
              "kind": "LinkedField",
              "name": "experience",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "candidateExperienceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyName",
                  "storageKey": null
                },
                v1
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "recommendations",
          "args": v13,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationById",
          "plural": false,
          "selections": [
            v14,
            v1
          ],
          "storageKey": null
        },
        {
          "alias": "globalTasks",
          "args": v15,
          "concreteType": "CandidateTaskGlobalGroup",
          "kind": "LinkedField",
          "name": "tasksCandidateGlobalTasks",
          "plural": true,
          "selections": [
            v1,
            v16,
            v17,
            v18,
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                v1,
                v19,
                v17,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidateTaskGroup",
                  "kind": "LinkedField",
                  "name": "group",
                  "plural": false,
                  "selections": [
                    v1,
                    v18
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fb45b8d000832406f15b1f4d31857978",
      "id": null,
      "metadata": {},
      "name": "AppCandidatesSecureLayoutQuery",
      "operationKind": "query",
      "text": "query AppCandidatesSecureLayoutQuery(\n  $candidateId: UUID!\n) {\n  ...AccountLayout_data\n  account: accountCandidateAccountViewer {\n    id\n    accountId\n    firstName\n    lastName\n    email\n    isGdprConsented\n    isEmailVerified\n    hasAgreedToTerms\n    isSuspended\n    isAnonymised\n    profileThumbNailImageUrl\n    ...CandidateAccountSetupContainer_account\n    ...ContactDetailsEditor_account\n  }\n  profile: recruitProfileViewerGetOrCreate {\n    recruitProfileId\n    ...RateEditor_RecruitProfile\n    ...AvailabilityEditor_RecruitProfile\n    ...LocationsFragment_RecruitProfile\n    ...TasksLayout_data\n    ...TalentPoolSignUpFragment_RecruitProfile\n    ...TalentPoolInvite_RecruitProfile\n    ...TalentPoolExternalSignUpFragment_RecruitProfile\n    id\n  }\n  recommendations: recruitRecommendationById(id: $candidateId) {\n    candidateId\n    id\n  }\n  globalTasks: tasksCandidateGlobalTasks(candidateId: $candidateId) {\n    id\n    groupId\n    type\n    name\n    tasks {\n      id\n      candidateTaskId\n    }\n  }\n}\n\nfragment AccountLayout_data on Query {\n  account: accountCandidateAccountViewer {\n    id\n    accountId\n    firstName\n    lastName\n    isGdprConsented\n    isEmailVerified\n    hasAgreedToTerms\n    isSuspended\n    isAnonymised\n    ...CandidateAccountSetupContainer_account\n    ...ContactDetailRoutes_account\n  }\n  profile: recruitProfileViewerGetOrCreate {\n    ...RateEditor_RecruitProfile\n    ...AvailabilityEditor_RecruitProfile\n    ...LocationsFragment_RecruitProfile\n    id\n  }\n  recommendations: recruitRecommendationById(id: $candidateId) {\n    candidateId\n    id\n  }\n  globalTasks: tasksCandidateGlobalTasks(candidateId: $candidateId) {\n    id\n    groupId\n    type\n    name\n    tasks {\n      id\n      candidateTaskId\n      type\n      title\n      group {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AccountTaskDetails_profile on RecruitProfile {\n  id\n  recruitProfileId\n}\n\nfragment AccountTaskLoader_data on RecruitProfile {\n  id\n  recruitProfileId\n  ...AccountTaskDetails_profile\n}\n\nfragment ApplicationRateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment ApplicationTaskDetails_profile on RecruitProfile {\n  id\n  recruitProfileId\n  ...ClarifyRateApplicationTask_profile\n  ...ClarifySkillsApplicationTask_profile\n  ...ClarifyOptionalSkillsApplicationTask_profile\n}\n\nfragment ApplicationTaskLoader_data on RecruitProfile {\n  id\n  recruitProfileId\n  ...ApplicationTaskDetails_profile\n}\n\nfragment AvailabilityEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  availability {\n    jobSearchStatus\n    availability {\n      __typename\n      ... on CandidateAvailableFromDate {\n        __typename\n        date\n      }\n      ... on CandidateAvailableImmediately {\n        __typename\n        immediately\n      }\n      ... on CandidateAvailableNotice {\n        __typename\n        notice\n        timeframe\n      }\n    }\n    id\n  }\n}\n\nfragment CandidateAccountEmailEditor_account on AccountsCandidateAccount {\n  id\n  email\n  isEmailVerified\n  createdAt\n  updatedAt\n}\n\nfragment CandidateAccountEmailVerifyForm_account on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n}\n\nfragment CandidateAccountGDPRConsentForm_account on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n}\n\nfragment CandidateAccountNameEditor_account on AccountsCandidateAccount {\n  id\n  firstName\n  lastName\n  createdAt\n  updatedAt\n}\n\nfragment CandidateAccountSetupContainer_account on AccountsCandidateAccount {\n  id\n  firstName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n  ...CandidateAccountEmailVerifyForm_account\n  ...CandidateAccountGDPRConsentForm_account\n  ...CandidateAccountTermsForm_account\n}\n\nfragment CandidateAccountTermsForm_account on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n}\n\nfragment CandidatePhoneContainer_account on AccountsCandidateAccount {\n  id\n  accountId\n  phone {\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneNumber\n    phoneVerificationStatus\n  }\n  ...CandidatePhoneEditor_account\n}\n\nfragment CandidatePhoneEditor_account on AccountsCandidateAccount {\n  id\n  accountId\n  phone {\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneNumber\n    phoneVerificationStatus\n  }\n}\n\nfragment ClarifyOptionalSkillsApplicationTask_profile on RecruitProfile {\n  id\n  recruitProfileId\n  experiences {\n    items {\n      id\n    }\n  }\n  ...ExperienceDropdown_RecruitProfile\n}\n\nfragment ClarifyRateApplicationTask_profile on RecruitProfile {\n  id\n  recruitProfileId\n  ...ApplicationRateEditor_RecruitProfile\n}\n\nfragment ClarifySkillsApplicationTask_profile on RecruitProfile {\n  id\n  recruitProfileId\n  experiences {\n    items {\n      id\n    }\n  }\n  ...ExperienceDropdown_RecruitProfile\n}\n\nfragment ContactDetailRoutes_account on AccountsCandidateAccount {\n  id\n  accountId\n  ...ContactDetailsEditor_account\n  ...CandidatePhoneContainer_account\n  ...ContactDetailsNameContainer_account\n  ...ContactDetailsEmailContainer_account\n}\n\nfragment ContactDetailsComponent_account on AccountsCandidateAccount {\n  ...CandidateAccountNameEditor_account\n  ...CandidateAccountEmailEditor_account\n  ...CandidatePhoneContainer_account\n}\n\nfragment ContactDetailsEditor_account on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  lastName\n  email\n  isEmailVerified\n  phone {\n    phoneNumber\n    phoneCountryCode\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n  ...ContactDetailsComponent_account\n}\n\nfragment ContactDetailsEmailContainer_account on AccountsCandidateAccount {\n  id\n  accountId\n  ...CandidateAccountEmailEditor_account\n}\n\nfragment ContactDetailsNameContainer_account on AccountsCandidateAccount {\n  id\n  accountId\n  ...CandidateAccountNameEditor_account\n}\n\nfragment ExperienceDropdown_RecruitProfile on RecruitProfile {\n  experience {\n    candidateExperienceId\n    companyId\n    companyName\n    id\n  }\n}\n\nfragment GroupedTasksContainer_data on RecruitProfile {\n  id\n  recruitProfileId\n  ...GroupedTasksLayout_data\n}\n\nfragment GroupedTasksLayout_data on RecruitProfile {\n  id\n  recruitProfileId\n  ...ApplicationTaskLoader_data\n  ...AccountTaskLoader_data\n}\n\nfragment LocationsFragment_RecruitProfile on RecruitProfile {\n  recruitProfileId\n}\n\nfragment RateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment TalentPoolExternalSignUpFragment_RecruitProfile on RecruitProfile {\n  recruitProfileId\n}\n\nfragment TalentPoolInvite_RecruitProfile on RecruitProfile {\n  recruitProfileId\n}\n\nfragment TalentPoolSignUpFragment_RecruitProfile on RecruitProfile {\n  recruitProfileId\n}\n\nfragment TasksLayout_data on RecruitProfile {\n  id\n  recruitProfileId\n  ...GroupedTasksContainer_data\n}\n"
    }
  };
}();
node31.hash = "1415070e3e994dfab256ba2b38b7b22f";
var AppCandidatesSecureLayoutQuery_graphql_default = node31;

// src/secure/AppCandidatesSecureLayout.tsx
import { createElement, useCallback as useCallback13 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery11 } from "react-relay";
import { Routes as Routes17, Route as Route22, useLocation as useLocation4, Navigate as Navigate9 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary28 } from "react-error-boundary";
import {
  BookOpenIcon,
  UserIcon,
  BookmarkIcon,
  BanknotesIcon as BanknotesIcon3,
  ArrowRightOnRectangleIcon,
  RectangleStackIcon,
  InboxArrowDownIcon,
  HeartIcon as HeartIcon2,
  QuestionMarkCircleIcon,
  InboxIcon
} from "@heroicons/react/24/outline";
import {
  createLinkState,
  EdSkeleton as EdSkeleton10,
  ErrorContainer as ErrorContainer3,
  CandidateShell,
  Size as Size8
} from "shared-ui";
import { useAuth as useAuth2, useUserSessionContext as useUserSessionContext3 } from "app-core";
import { AppLogoContainer } from "app-core";
import {
  candidateAccountHasCompletedRequiredSetup,
  CandidateAccountSetupContainer
} from "feature-candidate-accounts";

// src/secure/talent-pools/__generated__/TalentPoolExternalSignUpFragment_RecruitProfile.graphql.ts
var node32 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TalentPoolExternalSignUpFragment_RecruitProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node32.hash = "8b4df22d84a82413b158f6a08b64e7dd";
var TalentPoolExternalSignUpFragment_RecruitProfile_graphql_default = node32;

// src/secure/talent-pools/__generated__/TalentPoolExternalSignUpQuery.graphql.ts
var node33 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "slug"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "slug"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inviteOnly",
    "storageKey": null
  }, v7 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolExternalSignUpQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteById",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPool",
              "kind": "LinkedField",
              "name": "talentPool",
              "plural": false,
              "selections": [
                v4,
                v5,
                v6
              ],
              "storageKey": null
            },
            v7
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolExternalSignUpQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteById",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPool",
              "kind": "LinkedField",
              "name": "talentPool",
              "plural": false,
              "selections": [
                v4,
                v5,
                v6,
                v2
              ],
              "storageKey": null
            },
            v7
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "3dbcec22d98429505af9d3b92545425d",
      "id": null,
      "metadata": {},
      "name": "TalentPoolExternalSignUpQuery",
      "operationKind": "query",
      "text": "query TalentPoolExternalSignUpQuery(\n  $slug: UUID!\n) {\n  result: recruitTalentPoolInviteById(id: $slug) {\n    id\n    talentPoolId\n    talentPool {\n      name\n      description\n      inviteOnly\n      id\n    }\n  }\n}\n"
    }
  };
}();
node33.hash = "64fed42b2e8a0fb5fb7180b1d6176c1a";
var TalentPoolExternalSignUpQuery_graphql_default = node33;

// src/secure/talent-pools/__generated__/TalentPoolExternalSignUpJoinTalentPoolMutation.graphql.ts
var node34 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inviteOnly",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolExternalSignUpJoinTalentPoolMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitTalentPoolMembershipJoinPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipJoin",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolMembership",
              "kind": "LinkedField",
              "name": "talentPoolMembership",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolMembership",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    v3,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitTalentPool",
                      "kind": "LinkedField",
                      "name": "talentPool",
                      "plural": false,
                      "selections": [
                        v4,
                        v5,
                        v6
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolExternalSignUpJoinTalentPoolMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitTalentPoolMembershipJoinPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipJoin",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolMembership",
              "kind": "LinkedField",
              "name": "talentPoolMembership",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolMembership",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    v3,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitTalentPool",
                      "kind": "LinkedField",
                      "name": "talentPool",
                      "plural": false,
                      "selections": [
                        v4,
                        v5,
                        v6,
                        v2
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "7c544d099430eaf4dd03116a7f0683fa",
      "id": null,
      "metadata": {},
      "name": "TalentPoolExternalSignUpJoinTalentPoolMutation",
      "operationKind": "mutation",
      "text": "mutation TalentPoolExternalSignUpJoinTalentPoolMutation(\n  $input: RecruitTalentPoolMembershipJoinInput!\n) {\n  recruitTalentPoolMembershipJoin(input: $input) {\n    talentPoolMembership {\n      node {\n        id\n        status\n        talentPool {\n          name\n          description\n          inviteOnly\n          id\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node34.hash = "ada2eb63a91aea4a2f40faa26dc28a6a";
var TalentPoolExternalSignUpJoinTalentPoolMutation_graphql_default = node34;

// src/secure/talent-pools/__generated__/TalentPoolExternalSignUpAcceptTalentPoolInviteMutation.graphql.ts
var node35 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTalentPoolInvite",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPoolInvite",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolExternalSignUpAcceptTalentPoolInviteMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitTalentPoolInviteAcceptPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteAccept",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolExternalSignUpAcceptTalentPoolInviteMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitTalentPoolInviteAcceptPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteAccept",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "88b233e5decff78aeeb27a4612f7a475",
      "id": null,
      "metadata": {},
      "name": "TalentPoolExternalSignUpAcceptTalentPoolInviteMutation",
      "operationKind": "mutation",
      "text": "mutation TalentPoolExternalSignUpAcceptTalentPoolInviteMutation(\n  $input: RecruitTalentPoolInviteAcceptInput!\n) {\n  recruitTalentPoolInviteAccept(input: $input) {\n    payload {\n      node {\n        id\n        status\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node35.hash = "b5470315c4cd16145846b396f670c2b9";
var TalentPoolExternalSignUpAcceptTalentPoolInviteMutation_graphql_default = node35;

// src/secure/talent-pools/TalentPoolExternalSignUp.tsx
import { useState as useState11 } from "react";
import { ErrorBoundary as ErrorBoundary24 } from "react-error-boundary";
import { useNavigate as useNavigate16, useParams as useParams9 } from "react-router-dom";
import {
  useFragment as useFragment14,
  useLazyLoadQuery as useLazyLoadQuery9,
  useMutation as useMutation6
} from "react-relay";
import { ErrorBoundaryFallback as ErrorBoundaryFallback24 } from "app-core";
import { createClientMutationId as createClientMutationId6 } from "shared-lib";
import { Button as Button15, Card as Card6, Error as Error3, Size as Size6 } from "shared-ui";
import { jsx as jsx73, jsxs as jsxs44 } from "react/jsx-runtime";
var fragmentDef12 = TalentPoolExternalSignUpFragment_RecruitProfile_graphql_default;
function TalentPoolExternalSignUp({
  fragmentRef
}) {
  const { slug } = useParams9();
  if (!slug) {
    return null;
  }
  return /* @__PURE__ */ jsx73(ErrorBoundary24, { FallbackComponent: ErrorBoundaryFallback24, children: /* @__PURE__ */ jsx73(
    TalentPoolExternalSignUpComponent,
    {
      slug,
      fragmentRef
    }
  ) });
}
function TalentPoolExternalSignUpComponent({
  slug,
  fragmentRef
}) {
  const [joinTalentPool] = useMutation6(
    TalentPoolExternalSignUp.mutations.joinTalentPool
  );
  const [acceptTalentPoolInvite] = useMutation6(
    TalentPoolExternalSignUp.mutations.acceptTalentPoolInvite
  );
  const { result } = useLazyLoadQuery9(
    TalentPoolExternalSignUp.query,
    { slug }
  );
  const [errors, setErrors] = useState11(null);
  const { recruitProfileId } = useFragment14(fragmentDef12, fragmentRef);
  const navigate = useNavigate16();
  if (result == null || result == void 0) {
    return /* @__PURE__ */ jsx73("div", { children: "Talent Pool not found" });
  }
  const talentPoolId = result.talentPoolId;
  const redirectToTalentPools = () => {
    navigate("/candidates/app/account/talent-pools");
  };
  const handleJoinTalentPool = () => {
    if (!talentPoolId || !recruitProfileId) {
      return;
    }
    if (result.talentPool.inviteOnly) {
      acceptTalentPoolInvite({
        variables: {
          input: {
            clientMutationId: createClientMutationId6(),
            talentPoolInviteId: slug
          }
        },
        onCompleted: () => {
          redirectToTalentPools();
        },
        onError: (error) => {
          setErrors(error.message);
        }
      });
    } else {
      joinTalentPool({
        variables: {
          input: {
            clientMutationId: createClientMutationId6(),
            profileId: recruitProfileId,
            source: "website",
            talentPoolId
          }
        },
        onCompleted: () => {
          redirectToTalentPools();
        },
        onError: (error) => {
          setErrors(error.message);
        }
      });
    }
  };
  return /* @__PURE__ */ jsx73(ErrorBoundary24, { FallbackComponent: ErrorBoundaryFallback24, children: /* @__PURE__ */ jsx73("div", { className: "mx-auto max-w-2xl py-10", children: /* @__PURE__ */ jsxs44(Card6, { children: [
    result.talentPool.inviteOnly,
    /* @__PURE__ */ jsxs44("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ jsxs44("h1", { className: "text-2xl", children: [
        "Join the ",
        result.talentPool.name,
        " talent pool"
      ] }),
      /* @__PURE__ */ jsx73("div", { children: /* @__PURE__ */ jsx73("p", { children: result.talentPool.description }) }),
      /* @__PURE__ */ jsxs44("div", { className: "flex w-full flex-col justify-center", children: [
        /* @__PURE__ */ jsx73(
          Button15,
          {
            color: "primary",
            size: Size6.xl,
            onClick: handleJoinTalentPool,
            children: "Join"
          }
        ),
        /* @__PURE__ */ jsx73(Button15, { size: Size6.xl, onClick: redirectToTalentPools, children: "Cancel" })
      ] }),
      errors && /* @__PURE__ */ jsxs44(Error3, { className: "self-center rounded-2xl bg-red-400 px-2 py-1 text-white", children: [
        "This is a Private Talent Pool. Contact the",
        " ",
        /* @__PURE__ */ jsx73("a", { href: "mailto:support@myn.co.uk", children: "Talent Pool Administrator" }),
        " ",
        "for further details."
      ] })
    ] })
  ] }) }) });
}
TalentPoolExternalSignUp.query = TalentPoolExternalSignUpQuery_graphql_default;
TalentPoolExternalSignUp.mutations = {
  joinTalentPool: TalentPoolExternalSignUpJoinTalentPoolMutation_graphql_default,
  acceptTalentPoolInvite: TalentPoolExternalSignUpAcceptTalentPoolInviteMutation_graphql_default
};

// src/secure/talent-pools/__generated__/TalentPoolInvite_RecruitProfile.graphql.ts
var node36 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TalentPoolInvite_RecruitProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node36.hash = "728dde41efbf99ecf036a10c867d9826";
var TalentPoolInvite_RecruitProfile_graphql_default = node36;

// src/secure/talent-pools/__generated__/TalentPoolInviteQuery.graphql.ts
var node37 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "inviteId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "inviteId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolInviteId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "talentPoolId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inviteOnly",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolInviteQuery",
      "selections": [
        {
          "alias": "invite",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteById",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPool",
              "kind": "LinkedField",
              "name": "talentPool",
              "plural": false,
              "selections": [
                v4,
                v5,
                v6,
                v7,
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolInviteQuery",
      "selections": [
        {
          "alias": "invite",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvite",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteById",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPool",
              "kind": "LinkedField",
              "name": "talentPool",
              "plural": false,
              "selections": [
                v4,
                v5,
                v6,
                v7,
                v8,
                v2
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "284bbc871ca413c903cc23d0750540cf",
      "id": null,
      "metadata": {},
      "name": "TalentPoolInviteQuery",
      "operationKind": "query",
      "text": "query TalentPoolInviteQuery(\n  $inviteId: UUID!\n) {\n  invite: recruitTalentPoolInviteById(id: $inviteId) {\n    id\n    talentPoolInviteId\n    talentPool {\n      slug\n      talentPoolId\n      inviteOnly\n      name\n      description\n      id\n    }\n  }\n}\n"
    }
  };
}();
node37.hash = "d8b06d3947b8aec5d9ad008725ee384e";
var TalentPoolInviteQuery_graphql_default = node37;

// src/secure/talent-pools/__generated__/TalentPoolInviteMutation.graphql.ts
var node38 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitTalentPoolMembershipJoinPayload",
      "kind": "LinkedField",
      "name": "recruitTalentPoolMembershipJoin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfTalentPoolMembership",
          "kind": "LinkedField",
          "name": "talentPoolMembership",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolInviteMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolInviteMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "676df536e1ab2f8000bcf6cbb7504049",
      "id": null,
      "metadata": {},
      "name": "TalentPoolInviteMutation",
      "operationKind": "mutation",
      "text": "mutation TalentPoolInviteMutation(\n  $input: RecruitTalentPoolMembershipJoinInput!\n) {\n  recruitTalentPoolMembershipJoin(input: $input) {\n    talentPoolMembership {\n      node {\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node38.hash = "bbaca758b1f9030dc317fce837120ca8";
var TalentPoolInviteMutation_graphql_default = node38;

// src/secure/talent-pools/TalentPoolInvite.tsx
import { useState as useState12 } from "react";
import { ErrorBoundary as ErrorBoundary25 } from "react-error-boundary";
import { useNavigate as useNavigate17, useParams as useParams10 } from "react-router-dom";
import {
  useFragment as useFragment15,
  useLazyLoadQuery as useLazyLoadQuery10,
  useMutation as useMutation7
} from "react-relay";
import { ErrorBoundaryFallback as ErrorBoundaryFallback25 } from "app-core";
import { createClientMutationId as createClientMutationId7 } from "shared-lib";
import { Button as Button16, Card as Card7, Error as Error4, Size as Size7 } from "shared-ui";
import { jsx as jsx74, jsxs as jsxs45 } from "react/jsx-runtime";
var fragmentDef13 = TalentPoolInvite_RecruitProfile_graphql_default;
function TalentPoolInvite({
  fragmentRef
}) {
  const { inviteId } = useParams10();
  if (!inviteId) {
    return null;
  }
  return /* @__PURE__ */ jsx74(ErrorBoundary25, { FallbackComponent: ErrorBoundaryFallback25, children: /* @__PURE__ */ jsx74(TalentPoolJoinComponent, { inviteId, fragmentRef }) });
}
function TalentPoolJoinComponent({
  inviteId,
  fragmentRef
}) {
  const [joinTalentPool] = useMutation7(
    TalentPoolInvite.mutations.joinTalentPool
  );
  const { invite } = useLazyLoadQuery10(
    TalentPoolInvite.query,
    { inviteId }
  );
  const [errors, setErrors] = useState12(null);
  const { recruitProfileId } = useFragment15(fragmentDef13, fragmentRef);
  const navigate = useNavigate17();
  if (invite == null || invite.talentPool == void 0) {
    return /* @__PURE__ */ jsx74("div", { children: "Invite not found" });
  }
  const talentPool = invite.talentPool;
  const talentPoolId = talentPool.talentPoolId;
  const redirectToTalentPools = () => {
    navigate("/candidates/app/account/talent-pools");
  };
  const handleJoinTalentPool = () => {
    if (!talentPoolId || !recruitProfileId) {
      return;
    }
    joinTalentPool({
      variables: {
        input: {
          clientMutationId: createClientMutationId7(),
          profileId: recruitProfileId,
          source: "website",
          talentPoolId
        }
      },
      onCompleted: () => {
        redirectToTalentPools();
      },
      onError: (error) => {
        setErrors(error.message);
      }
    });
  };
  return /* @__PURE__ */ jsx74(ErrorBoundary25, { FallbackComponent: ErrorBoundaryFallback25, children: /* @__PURE__ */ jsx74("div", { className: "mx-auto max-w-2xl py-10", children: /* @__PURE__ */ jsx74(Card7, { children: /* @__PURE__ */ jsxs45("div", { className: "flex flex-col gap-5", children: [
    /* @__PURE__ */ jsxs45("h1", { className: "text-2xl", children: [
      "Join the ",
      talentPool.name,
      " talent pool"
    ] }),
    /* @__PURE__ */ jsx74("div", { children: /* @__PURE__ */ jsx74("p", { children: talentPool.description }) }),
    /* @__PURE__ */ jsxs45("div", { className: "flex w-full flex-col justify-center", children: [
      /* @__PURE__ */ jsx74(
        Button16,
        {
          color: "primary",
          size: Size7.xl,
          onClick: handleJoinTalentPool,
          children: "Join"
        }
      ),
      /* @__PURE__ */ jsx74(Button16, { size: Size7.xl, onClick: redirectToTalentPools, children: "Cancel" })
    ] }),
    errors && /* @__PURE__ */ jsxs45(Error4, { className: "self-center rounded-2xl bg-red-400 px-2 py-1 text-white", children: [
      "This is a Private Talent Pool. Contact the",
      " ",
      /* @__PURE__ */ jsx74("a", { href: "mailto:support@myn.co.uk", children: "Talent Pool Administrator" }),
      " ",
      "for further details."
    ] })
  ] }) }) }) });
}
TalentPoolInvite.query = TalentPoolInviteQuery_graphql_default;
TalentPoolInvite.mutations = {
  joinTalentPool: TalentPoolInviteMutation_graphql_default
};

// src/secure/inbox/CandidatesInboxLayout.tsx
import {
  ShareIcon as ShareIcon2,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightIcon2,
  CalendarIcon as CalendarIcon2
} from "@heroicons/react/24/outline";
import { ErrorBoundary as ErrorBoundary27 } from "react-error-boundary";
import { Navigate as Navigate8, Route as Route21, Routes as Routes16 } from "react-router-dom";
import { ErrorBoundaryFallback as ErrorBoundaryFallback27 } from "app-core";
import {
  Breadcrumbs as Breadcrumbs4,
  MobileHeader as MobileHeader5,
  SectionedLayout as SectionedLayout5
} from "shared-ui";
import { GlobalChat } from "feature-chat";

// src/secure/interviews/pages/InterviewPage.tsx
import { Suspense as Suspense8 } from "react";
import { useParams as useParams11 } from "react-router-dom";
import { EdSkeleton as EdSkeleton9 } from "shared-ui";
import { InterviewContainer } from "feature-recruit";
import { jsx as jsx75 } from "react/jsx-runtime";
var InterviewPage = () => {
  const { interviewId } = useParams11();
  return /* @__PURE__ */ jsx75(Suspense8, { fallback: /* @__PURE__ */ jsx75(EdSkeleton9, {}), children: /* @__PURE__ */ jsx75(
    InterviewContainer,
    {
      showMobileNavigation: true,
      interviewId,
      showExpand: false
    }
  ) });
};
var InterviewPage_default = InterviewPage;

// src/secure/interviews/InterviewsLayout.tsx
import { Routes as Routes15, Route as Route20 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary26 } from "react-error-boundary";
import { ErrorContainer as ErrorContainer2 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback26 } from "app-core";
import { InterviewsContainer } from "feature-recruit";
import { jsx as jsx76, jsxs as jsxs46 } from "react/jsx-runtime";
var InterviewsLayout = ({ candidateId }) => {
  return /* @__PURE__ */ jsx76(ErrorBoundary26, { FallbackComponent: ErrorBoundaryFallback26, children: /* @__PURE__ */ jsxs46(Routes15, { children: [
    /* @__PURE__ */ jsx76(
      Route20,
      {
        path: "*",
        element: /* @__PURE__ */ jsx76(InterviewsContainer, { candidateId }),
        errorElement: /* @__PURE__ */ jsx76(ErrorContainer2, {})
      }
    ),
    /* @__PURE__ */ jsx76(
      Route20,
      {
        path: `interview/:interviewId/*`,
        element: /* @__PURE__ */ jsx76(InterviewPage_default, {}),
        errorElement: /* @__PURE__ */ jsx76(ErrorContainer2, {})
      }
    )
  ] }) });
};

// src/secure/inbox/CandidatesInboxLayout.tsx
import { TalentPoolCandidateInvitesList } from "feature-recruit";
import { jsx as jsx77, jsxs as jsxs47 } from "react/jsx-runtime";
var ItemLayout4 = ({ children, links }) => {
  return /* @__PURE__ */ jsxs47("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx77("div", { className: "hidden border-b md:flex", children: /* @__PURE__ */ jsx77(Breadcrumbs4, { homeText: "Inbox", homeHref: "..", links }) }),
    /* @__PURE__ */ jsx77("div", { children })
  ] });
};
var InboxLayout = ({ candidateId }) => {
  return /* @__PURE__ */ jsx77(
    SectionedLayout5,
    {
      title: "Inbox",
      sections: [
        {
          key: "application-chat",
          listTitle: "Application Chat",
          itemTitle: "Application Chat",
          icon: ChatBubbleLeftRightIcon2,
          iconBackground: "bg-gray-50",
          iconForeground: "text-gray-700",
          element: /* @__PURE__ */ jsx77(GlobalChat, { candidateId })
        },
        {
          key: "interview-invitations",
          listTitle: "Interview Invitations",
          itemTitle: "Interview Invitations",
          icon: CalendarIcon2,
          iconBackground: "bg-gray-50",
          iconForeground: "text-gray-700",
          element: /* @__PURE__ */ jsx77(InterviewsLayout, { candidateId })
        },
        {
          key: "talent-pool-invitations",
          listTitle: "Talent Pool Invitations",
          itemTitle: "Talent Pool Invitations",
          icon: ShareIcon2,
          iconBackground: "bg-gray-50",
          iconForeground: "text-gray-700",
          element: /* @__PURE__ */ jsx77(TalentPoolCandidateInvitesList, { candidateId })
        }
      ]
    }
  );
};
var CandidatesInboxLayout = ({
  candidateId
}) => {
  return /* @__PURE__ */ jsx77(ErrorBoundary27, { FallbackComponent: ErrorBoundaryFallback27, children: /* @__PURE__ */ jsx77(Routes16, { children: /* @__PURE__ */ jsxs47(Route21, { path: "/", element: /* @__PURE__ */ jsx77(InboxLayout, { candidateId }), children: [
    /* @__PURE__ */ jsx77(
      Route21,
      {
        path: "application-chat/*",
        element: /* @__PURE__ */ jsxs47(ItemLayout4, { links: [{ name: "Application Chats", href: "" }], children: [
          /* @__PURE__ */ jsx77(
            MobileHeader5,
            {
              title: /* @__PURE__ */ jsx77("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Application Chat" }),
              showBackButton: true
            }
          ),
          /* @__PURE__ */ jsx77(GlobalChat, { candidateId })
        ] })
      }
    ),
    /* @__PURE__ */ jsx77(
      Route21,
      {
        path: "interview-invitations/*",
        element: /* @__PURE__ */ jsxs47(ItemLayout4, { links: [{ name: "Interview Invitations", href: "" }], children: [
          /* @__PURE__ */ jsx77(
            MobileHeader5,
            {
              title: /* @__PURE__ */ jsx77("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Interview Invitations" }),
              showBackButton: true
            }
          ),
          /* @__PURE__ */ jsx77(InterviewsLayout, { candidateId })
        ] })
      }
    ),
    /* @__PURE__ */ jsx77(
      Route21,
      {
        path: "talent-pool-invitations/*",
        element: /* @__PURE__ */ jsxs47(
          ItemLayout4,
          {
            links: [{ name: "Talent Pool Invitations", href: "" }],
            children: [
              /* @__PURE__ */ jsx77(
                MobileHeader5,
                {
                  title: /* @__PURE__ */ jsx77("h1", { className: "text-center font-bold md:text-right xl:text-left", children: "Talent Pool Invitations" }),
                  showBackButton: true
                }
              ),
              /* @__PURE__ */ jsx77(TalentPoolCandidateInvitesList, { candidateId })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsx77(Route21, { path: "*", element: /* @__PURE__ */ jsx77(Navigate8, { to: "./dashboard" }) })
  ] }) }) });
};

// src/secure/AppCandidatesSecureLayout.tsx
import { jsx as jsx78, jsxs as jsxs48 } from "react/jsx-runtime";
var AppErrorPage = () => {
  return /* @__PURE__ */ jsx78("div", { children: "AppErrorPage" });
};
var queryDef7 = AppCandidatesSecureLayoutQuery_graphql_default;
var AppPageComponent = ({
  userId
}) => {
  const isLocal = window.location.href.includes("localhost");
  const data = useLazyLoadQuery11(
    queryDef7,
    {
      candidateId: userId
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const sectionHasTasks = (section) => data.globalTasks.reduce((a, c) => {
    if (c.type === section) {
      return c.tasks.length > 0;
    }
    return a;
  }, false);
  const location = useLocation4();
  const sidebarNavigation = [
    createLinkState(
      location,
      "Profile",
      `profile`,
      () => /* @__PURE__ */ jsx78(
        "img",
        {
          className: "inline-block h-6 w-6 rounded-full bg-gray-100 ring-2 ring-white",
          src: data.account?.profileThumbNailImageUrl || isLocal ? "/assets/myn/profile.png" : "/portal/assets/myn/profile.png",
          alt: ""
        }
      ),
      sectionHasTasks("Profile")
    ),
    createLinkState(
      location,
      "Applications",
      `applications`,
      InboxArrowDownIcon,
      sectionHasTasks("Applications")
    ),
    createLinkState(location, "Recommendations", `jobs`, RectangleStackIcon),
    createLinkState(location, "Inbox", `inbox`, InboxIcon),
    createLinkState(location, "Tasks", `tasks`, BookmarkIcon),
    createLinkState(location, "Finance", `finance`, BanknotesIcon3),
    createLinkState(location, "Benefits", `benefits`, BookOpenIcon),
    createLinkState(location, "Support", `support`, QuestionMarkCircleIcon),
    createLinkState(
      location,
      "Account",
      `account`,
      HeartIcon2,
      sectionHasTasks("Account")
    )
  ];
  const trayNavigation = [
    createLinkState(
      location,
      "Applications",
      `/candidates/app/applications`,
      InboxArrowDownIcon
    ),
    createLinkState(
      location,
      "Inbox",
      `/candidates/app/inbox`,
      InboxIcon
    ),
    createLinkState(location, "Tasks", `/candidates/app/tasks`, BookmarkIcon),
    createLinkState(
      location,
      "Recommended",
      `/candidates/app/jobs/recommendations`,
      RectangleStackIcon
    )
  ];
  const auth = useAuth2();
  const onSignOut = useCallback13(async () => {
    await auth?.signOutRedirect();
  }, [auth]);
  const userNavigation = [
    { name: "Your Profile", to: "/candidates/app/account", icon: UserIcon },
    {
      name: "Sign out",
      to: ".",
      icon: ArrowRightOnRectangleIcon,
      onClick: onSignOut
    }
  ];
  const { account, profile } = data;
  if (!account || !profile) {
    window.location.reload();
    return /* @__PURE__ */ jsx78("div", { children: "No Account Data Found, Please Wait...." });
  }
  if (!candidateAccountHasCompletedRequiredSetup(account)) {
    return /* @__PURE__ */ jsxs48("div", { className: "flex flex-col py-12 sm:px-6 lg:px-8", children: [
      /* @__PURE__ */ jsx78("div", { className: "mb-8", children: /* @__PURE__ */ jsx78(AppLogoContainer, { size: Size8.xl }) }),
      /* @__PURE__ */ jsx78(CandidateAccountSetupContainer, { fragmentRef: account })
    ] });
  }
  return /* @__PURE__ */ jsx78(ErrorBoundary28, { fallback: /* @__PURE__ */ jsx78(AppErrorPage, {}), children: /* @__PURE__ */ jsx78(
    CandidateShell,
    {
      accountLink: "/candidates/app/account",
      sidebarNavigation,
      userNavigation,
      trayNavigation,
      accountInfo: {
        firstName: account.firstName,
        lastName: account.lastName,
        profileThumbNailImageUrl: account.profileThumbNailImageUrl
      },
      children: /* @__PURE__ */ jsxs48(Routes17, { children: [
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "account/*",
            element: /* @__PURE__ */ jsx78(AccountLayout, { fragmentRef: data })
          }
        ),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "profile/*",
            element: /* @__PURE__ */ jsx78(
              ProfilePage,
              {
                candidateId: account.accountId,
                candidateEmail: account.email
              }
            )
          }
        ),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "applications/*",
            element: /* @__PURE__ */ jsx78(
              ApplicationsLayout,
              {
                candidateId: account.accountId,
                defaultPath: "info"
              }
            ),
            errorElement: /* @__PURE__ */ jsx78(ErrorContainer3, {})
          }
        ),
        /* @__PURE__ */ jsx78(Route22, { path: "compliance/*", element: /* @__PURE__ */ jsx78(ComplianceLayout, {}) }),
        /* @__PURE__ */ jsx78(Route22, { path: "documents/*", element: /* @__PURE__ */ jsx78(Routes8, {}) }),
        /* @__PURE__ */ jsx78(Route22, { path: "contracts/*", element: /* @__PURE__ */ jsx78(Routes7, {}) }),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "talent-pool/:slug",
            element: /* @__PURE__ */ jsx78(TalentPoolSignUp, { fragmentRef: data.profile })
          }
        ),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "talent-pool-invite/:inviteId",
            element: /* @__PURE__ */ jsx78(TalentPoolInvite, { fragmentRef: data.profile })
          }
        ),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "talentpoolexternalinvite/:slug",
            element: /* @__PURE__ */ jsx78(TalentPoolExternalSignUp, { fragmentRef: data.profile })
          }
        ),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "jobs/*",
            element: /* @__PURE__ */ jsx78(JobsLayout, { candidateId: account.accountId })
          }
        ),
        /* @__PURE__ */ jsx78(Route22, { path: "recruit/*", element: /* @__PURE__ */ jsx78(RecruitLayout, {}) }),
        /* @__PURE__ */ jsx78(Route22, { path: "vacancies/*", element: /* @__PURE__ */ jsx78(VacanciesLayout, {}) }),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "tasks/*",
            element: /* @__PURE__ */ jsx78(
              ApplicationsLayout,
              {
                title: "Tasks",
                candidateId: account.accountId,
                defaultPath: "tasks"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx78(Route22, { path: "support/*", element: /* @__PURE__ */ jsx78(CandidatesSupportLayout, {}) }),
        /* @__PURE__ */ jsx78(Route22, { path: "benefits/*", element: /* @__PURE__ */ jsx78(CandidatesBenefitsLayout, {}) }),
        /* @__PURE__ */ jsx78(Route22, { path: "finance/*", element: /* @__PURE__ */ jsx78(CandidatesFinanceLayout, {}) }),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "inbox/*",
            element: /* @__PURE__ */ jsx78(CandidatesInboxLayout, { candidateId: account.accountId })
          }
        ),
        /* @__PURE__ */ jsx78(
          Route22,
          {
            path: "*",
            element: /* @__PURE__ */ jsx78(Navigate9, { to: "/candidates/app/profile/summary", replace: true })
          }
        )
      ] })
    }
  ) });
};
var withUserId = (Component) => {
  return function WrappedComponent(props) {
    const session = useUserSessionContext3();
    if (session == null) {
      return /* @__PURE__ */ jsx78(EdSkeleton10, {});
    }
    return createElement(Component, { ...props, userId: session.userId });
  };
};
var AppCandidatesSecureLayout = withUserId(AppPageComponent);

// src/AppCandidates.tsx
import { jsx as jsx79, jsxs as jsxs49 } from "react/jsx-runtime";
var AppCandidates = () => {
  const oidc = useOIDC8();
  const navigate = useNavigate18();
  const authConfig = useAuthConfig();
  useEffect6(() => {
    let isMounted = true;
    const app = {
      tenant: Tenant3.Contractor
    };
    setAppContext(app);
    async function checkSessionAsync() {
      oidc.setTenant(Tenant3.Contractor);
      await oidc.checkSession();
    }
    checkSessionAsync();
    return () => {
      isMounted = false;
    };
  }, [oidc]);
  return /* @__PURE__ */ jsx79(AuthProvider3, { ...authConfig, children: /* @__PURE__ */ jsx79("div", { className: "flex min-h-screen flex-col bg-white", children: /* @__PURE__ */ jsx79(Suspense9, { fallback: /* @__PURE__ */ jsx79(Loading, { label: "Almost there..." }), children: /* @__PURE__ */ jsxs49(Routes18, { children: [
    /* @__PURE__ */ jsx79(
      Route23,
      {
        errorElement: /* @__PURE__ */ jsx79(ErrorContainer4, {}),
        path: "signin-oidc/*",
        element: /* @__PURE__ */ jsx79(SignInLoader, {})
      }
    ),
    /* @__PURE__ */ jsx79(
      Route23,
      {
        path: "signout-oidc",
        errorElement: /* @__PURE__ */ jsx79(ErrorContainer4, {}),
        element: /* @__PURE__ */ jsx79(Navigate10, { replace: true, to: "/candidates" })
      }
    ),
    /* @__PURE__ */ jsx79(Route23, { path: "nav/*", element: /* @__PURE__ */ jsx79(NavigatePage, {}) }),
    /* @__PURE__ */ jsx79(
      Route23,
      {
        path: "signup",
        errorElement: /* @__PURE__ */ jsx79(ErrorContainer4, {}),
        element: /* @__PURE__ */ jsx79(Navigate10, { replace: true, to: "/candidates/pub/signup" })
      }
    ),
    /* @__PURE__ */ jsx79(
      Route23,
      {
        path: "pub/*",
        errorElement: /* @__PURE__ */ jsx79(ErrorContainer4, {}),
        element: /* @__PURE__ */ jsx79(AppCandidatesPublicLayout, {})
      }
    ),
    /* @__PURE__ */ jsx79(
      Route23,
      {
        path: "app/*",
        errorElement: /* @__PURE__ */ jsx79(ErrorContainer4, {}),
        element: /* @__PURE__ */ jsx79(AuthGuard, { ...authConfig, children: /* @__PURE__ */ jsx79(AppCandidatesSecureLayout, {}) })
      }
    ),
    /* @__PURE__ */ jsx79(Route23, { path: "*", element: /* @__PURE__ */ jsx79(Navigate10, { replace: true, to: "/candidates" }) }),
    /* @__PURE__ */ jsx79(
      Route23,
      {
        path: "debugger/*",
        errorElement: /* @__PURE__ */ jsx79(ErrorContainer4, {}),
        element: /* @__PURE__ */ jsx79(
          DebuggerConfig2,
          {
            onDone: () => {
              navigate("app");
            }
          }
        )
      }
    ),
    /* @__PURE__ */ jsx79(
      Route23,
      {
        path: "/",
        errorElement: /* @__PURE__ */ jsx79(ErrorContainer4, {}),
        element: /* @__PURE__ */ jsx79(HomePage, {})
      }
    )
  ] }) }) }) });
};
export {
  AccountGeneralPageWrapper as AccountGeneralPage,
  AccountGeneralPageComponent,
  AccountLayout,
  AppCandidates,
  AppCandidatesSecureLayout,
  ApplicationPage,
  ApplicationsLayout,
  AvailabilityEditor,
  AvailabilityLayout,
  CandidateShellHeader,
  CandidateSignUpForm,
  CandidateSignUpFormComponent,
  CandidateSignUpFormWithTalentInviteCode,
  CandidateSignUpFormWithTalentPool,
  CandidatesBenefitsLayout,
  CandidatesFinanceLayout,
  CandidatesSupportLayout,
  ComplianceLayout,
  CompliancePageComponent,
  CompliancePageLayout,
  ContactDetailRoutes,
  ContactDetailsEditor,
  ContactDetailsEmailContainer,
  ContactDetailsNameContainer,
  Routes7 as ContractRoutes,
  Contracts,
  DebuggerPage,
  Routes8 as DocumentRoutes,
  Documents,
  DocumentsComponent,
  ErrorPage,
  GDPR,
  GroupedTasksContainer,
  JobsLayout,
  Legal,
  Routes12 as LegalRoutes,
  Linkable,
  LocationRoutes,
  Locations,
  NEXT_LOCATION_KEY,
  PasswordPageWrapper as PasswordPage,
  PasswordPageComponent,
  ProfileLayout,
  ProfilePage,
  RateEditor,
  RateRoutes,
  RecommendationsLayout,
  RecruitLayout,
  RightToAddPage,
  RightToEditPage,
  RightToWorkListPage,
  RightToWorkRoutes,
  SectionNavigation,
  SignInLoader,
  SignOutPage,
  Signature,
  TalentPoolSignUp,
  TalentPoolSignUpComponent,
  TalentPoolsLayout,
  TasksLayout,
  TermsAndConditions,
  VacanciesLayout,
  VacancyApplyPage,
  VerifyEmployerPageComponent,
  VerifyEmployerPageLayout,
  VerifyPageComponent,
  VerifyPageLayout,
  availabilityInputSchema,
  fromDateInputSchema,
  immediatelyInputSchema,
  jobSearchStatusSchema,
  noticePeriodInputSchema,
  noticeTimeframeSchema,
  recruitCandidateAvailabilityUpdate2InputSchema,
  useConfig
};
//# sourceMappingURL=index.mjs.map